(function () {
  'use strict';

  var BUILD = 'V2.34-MINI-CART-2026-09-19';
  var PILOT_MARKER = 'V2.19.3';
  var LEGACY_MARKER = 'V2.19.2';
  /* Admin-reference label only. Runtime safety is proven by the economic result,
   * so renaming the automatic discount cannot strand a genuinely free carrier. */
  var DISCOUNT_TITLE = 'Complimentary shade carrier';
  var DRAWER_SELECTOR = '#CartDrawer';
  var FORM_SELECTOR = '#CartDrawerForm, #CartPageForm';
  var OFFER_SELECTOR = '[data-mekhann-carrier-offer]';
  var PILOT_LINE_SELECTOR = '[data-mekhann-carrier-line]';
  var ACTIVE_CLASS = 'mekhann-carrier-pilot-active';
  var GUARD_CLASS = 'mekhann-carrier-pilot-guarded';
  var MAX_RECONCILE_REMOVALS = 12;

  var addInFlight = false;
  var addOperation = null;
  var removeOperation = null;
  var unverifiedMutation = false;
  var pilotLinePresent = false;
  var checkoutInFlight = false;
  var checkoutBypass = false;
  var reconcileInFlight = null;
  var reconcileShared = null;
  var reconcileStamp = '';
  var reconcileStartedSignalGeneration = null;
  var reconcileGuard = null;
  var ownedMutation = null;
  var pendingRemoveIntent = null;
  var ownedParentUncertain = false;
  var ownedQuantityUncertain = false;
  var ownedSequence = 0;
  var REMOVE_PENDING_KEY = 'mekhann:carrier:unresolved-removal:v1';
  var removalJournal = null, removalJournalRestored = false, removalJournalFault = false, removalRecovery = null;
  var activeRender = null;
  var renderVerificationPending = false;
  var lastRenderReceipt = null;
  var cartObservers = [];
  var parentRemoveLocks = new WeakMap();
  var checkoutVerificationLocks = new WeakMap();
  var checkoutPendingLocks = new WeakMap();
  var reconcileTimer = null;
  var reconcileAfterMutation = false;
  var cartMutationGeneration = 0;
  var cartSignalGeneration = 0;
  var pendingAddToken = '';
  var pendingAddAcknowledged = false;
  var pendingAddQuantity = 0;
  var pendingAddProtection = null;
  var pendingAddRollback = false;
  var pendingPdpUncertain = false;
  var PDP_PENDING_KEY = 'mekhann:carrier:unresolved-pdp:v1';
  var NATIVE_PENDING_KEY = 'mekhann:carrier:unresolved-native-batch:v1';
  var NATIVE_BATCH_MARKER = 'V1';
  var nativeBatchRecord = null;
  var nativeBatchFault = false;
  var nativeAbandonedTokens = [];
  var nativeResolvedTokens = [];
  var nativeRecoveryOperation = null;
  var nativeRecoveryMessage = '';
  var NATIVE_FAULT_MESSAGE = 'We could not check your previous addition. Please contact us before continuing.';
  var nativeRecoveryNeedsRefresh = false;
  var NATIVE_REFRESH_MESSAGE = 'Your bag has changed. Refresh it to check your previous addition.';
  var NATIVE_FORM_PENDING_KEY = 'mekhann:add-to-bag:unresolved:v226';
  var pendingPdpRecord = null;
  var pendingPdpIdentityConfirmed = false;
  var restoredPdpPending = false;
  var pdpRecoveryFault = false;
  var pdpOperation = null;
  var pendingReductionProtection = null;
  var externalMutationGeneration = 0;
  var externalMutationPending = false;
  var externalVerificationInFlight = false;
  // Each external start needs its own complete. Verification is a separate
  // owner: a later completion waits for the current read, never disappears.
  var externalActiveWrites = 0;
  var externalWriterCounts = Object.create(null);
  var externalMutationUncertain = false;
  var externalVerificationOwner = null;
  var externalVerificationDemand = false;
  // Shopify automatic discount eligibility must be All customers for this
  // guest-checkout pilot. Theme code never creates or overrides the discount.
  var offerFeedback = {};
  var offerPreferences = { expanded: false, selection: '' };
  var preferenceKey = 'mekhann-carrier-inline-v223';
  var extrasOperation = Promise.resolve();
  var extrasPending = 0;
  var extrasError = '';
  var cartExtras = null;
  var checkoutIntent = null;

  var advisorReturn = null;
  var inlineReturnFocus = null;
  var CARRIER_PREFERENCE_ATTRIBUTE = '_mekhann_carrier_preferences';
  var observedCarrierPreferences = Object.create(null);
  var observedCarrierCart = null;
  var followRetryOperation = null;


  if (window.__mekhannMiniCartCarrierPilotV2193) return;
  window.__mekhannMiniCartCarrierPilotV2193 = true;

  function route(name, suffix) {
    if (window.theme && window.theme.routes && window.theme.routes[name]) {
      return window.theme.routes[name];
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + suffix;
  }

  function isPilotEnvironment() {
    // The installed theme owns this feature. No customer or test-theme identity.
    return Boolean(window.Shopify && window.Shopify.theme);
  }

  function normaliseProperties(properties) {
    return properties && typeof properties === 'object' ? properties : {};
  }

  function numericId(value) {
    return Number(value || 0);
  }

  function cartGroups() {
    return window.theme && window.theme.mekhannCartGroups;
  }

  function groupBusy(ownerToken) {
    var groups = cartGroups();
    return Boolean((ownedMutation && ownerToken !== ownedMutation) || (groups && groups.pending()) || document.querySelector('#CartDrawerForm[aria-busy="true"], #CartPageForm[aria-busy="true"]'));
  }

  function generationStamp() {
    return cartMutationGeneration + ':' + cartSignalGeneration + ':' + externalMutationGeneration;
  }

  function reconciliationStamp(signalGeneration) {
    var signal = signalGeneration == null ? cartSignalGeneration : signalGeneration;
    return cartMutationGeneration + ':' + signal + ':' + externalMutationGeneration + ':' + pendingAddToken + ':' + pendingAddQuantity + ':' +
      (nativeBatchRecord ? nativeBatchRecord.token : '') + ':' + nativeBatchFault + ':' +
      Boolean(pendingReductionProtection) + ':' + Boolean(unverifiedMutation) + ':' +
      Boolean(ownedParentUncertain) + ':' + (cartExtras ? cartExtras.revision() : 0);
  }

  function ownedCurrent(token) {
    return Boolean(token && ownedMutation === token && !token.invalid &&
      token.external === externalMutationGeneration && !externalMutationPending);
  }

  function receiptCurrent(receipt) {
    return Boolean(receipt && receipt === lastRenderReceipt && receipt.stamp === generationStamp() &&
      !nativeBatchRecord && !nativeBatchFault &&
      !ownedMutation && !addInFlight && !addOperation && !removeOperation && !reconcileInFlight &&
      !unverifiedMutation && !pendingAddToken && !externalMutationPending && !externalVerificationInFlight &&
      !extrasPending && !extrasError && (!cartExtras || receipt.extrasRevision === cartExtras.revision()));
  }

  function storedParentGroup(child) {
    var stored = normaliseProperties(child && child.properties)._mekhann_parent_group;
    if (!stored || typeof stored !== 'string') return null;
    try {
      var descriptor = JSON.parse(stored);
      return descriptor && descriptor.variantId > 0 && Array.isArray(descriptor.properties)
        ? descriptor : null;
    } catch (error) { return null; }
  }

  function isKnownPilotLine(item) {
    var properties = normaliseProperties(item && item.properties);
    if (properties._mekhann_addon_type !== 'shade_carrier') return false;

    return properties._mekhann_carrier_pilot === PILOT_MARKER ||
      properties._mekhann_test_fixture === LEGACY_MARKER;
  }

  function isCurrentPilotLine(item) {
    var properties = normaliseProperties(item && item.properties);
    return properties._mekhann_addon_type === 'shade_carrier' &&
      properties._mekhann_carrier_pilot === PILOT_MARKER;
  }

  function isCarrierVariant(item) {
    var type = String(item && item.product_type || '').toLowerCase().replace(/[\s_-]+/g, '');
    return isKnownPilotLine(item) || type === 'shadecarriers' || type === 'shadecarrier';
  }

  function mappedCarrier(cart, parentVariantId) {
    var mappings = cart && cart._mekhann_carrier_mappings;
    return numericId(mappings && mappings[String(parentVariantId)]);
  }

  function carrierOptions(cart, parentVariantId) {
    var options = cart && cart._mekhann_carrier_options;
    return options && options[String(parentVariantId)] || [];
  }

  function carrierAllowed(cart, parentVariantId, carrierVariantId, includeLegacy) {
    var id = numericId(carrierVariantId);
    return id > 0 && (carrierOptions(cart, parentVariantId).some(function (option) { return option.id === id; }) ||
      includeLegacy && mappedCarrier(cart, parentVariantId) === id);
  }

  function preferredCarrier(cart, parent) {
    var preference = carrierPreference(cart, parent);
    return numericId(preference && preference.chosenCarrierVariantId) || mappedCarrier(cart, parent.variant_id);
  }

  function selectedCarrierVariantId(cart, parent) {
    var ids = linkedCarriers(cart, parent).map(function (child) { return numericId(child.variant_id); });
    if (ids.some(function (id) { return id !== ids[0]; })) throw new Error('Please choose a fitting to update this lampshade selection.');
    return ids[0] || 0;
  }

  function hasAnyCarrierVariant(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(isCarrierVariant));
  }

  function hasSupportedDiscountEvidence(application) {
    if (!application) return false;
    if (application.type === 'automatic') return true;
    // This store omits type in BOTH Ajax and Liquid. A blank type is not
    // proof of "automatic". Accept it only after mergeDiscountTypes matched
    // the server cart/line/allocation evidence; full monetary proof is still
    // required below. Explicit nonautomatic types remain unsupported.
    return application.type === '' && application._mekhann_type_source === 'liquid';
  }

  function hasProvenFullDiscount(item) {
    if (!item || !Array.isArray(item.line_level_discount_allocations)) return false;
    if (item.line_level_discount_allocations.length !== 1) return false;

    var allocation = item.line_level_discount_allocations[0] || {};
    var application = allocation.discount_application || {};

    return sameMoney(allocation.amount, item.original_line_price) &&
      hasSupportedDiscountEvidence(application);
  }

  function discountAllocations(item) {
    if (!item || !Array.isArray(item.line_level_discount_allocations)) return [];

    return item.line_level_discount_allocations.map(function (allocation) {
      var application = allocation && allocation.discount_application || {};
      return {
        amount: Number(allocation && allocation.amount || 0),
        type: application.type || '',
        title: application.title || '',
        typeSource: application._mekhann_type_source || 'ajax',
        ajaxType: application._mekhann_type_source === 'liquid'
          ? '' : (application.type || '')
      };
    });
  }

  function isComplimentaryLine(item) {
    return Boolean(item) &&
      positiveQuantity(item.quantity) &&
      validMoney(item.original_line_price) && item.original_line_price > 0 &&
      item.final_line_price === 0 &&
      hasProvenFullDiscount(item);
  }

  function buildAddPayload(data, token) {
    var parentLabel = data.parentTitle;
    if (data.parentVariantTitle && data.parentVariantTitle !== 'Default Title') {
      parentLabel += ' · ' + data.parentVariantTitle;
    }

    return {
      items: [{
        id: data.carrierVariantId,
        quantity: positiveQuantity(data.quantity) ? Number(data.quantity) : 1,
        properties: {
          'For': parentLabel,
          '_mekhann_addon_type': 'shade_carrier',
          '_mekhann_carrier_pilot': PILOT_MARKER,
          '_mekhann_parent_variant_id': String(data.parentVariantId),
          '_mekhann_parent_line_key': data.parentLineKey,
          '_mekhann_parent_group': data.parentGroup || '',
          '_mekhann_parent_selection_key': data.parentSelectionKey || '',
          '_mekhann_pilot_token': token
        }
      }]
    };
  }

  function nativeParentKey(item) {
    var relation = item && item.parent_relationship;
    return relation && (relation.parent_key || relation.parent && relation.parent.key) || '';
  }

  function findParent(cart, parentKey) {
    if (!cart || !Array.isArray(cart.items) || !parentKey) return null;
    return cart.items.find(function (item) {
      return item.key === parentKey && !nativeParentKey(item);
    }) || null;
  }

  function findUniquePilotParent(cart, child) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var groups = cartGroups();
    var descriptor = storedParentGroup(child);
    // A disappearing R3 key contains no evidence of the old configuration.
    // Never reattach an old carrier by variant alone.
    if (!groups || !descriptor || nativeParentKey(child)) return null;
    var declaredId = numericId(normaliseProperties(child && child.properties)._mekhann_parent_variant_id);
    var parents = cart.items.filter(function (item) {
      return declaredId > 0 && numericId(item.variant_id) === declaredId &&
        carrierAllowed(cart, declaredId, child && child.variant_id, true) &&
        Number(item.quantity) >= 1 && !nativeParentKey(item) &&
        !isKnownPilotLine(item) && groups.sameSelection(item, descriptor);
    });

    return parents.length ? parents[0] : null;
  }

  function groupedParentProperties(properties) {
    if (!nativeObject(properties) || Object.keys(properties).length !== 3 || properties._mekhann_grouped_parent !== 'V1') return false;
    var id = properties._mekhann_grouped_carrier_id;
    return typeof id === 'string' && /^[1-9][0-9]*$/.test(id) && Number.isSafeInteger(Number(id)) &&
      nativeGroupProperties({ _mekhann_fitting_group: properties._mekhann_fitting_group });
  }
  function isGroupedChild(item) {
    var properties = normaliseProperties(item && item.properties);
    return Object.prototype.hasOwnProperty.call(properties, '_mekhann_grouped_batch') ||
      Object.prototype.hasOwnProperty.call(properties, '_mekhann_fitting_group');
  }
  function groupedChildParent(cart, child) {
    var props = normaliseProperties(child && child.properties), descriptor = storedParentGroup(child);
    if (!cart || !Array.isArray(cart.items) || !cartGroups() || !isCurrentPilotLine(child) ||
        props._mekhann_grouped_batch !== 'V1' || nativeParentKey(child) || Object.prototype.hasOwnProperty.call(props, '_mekhann_parent_line_key') ||
        Object.prototype.hasOwnProperty.call(props, '_mekhann_parent_selection_key') || Object.prototype.hasOwnProperty.call(props, '_mekhann_native_batch') || !props._mekhann_pilot_token || !descriptor) return null;
    var matches = cart.items.filter(function (parent) {
      var properties = parent.properties || {};
      return !isCarrierVariant(parent) && !nativeParentKey(parent) && groupedParentProperties(properties) &&
        properties._mekhann_fitting_group === props._mekhann_fitting_group &&
        Number(properties._mekhann_grouped_carrier_id) === numericId(child.variant_id) &&
        numericId(parent.variant_id) === numericId(props._mekhann_parent_variant_id) &&
        cartGroups().sameSelection(parent, descriptor);
    });
    return matches.length === 1 ? matches[0] : null;
  }
  function actualParentKey(item) {
    if (!item) return '';
    if (nativeParentKey(item)) return nativeParentKey(item);
    return normaliseProperties(item.properties)._mekhann_parent_line_key || '';
  }

  function resolveParent(cart, item) {
    if (isGroupedChild(item)) return groupedChildParent(cart, item);
    var linkedParent = findParent(cart, actualParentKey(item));
    var stored = normaliseProperties(item && item.properties)._mekhann_parent_group;
    if (linkedParent && stored) {
      var descriptor = storedParentGroup(item);
      var groups = cartGroups();
      if (!descriptor || !groups || !groups.sameSelection(linkedParent, descriptor)) return null;
    }
    return linkedParent || findUniquePilotParent(cart, item);
  }

  function positiveQuantity(value) {
    return Number.isSafeInteger(Number(value)) && Number(value) > 0;
  }

  function parentQuantity(cart, parent, validation) {
    var groups = cartGroups();
    var members = validation ? validation.selectionMembers(parent) : groups ? groups.selectionMembers(cart, parent) : [parent];
    return members.reduce(function (quantity, member) {
      return quantity + (positiveQuantity(member.quantity) ? Number(member.quantity) : 0);
    }, 0);
  }

  function linkedCarriers(cart, parent, validation) {
    if (!cart || !Array.isArray(cart.items) || !parent) return [];
    var groups = cartGroups();
    return cart.items.filter(function (child) {
      if (!isCurrentPilotLine(child)) return false;
      var linked = validation ? validation.resolveParent(child) : resolveParent(cart, child);
      return linked && (groups ? groups.sameSelection(linked, parent) : linked.key === parent.key);
    });
  }

  function carrierQuantityForParent(cart, parent) {
    return linkedCarriers(cart, parent).reduce(function (quantity, child) {
      return quantity + (positiveQuantity(child.quantity) ? Number(child.quantity) : 0);
    }, 0);
  }

  // Cart attributes survive a missing child line and movement between surfaces.
  // Identity excludes physical keys and discount prices, matching selectionMembers.
  function carrierPreferences(cart) {
    var selections = Object.create(null);
    try {
      var saved = JSON.parse(String((cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] || 'null'));
      if (saved && (saved.version !== 1 || !saved.selections || typeof saved.selections !== 'object' || Array.isArray(saved.selections))) return selections;
      if (saved && saved.version === 1 && saved.selections && typeof saved.selections === 'object' && !Array.isArray(saved.selections)) selections = saved.selections;
    } catch (error) { return selections; }
    // New purchases carry their initial Follow intent on the parent itself.
    // Explicit Off/custom/suspended entries always win, including after a
    // partial batch is compensated. Child presence never creates consent.
    var groups = cartGroups();
    if (groups && cart && Array.isArray(cart.items)) cart.items.forEach(function (parent) {
      var props = parent.properties || {};
      if (!groupedParentProperties(props) || isCarrierVariant(parent) || nativeParentKey(parent) || !positiveQuantity(parent.quantity)) return;
      var selected = Number(props._mekhann_grouped_carrier_id), key = groups.selectionSignature(parent);
      if (Object.prototype.hasOwnProperty.call(selections, key) || !carrierAllowed(cart, parent.variant_id, selected, true)) return;
      if (cart.items.filter(function (item) { return !isCarrierVariant(item) && !nativeParentKey(item) && groups.sameSelection(item, parent); }).length !== 1) return;
      selections[key] = { parent: groups.selectionDescriptor(parent), mode: 'follow',
        selectionKey: parent._mekhann_parent_selection_key || '', chosenCarrierVariantId: selected };
    });
    return selections;
  }

  function carrierPreference(cart, parent) {
    var groups = cartGroups();
    return groups && parent ? carrierPreferences(cart)[groups.selectionSignature(parent)] || null : null;
  }

  function validCarrierPreference(preference) {
    return preference && ['off', 'follow', 'custom'].indexOf(preference.mode) !== -1 &&
      (preference.mode !== 'custom' || positiveQuantity(preference.quantity));
  }

  function desiredCarrierQuantity(cart, parent, preference) {
    if (!validCarrierPreference(preference)) return carrierQuantityForParent(cart, parent);
    if (preference.mode === 'off') return 0;
    var maximum = parentQuantity(cart, parent);
    return preference.mode === 'follow' ? maximum : Math.min(maximum, Number(preference.quantity));
  }

  function observeCarrierPreferences(cart) {
    observedCarrierPreferences = carrierPreferences(cart);
    observedCarrierCart = cart;
    return cart;
  }

  function offerCarrierPreference(offer) {
    var groups = cartGroups();
    try { return groups ? observedCarrierPreferences[groups.selectionSignature(JSON.parse(offer.dataset.parentGroup))] || null : null; }
    catch (error) { return null; }
  }

  function writeCarrierPreferences(cart, selections, canMutate, contextOnly) {
    if (canMutate && !canMutate()) throw new Error('Your bag is still updating. Please wait before changing shade carriers.');
    var value = JSON.stringify({ version: 1, selections: selections });
    if (String((cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] || '') === value) {
      if (!priorCartToken(cart)) return Promise.resolve(observeCarrierPreferences(cart));
      // An unchanged provisional attribute is not the final Ajax identity
      // barrier. Read only, then require the exact intended preference again.
      return getCart().then(function (confirmed) {
        if (canMutate && !canMutate()) throw new Error('Your bag changed while the shade carrier preference was being checked.');
        if (String((confirmed.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] || '') !== value) {
          throw new Error('Your shade carrier preference changed while it was being checked. Please try again.');
        }
        return observeCarrierPreferences(confirmed);
      });
    }
    // Shopify merges this attribute patch. Sending only our key also avoids
    // overwriting a concurrently typed gift message or unrelated app attribute.
    var attributes = {};
    attributes[CARRIER_PREFERENCE_ATTRIBUTE] = value;
    var write = function () {
      if (canMutate && !canMutate()) throw new Error('Your bag changed before the shade carrier preference could be saved.');
      return requestJson(route('cartUpdate', 'cart/update.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }, contextOnly ? 'context' : 'response').then(function (updatedCart) {
        // update.js already returns the committed cart. Keep the fresh Liquid
        // mapping/discount proof, without discarding this response for a second
        // cart.js read. A mismatched proof still performs its one fresh retry.
        return attachCarrierMappings(updatedCart, false);
      }).catch(function (error) {
        if (error && error.mekhannContextRetried) throw error;
        // A rejected or unprovable response may have committed. Read once,
        // without replaying the preference POST or any carrier mutation.
        return getCart();
      }).then(function (confirmed) {
        if (pendingPdpRecord && pendingPdpRecord.tokenSource === 'prior-ajax-token') checkPendingPdpCart(confirmed);
        if (String((confirmed.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] || '') !== value) {
          throw new Error('Your shade carrier preference could not be saved. Please use Change to try again.');
        }
        return observeCarrierPreferences(confirmed);
      });
    };
    var groups = cartGroups();
    return groups && groups.run ? groups.run(write) : write();
  }

  function carrierPreferenceSelections(cart, parent, choice, suspended, chosenCarrierVariantId) {
    var groups = cartGroups();
    if (!groups || !parent) throw new Error('Your lampshade selection could not be confirmed.');
    var selections = carrierPreferences(cart);
    var mode = choice === 'follow' ? 'follow' : Number(choice) === 0 ? 'off' : 'custom';
    var prior = selections[groups.selectionSignature(parent)] || {};
    var selectionKey = parent._mekhann_parent_selection_key || prior.selectionKey || '';
    if (!selectionKey) {
      Array.prototype.some.call(document.querySelectorAll(OFFER_SELECTOR), function (offer) {
        try {
          if (!groups.sameSelection(parent, JSON.parse(offer.dataset.parentGroup))) return false;
          selectionKey = offer.dataset.parentSelectionKey || '';
          return Boolean(selectionKey);
        } catch (error) { return false; }
      });
    }
    var preference = { parent: groups.selectionDescriptor(parent), mode: mode, selectionKey: selectionKey };
    var selectedId = chosenCarrierVariantId === undefined ? numericId(prior.chosenCarrierVariantId) : numericId(chosenCarrierVariantId);
    if (selectedId) preference.chosenCarrierVariantId = selectedId;
    if (mode === 'custom') preference.quantity = Number(choice);
    if (suspended) preference.suspended = true;
    selections[groups.selectionSignature(parent)] = preference;
    return selections;
  }

  function saveCarrierPreference(cart, parent, choice, suspended, canMutate, chosenCarrierVariantId) {
    return writeCarrierPreferences(cart, carrierPreferenceSelections(cart, parent, choice, suspended, chosenCarrierVariantId), canMutate, suspended);
  }

  // A confirmed decrease can save its explicit preference and exact current
  // child-key reductions together. Never use update.js to create/increase a
  // carrier, and never substitute guessed keys after the write was attempted.
  function carrierReductionPlan(cart, parent, desired, choice) {
    var groups = cartGroups();
    if (!groups || !cart || typeof cart.token !== 'string' || !cart.token || priorCartToken(cart) ||
        !Number.isSafeInteger(desired) || desired < 0 || Number(choice) !== desired ||
        !parent || groups.selectionMembers(cart, parent).length !== 1 || findInvalidPilotLine(cart)) return null;
    var children = linkedCarriers(cart, parent), selected = carrierQuantityForParent(cart, parent);
    if (!children.length || desired >= selected) return null;
    var keys = Object.create(null), updates = Object.create(null), remaining = selected - desired;
    var lines = [];
    for (var index = 0; index < children.length; index += 1) {
      var child = children[index], key = child.key;
      var token = normaliseProperties(child.properties)._mekhann_pilot_token;
      if (typeof key !== 'string' || !key || /^\d+$/.test(key) || keys[key] ||
          cart.items.filter(function (item) { return item.key === key; }).length !== 1 ||
          !isCurrentPilotLine(child) || !isComplimentaryLine(child) || !positiveQuantity(child.quantity) ||
          !validMoney(child.original_price) || child.original_line_price !== child.original_price * child.quantity ||
          cart.items.some(function (item) {
            return normaliseProperties(item.properties)._mekhann_pilot_token === token && children.indexOf(item) === -1;
          })) return null;
      keys[key] = true;
      var quantity = child.quantity - Math.min(child.quantity, remaining);
      remaining -= child.quantity - quantity;
      if (quantity < child.quantity) updates[key] = quantity;
      lines.push({ descriptor: groups.selectionDescriptor(child), productId: numericId(child.product_id),
        quantity: quantity, originalPrice: child.original_price });
    }
    if (remaining || !Object.keys(updates).length) return null;
    var retained = lines.filter(function (line) { return line.quantity > 0; });
    if (retained.some(function (line, index) {
      return retained.some(function (other, otherIndex) { return index !== otherIndex && nativeEqual(line.descriptor, other.descriptor); });
    })) return null;
    var unchanged = cart.items.filter(function (item) { return children.indexOf(item) === -1; }).map(nativeLineEvidence);
    if (!unchanged.every(validNativeLineEvidence)) return null;
    return { token: cart.token, parent: groups.selectionDescriptor(parent), parentQuantity: parentQuantity(cart, parent),
      desired: desired, lines: lines, unchanged: unchanged, updates: updates, note: cart.note || '', attributes: nativeClone(cart.attributes || {}),
      referenceLines: cart.items.map(nativeLineEvidence), excludedKeys: [parent.key].concat(children.map(function (child) { return child.key; })) };
  }


  // Only a full Remove of owned, individually tagged selections uses this path.
  // update.js carries exact line keys and zeroes only; it cannot create stock.
  // Preference cleanup stays in acknowledged reconciliation: a late uncertain
  // attribute patch could otherwise overwrite a later customer's choice.
  function removalPlan(cart, identity) {
    var groups = cartGroups();
    if (!groups || !cart || typeof cart.token !== 'string' || !cart.token || priorCartToken(cart) ||
        removalJournal || removalJournalFault || nativeBatchRecord || nativeBatchFault || pendingPdpRecord || pendingAddToken ||
        pendingReductionProtection || pdpRecoveryFault || findInvalidPilotLine(cart) ||
        (cart.cart_level_discount_applications || []).length) return null;
    var baseline = nativeBaseline(cart);
    if (!validNativeBaseline(baseline)) return null;
    var parents = groups.members(cart, identity), display = groups.isDisplay(identity);
    if (!parents.length) return null;
    if (display) {
      if (!Number.isSafeInteger(identity.quantity) || parents.length !== identity.selections.length ||
          !Array.isArray(identity.childStates) || identity.childStates.length !== parents.length ||
          parents.reduce(function (sum, parent) { return sum + parent.quantity; }, 0) !== identity.quantity) return null;
      var equivalents = cart.items.filter(function (parent) {
        var config = groups.displayConfiguration(cart, parent, true);
        return config && nativeEqual(config, identity.configuration);
      });
      if (equivalents.length !== parents.length || parents.some(function (parent) {
        var n = identity.selections.findIndex(function (selection) { return groups.sameSelection(parent, selection); });
        return n < 0 || !nativeEqual(groups.displayConfiguration(cart, parent, true), identity.configuration) ||
          identity.childStates[n] !== groups.displayChildState(cart, parent);
      })) return null;
    }
    var selected = [], fittingGroups = [], keys = Object.create(null), bad = false;
    parents.forEach(function (parent) {
      var props = parent.properties || {}, linked = linkedCarriers(cart, parent);
      var type = String(parent.product_type || '').toLowerCase().replace(/[\s_-]+/g, '');
      if (['lampshade', 'lampshades'].indexOf(type) < 0 ||
          !(groupedParentProperties(props) || nativeGroupProperties(props)) || nativeParentKey(parent) ||
          groups.selectionMembers(cart, parent).length !== 1 || parent.original_price !== parent.final_price ||
          parent.original_line_price !== parent.original_price * parent.quantity || parent.final_line_price !== parent.original_line_price ||
          !linked.length || carrierQuantityForParent(cart, parent) !== parent.quantity ||
          fittingGroups.indexOf(props._mekhann_fitting_group) !== -1 ||
          linked.some(function (child) { return !isComplimentaryLine(child) || getPilotLineIssue(cart, child) ||
            !(child.properties || {})._mekhann_pilot_token; })) { bad = true; return; }
      fittingGroups.push(props._mekhann_fitting_group);
      selected.push(parent); selected = selected.concat(linked);
    });
    if (bad || !selected.length || selected.some(function (line) {
      var key = line.key;
      if (typeof key !== 'string' || !key || /^\d+$/.test(key) || keys[key] ||
          cart.items.filter(function (item) { return item.key === key; }).length !== 1) return true;
      keys[key] = true; return false;
    })) return null;
    // Never capture only part of a persisted fitting or a native child graph.
    if (cart.items.some(function (line) { return !keys[line.key] &&
      (fittingGroups.indexOf((line.properties || {})._mekhann_fitting_group) !== -1 || keys[nativeParentKey(line)]); })) return null;
    var record = {version: 1, token: cart.token, baseline: baseline, removed: selected.map(nativeLineEvidence), fittingGroups: fittingGroups};
    return validRemovalRecord(record) ? record : null;
  }

  function validRemovalRecord(record) {
    if (record && record.version === 2) return validMinusRecord(record);
    if (!nativeObject(record) || record.version !== 1 || typeof record.token !== 'string' || !record.token ||
        !validNativeBaseline(record.baseline) || !Array.isArray(record.removed) || !record.removed.length ||
        !record.removed.every(validNativeLineEvidence) || !Array.isArray(record.fittingGroups) || !record.fittingGroups.length ||
        record.fittingGroups.some(function (group) { return typeof group !== 'string' || !/^[A-Za-z0-9_-]{8,120}$/.test(group); })) return false;
    var seen = Object.create(null);
    return record.removed.every(function (line) {
      if (/^\d+$/.test(line.key) || seen[line.key] || line.parentKey) return false;
      seen[line.key] = true;
      return record.baseline.items.some(function (old) { return nativeEqual(old, line); });
    }) && record.fittingGroups.every(function (group) {
      return record.removed.some(function (line) { return line.properties._mekhann_fitting_group === group &&
        (nativeGroupProperties(line.properties) || groupedParentProperties(line.properties)); });
    });
  }

  function removalComplete(cart, record) {
    if (record && record.version === 2) return minusComplete(cart, record);
    if (!validRemovalRecord(record) || !cart || priorCartToken(cart) || cart.token !== record.token ||
        !Array.isArray(cart.items) || cart.currency !== record.baseline.currency ||
        (cart.note || '') !== record.baseline.note || !nativeEqual(cart.attributes || {}, record.baseline.attributes) ||
        (cart.cart_level_discount_applications || []).length || findInvalidPilotLine(cart)) return false;
    var gone = Object.create(null);
    record.removed.forEach(function (line) { gone[line.key] = true; });
    if (cart.items.some(function (line) { return gone[line.key] ||
        record.fittingGroups.indexOf((line.properties || {})._mekhann_fitting_group) !== -1; })) return false;
    var retained = record.baseline.items.filter(function (line) { return !gone[line.key]; });
    return unchangedReductionLines(retained, cart.items, true, {beforeLines: record.baseline.items, currentLines: cart.items,
      excludedKeys: record.removed.map(function (line) { return line.key; })}) &&
      cart.item_count === retained.reduce(function (sum, line) { return sum + line.quantity; }, 0) &&
      cart.total_price === retained.reduce(function (sum, line) { return sum + line.finalLinePrice; }, 0) &&
      cart.total_discount === retained.reduce(function (sum, line) { return sum + line.originalLinePrice - line.finalLinePrice; }, 0);
  }

  function saveRemovalJournal(record) {
    try {
      var encoded = JSON.stringify(record);
      window.sessionStorage.setItem(REMOVE_PENDING_KEY, encoded);
      if (window.sessionStorage.getItem(REMOVE_PENDING_KEY) !== encoded) throw new Error();
    } catch (error) {
      // No request has been sent. Remove only this attempt's own write.
      try { if (window.sessionStorage.getItem(REMOVE_PENDING_KEY) === encoded) window.sessionStorage.removeItem(REMOVE_PENDING_KEY); } catch (ignore) {}
      // Do not fall through to another write path.
      throw new Error('Your bag update could not be prepared. Please refresh your bag and try again.');
    }
    removalJournal = record;
  }

  function clearRemovalJournal(record) {
    if (removalJournal !== record) throw new Error('Your bag update could not be confirmed. Please refresh your bag.');
    window.sessionStorage.removeItem(REMOVE_PENDING_KEY);
    if (window.sessionStorage.getItem(REMOVE_PENDING_KEY)) throw new Error('Your bag update could not be confirmed. Please refresh your bag.');
    removalJournal = null; removalJournalRestored = false;
  }

  function restoreRemovalJournal() {
    try {
      var encoded = window.sessionStorage && window.sessionStorage.getItem(REMOVE_PENDING_KEY);
      if (!encoded) return;
      var record = JSON.parse(encoded);
      if (!validRemovalRecord(record) || nativeBatchRecord || nativeBatchFault || pendingPdpRecord || pendingAddToken) throw new Error();
      removalJournal = record; removalJournalRestored = true;
      ownedQuantityUncertain = true; unverifiedMutation = true;
    } catch (error) { removalJournalFault = true; ownedQuantityUncertain = true; unverifiedMutation = true; }
  }

  function recoverRemovalJournal(guard) {
    if (removalRecovery) return removalRecovery;
    var record = removalJournal, navigated = false;
    var failureMessage = 'Your last bag update could not be confirmed. Refresh your bag before continuing.';
    var staleRead = new Error(failureMessage);
    function onPageHide() { navigated = true; }
    function current() {
      if (navigated) {
        var navigationError = new Error(failureMessage);
        navigationError.mekhannNavigation = true;
        throw navigationError;
      }
      if (guard) guard();
      if (!removalJournalRestored || removalJournal !== record || ownedMutation || externalMutationPending) throw new Error(failureMessage);
    }
    function read(retried) {
      if (retried) current();
      var stamp = generationStamp();
      return getCart().then(function (cart) {
        current();
        if (!removalComplete(cart, record)) throw new Error(failureMessage);
        if (stamp !== generationStamp()) throw retried ? new Error(failureMessage) : staleRead;
        // A fresh Add has a new fitting UUID. These exact old keys can only be
        // zeroed by a late request; there is no late attribute patch to undo new
        // preferences. A before-cart or partial result never releases this lock.
        clearRemovalJournal(record);
        ownedQuantityUncertain = false; unverifiedMutation = false;
        return cart;
      });
    }
    window.addEventListener('pagehide', onPageHide);
    removalRecovery = read(false).catch(function (error) {
      // Initial HTML can mount while recovery reads are in flight. A caller
      // joining this promise must not inherit a permanently stale generation.
      // Retry only that completed read once, retaining every journal/economic
      // check; never accept the old snapshot or resend a mutation.
      if (error !== staleRead) throw error;
      return read(true);
    }).finally(function () {
      window.removeEventListener('pagehide', onPageHide);
      removalRecovery = null;
    });
    return removalRecovery;
  }

  function removeOwnedSelection(owner, identity, guard, expectedQuantity) {
    var groups = cartGroups(), attempted = false, plan = null;
    // Paid products and explicit No carrier choices keep their one-read path.
    var captured = groups.isDisplay(identity) ? identity.configuration && identity.configuration.identity : groups.descriptor(identity);
    var tagged = groups.isDisplay(identity) ? identity.configuration.carrierMode === 'follow' :
      captured && captured.properties && captured.properties.some(function (pair) { return pair[0] === '_mekhann_grouped_parent' && pair[1] === 'V1'; });
    if (!tagged) return groups.changeQuantity(identity, 0, guard, expectedQuantity);
    function current(beforeWrite) {
      if (guard) guard(Boolean(beforeWrite));
      if (!ownedCurrent(owner)) throw new Error('Your bag changed before the item could be removed. Please refresh your bag.');
    }
    return groups.run(function () {
      current(false);
      return getCart().then(function (cart) {
        current(false);
        if (Number.isSafeInteger(expectedQuantity) && groups.members(cart, identity).reduce(function (sum, line) { return sum + line.quantity; }, 0) !== expectedQuantity) {
          throw new Error('Your bag has changed. Please check the quantity and try again.');
        }
        plan = removalPlan(cart, identity);
        if (!plan) return null;
        var updates = Object.create(null);
        plan.removed.forEach(function (line) { updates[line.key] = 0; });
        current(true);
        saveRemovalJournal(plan);
        attempted = true;
        return requestJson(route('cartUpdate', 'cart/update.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({updates: updates})
        }).then(function (cart) { return attachCarrierMappings(cart, false); }).then(function (cart) {
          current(false);
          if (!removalComplete(cart, plan)) throw new Error('Your bag removal could not be confirmed. Please refresh your bag.');
          clearRemovalJournal(plan);
          owner.removalAcknowledged = plan;
          return observeCarrierPreferences(cart);
        }).catch(function (error) {
          // Only an explicit, unbundled definitive rejection proves no commit.
          var rejected = [400, 404, 422].indexOf(error && error.httpStatus) !== -1 && !error.mekhannMutationUnknown;
          if (rejected) { clearRemovalJournal(plan); throw error; }
          ownedQuantityUncertain = true; unverifiedMutation = true;
          error.mekhannMutationUnknown = true;
          throw error;
        });
      });
    }).then(function (cart) {
      // Unsupported graphs retain the established path, only before any POST.
      if (!cart && !attempted) return groups.changeQuantity(identity, 0, guard, expectedQuantity);
      return cart;
    });
  }

  // QTY1: a proven Follow decrement changes one physical parent and one
  // linked free child together. Exact keys only; every target is lower.
  // A receipt travels in the same POST. Matching quantities without that
  // receipt cannot resolve a lost response and release a late-write hazard.
  var MINUS_RECEIPT_ATTRIBUTE = '_mekhann_quantity_receipt';

  function minusAttributePatch(record) {
    var patch = {}, parent = record.baseline.items.find(function (line) { return line.key === record.parentKey; });
    patch[MINUS_RECEIPT_ATTRIBUTE] = record.receipt;
    if (parent && parent.quantity === 1) {
      var raw = record.baseline.attributes[CARRIER_PREFERENCE_ATTRIBUTE];
      if (raw) {
        var saved = JSON.parse(raw);
        if (!saved || saved.version !== 1 || !nativeObject(saved.selections)) throw new Error('Invalid saved fitting preference');
        var signature = cartGroups().selectionSignature({variant_id: parent.variantId, properties: parent.properties});
        if (Object.prototype.hasOwnProperty.call(saved.selections, signature)) {
          delete saved.selections[signature];
          patch[CARRIER_PREFERENCE_ATTRIBUTE] = JSON.stringify(saved);
        }
      }
    }
    return patch;
  }

  function validMinusRecord(record) {
    if (!nativeObject(record) || record.version !== 2 || record.kind !== 'minus' ||
        typeof record.token !== 'string' || !record.token || !validNativeBaseline(record.baseline) ||
        typeof record.receipt !== 'string' || !/^minus-[a-z0-9-]{16,100}$/.test(record.receipt) ||
        record.receipt === record.baseline.attributes[MINUS_RECEIPT_ATTRIBUTE] ||
        !nativeObject(record.updates) || Object.keys(record.updates).length !== 2 ||
        record.parentKey === record.childKey) return false;
    var parent = record.baseline.items.find(function (line) { return line.key === record.parentKey; });
    var child = record.baseline.items.find(function (line) { return line.key === record.childKey; });
    if (!parent || !child || parent.parentKey || child.parentKey || parent.sellingPlanId || child.sellingPlanId ||
        /^\d+$/.test(parent.key) || /^\d+$/.test(child.key) ||
        !(groupedParentProperties(parent.properties) || nativeGroupProperties(parent.properties)) ||
        record.updates[parent.key] !== parent.quantity - 1 || record.updates[child.key] !== child.quantity - 1 ||
        parent.originalPrice !== parent.finalPrice || parent.originalLinePrice !== parent.originalPrice * parent.quantity ||
        parent.finalLinePrice !== parent.originalLinePrice || parent.allocations.some(function (a) { return a.amount !== 0; }) ||
        child.finalPrice !== 0 || child.finalLinePrice !== 0 || child.originalLinePrice !== child.originalPrice * child.quantity ||
        child.allocations.length !== 1 || child.allocations[0].amount !== child.originalLinePrice ||
        child.allocations[0].type && child.allocations[0].type !== 'automatic' ||
        child.properties._mekhann_addon_type !== 'shade_carrier' || !child.properties._mekhann_pilot_token ||
        Number(child.properties._mekhann_parent_variant_id) !== parent.variantId) return false;
    try {
      var descriptor = JSON.parse(child.properties._mekhann_parent_group);
      if (!cartGroups().sameSelection({variant_id: parent.variantId, properties: parent.properties}, descriptor) ||
          child.properties._mekhann_grouped_batch === 'V1' &&
            (child.properties._mekhann_fitting_group !== parent.properties._mekhann_fitting_group ||
             Number(parent.properties._mekhann_grouped_carrier_id) !== child.variantId) ||
          child.properties._mekhann_parent_line_key && child.properties._mekhann_parent_line_key !== parent.key) return false;
      return nativeEqual(record.attributePatch, minusAttributePatch(record));
    } catch (error) { return false; }
  }

  function minusExpectedLines(record) {
    return record.baseline.items.map(function (old) {
      var line = nativeClone(old);
      if (!Object.prototype.hasOwnProperty.call(record.updates, line.key)) return line;
      line.quantity = record.updates[line.key];
      line.originalLinePrice = line.originalPrice * line.quantity;
      line.finalLinePrice = line.finalPrice * line.quantity;
      line.allocations.forEach(function (a) { a.amount = a.amount / old.quantity * line.quantity; });
      return line;
    }).filter(function (line) { return line.quantity > 0; });
  }

  function minusComplete(cart, record) {
    if (!validMinusRecord(record) || !cart || priorCartToken(cart) || cart.token !== record.token ||
        !Array.isArray(cart.items) || cart.currency !== record.baseline.currency ||
        (cart.note || '') !== record.baseline.note ||
        !nativeEqual(cart.attributes || {}, Object.assign({}, record.baseline.attributes, record.attributePatch)) ||
        (cart.cart_level_discount_applications || []).length || findInvalidPilotLine(cart)) return false;
    var retained = minusExpectedLines(record);
    return unchangedReductionLines(retained, cart.items, true, {beforeLines: record.baseline.items, currentLines: cart.items,
      excludedKeys: Object.keys(record.updates)}) &&
      cart.item_count === retained.reduce(function (sum, line) { return sum + line.quantity; }, 0) &&
      cart.total_price === retained.reduce(function (sum, line) { return sum + line.finalLinePrice; }, 0) &&
      cart.total_discount === retained.reduce(function (sum, line) { return sum + line.originalLinePrice - line.finalLinePrice; }, 0);
  }

  function tryMinusOwnedSelection(owner, identity, target, guard, expectedQuantity) {
    var groups = cartGroups();
    if (!groups || !ownedCurrent(owner) || !Number.isSafeInteger(expectedQuantity) || expectedQuantity < 2 ||
        target !== expectedQuantity - 1) return Promise.resolve(null);
    var sent = false;
    var lifecycleGuard = cartExtras && cartExtras.removeGuard(function () { return ownedCurrent(owner); },
      Date.now() + 10000, function () { return sent; }, 'quantity');
    var selections = groups.isDisplay(identity) ? identity.selections : [identity];
    var offers = Array.prototype.slice.call(document.querySelectorAll(OFFER_SELECTOR));
    var captured = Object.create(null);
    if (!Array.isArray(selections) || !selections.every(function (selection) {
      var matches = offers.filter(function (offer) {
        try { return groups.sameSelection(JSON.parse(offer.dataset.parentGroup), selection); }
        catch (ignore) { return false; }
      });
      var offer = matches[0];
      if (!offer || offer.dataset.carrierProven !== 'true' || !positiveQuantity(offer.dataset.parentQuantity) ||
          Number(offer.dataset.carrierSelected) !== Number(offer.dataset.parentQuantity) || !numericId(offer.dataset.carrierVariantId)) return false;
      var proof = {quantity: Number(offer.dataset.parentQuantity), carrier: Number(offer.dataset.carrierVariantId)};
      if (matches.some(function (other) { return other.dataset.carrierProven !== 'true' ||
          Number(other.dataset.parentQuantity) !== proof.quantity || Number(other.dataset.carrierSelected) !== proof.quantity ||
          Number(other.dataset.carrierVariantId) !== proof.carrier; })) return false;
      captured[groups.selectionSignature(selection)] = proof;
      return true;
    })) return Promise.resolve(null);
    function current(beforeWrite) {
      if (guard) guard(Boolean(beforeWrite));
      if (lifecycleGuard) lifecycleGuard();
      if (!ownedCurrent(owner)) throw new Error('Your bag changed before the quantity could be updated. Please refresh your bag.');
    }
    return groups.run(function () {
      current(false);
      return getCart().then(function (cart) {
        current(false);
        var parents = groups.members(cart, identity);
        if (!parents.length || parents.reduce(function (sum, parent) { return sum + parent.quantity; }, 0) !== expectedQuantity ||
            parents.length !== selections.length) throw new Error('Your bag has changed. Please check the quantity and try again.');
        var eligible = parents.every(function (parent) {
          var proof = captured[groups.selectionSignature(parent)], preference = carrierPreference(cart, parent);
          if (!proof || parent.quantity !== proof.quantity ||
              preference && Number(preference.chosenCarrierVariantId) !== proof.carrier) {
            throw new Error('Your shade carrier selection has changed. Please check your bag.');
          }
          return validCarrierPreference(preference) && preference.mode === 'follow' && !preference.suspended;
        });
        if (!eligible || !removalPlan(cart, identity)) return null;
        // Prefer reducing a retained physical line. Both older TECH1 quantity
        // rows and new PLUS1 one-unit pairs use the same bounded request.
        var parent = parents.slice().sort(function (a, b) { return b.quantity - a.quantity; })[0];
        var child = linkedCarriers(cart, parent)[0];
        var record = {version: 2, kind: 'minus', token: cart.token, baseline: nativeBaseline(cart),
          parentKey: parent.key, childKey: child.key, updates: {},
          receipt: 'minus-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12) + '-q'};
        record.updates[parent.key] = parent.quantity - 1;
        record.updates[child.key] = child.quantity - 1;
        record.attributePatch = minusAttributePatch(record);
        if (!validMinusRecord(record)) return null;
        current(true);
        saveRemovalJournal(record);
        try { current(true); }
        catch (error) { clearRemovalJournal(record); throw error; }
        function confirm(confirmed) {
          current(false);
          if (!minusComplete(confirmed, record)) throw new Error('Your quantity update could not be confirmed. Please refresh your bag.');
          clearRemovalJournal(record);
          owner.removalAcknowledged = record;
          return observeCarrierPreferences(confirmed);
        }
        sent = true;
        return requestJson(route('cartUpdate', 'cart/update.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({updates: record.updates, attributes: record.attributePatch})
        }).then(function (response) {
          return attachCarrierMappings(response, false).then(confirm);
        }, function (error) {
          // Never resend. A fresh read may prove this exact receipt completed;
          // quantities alone, a partial result or an old cart cannot do so.
          return getCart().then(function (confirmed) {
            current(false);
            if (minusComplete(confirmed, record)) return confirm(confirmed);
            if ([400, 404, 422].indexOf(error && error.httpStatus) !== -1 && !error.mekhannMutationUnknown &&
                confirmed.token === record.token && nativeEqual(nativeBaseline(confirmed), record.baseline)) {
              clearRemovalJournal(record);
            }
            throw error;
          });
        }).catch(function (error) {
          if (removalJournal === record) {
            ownedQuantityUncertain = true; unverifiedMutation = true;
            error.mekhannMutationUnknown = true;
          }
          throw error;
        });
      });
    });
  }

  function unchangedReductionLines(before, current, allowOmittedType, partitionContext) {
    if (new Set(before.map(function (line) { return line.key; })).size !== before.length ||
        new Set(current.map(function (line) { return line.key; })).size !== current.length) return false;
    var used = [], remapped = Object.create(null), consumedBefore = Object.create(null), valid = true;
    // Prove unaffected eligible cohorts atomically, then strict parents before
    // native children. Neither path can change selection totals, properties or
    // the set of unrelated children, including extra FREE items.
    before.slice().sort(function (a, b) { return Number(Boolean(a.parentKey)) - Number(Boolean(b.parentKey)); }).forEach(function (old) {
      if (!valid || consumedBefore[old.key]) return;
      var partition = nativeExistingPartition(before, current, old, used, consumedBefore, partitionContext);
      if (partition) {
        partition.beforeKeys.forEach(function (key) {
          consumedBefore[key] = true;
          if (partition.currentKeys.length === 1) remapped[key] = partition.currentKeys[0];
        });
        used = used.concat(partition.currentKeys);
        return;
      }
      var matches = current.filter(function (item) {
        if (used.indexOf(item.key) !== -1) return false;
        var actual = nativeLineEvidence(item), expected = nativeClone(old);
        expected.key = actual.key;
        // The matching Liquid proof can omit type on a read while the later
        // acknowledged Ajax response explicitly supplies automatic. Keep the
        // exact amount/title and reject any explicit conflicting type.
        if (allowOmittedType && expected.allocations.length === actual.allocations.length) {
          expected.allocations.forEach(function (allocation, index) {
            var next = actual.allocations[index];
            if (allocation.amount !== next.amount || allocation.title !== next.title) return;
            if (!allocation.type && next.type === 'automatic') allocation.type = next.type;
            else if (!next.type && allocation.type === 'automatic') next.type = allocation.type;
          });
        }
        if (expected.parentKey && remapped[expected.parentKey]) expected.parentKey = remapped[expected.parentKey];
        if (!isCarrierVariant(item) && !actual.parentKey && actual.originalLinePrice === actual.finalLinePrice) {
          actual.allocations = actual.allocations.filter(function (entry) { return entry.amount !== 0; });
          expected.allocations = expected.allocations.filter(function (entry) { return entry.amount !== 0; });
        }
        return nativeEqual(actual, expected) && (!isCurrentPilotLine(item) || isComplimentaryLine(item));
      });
      if (matches.length !== 1) { valid = false; return; }
      consumedBefore[old.key] = true;
      used.push(matches[0].key);
      remapped[old.key] = matches[0].key;
    });
    return valid && used.length === current.length;
  }

  function reduceCarriersTogether(cart, parent, choice, plan, protection, canMutate) {
    var groups = cartGroups();
    var value = JSON.stringify({ version: 1, selections: carrierPreferenceSelections(cart, parent, choice, false) });
    var attributes = {};
    attributes[CARRIER_PREFERENCE_ATTRIBUTE] = value;
    var expectedAttributes = Object.assign({}, plan.attributes, attributes);
    function verify(confirmed) {
      if (!canMutate() || !confirmed || priorCartToken(confirmed) || confirmed.token !== plan.token ||
          String((confirmed.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] || '') !== value ||
          !nativeEqual(confirmed.attributes || {}, expectedAttributes) || (confirmed.note || '') !== plan.note ||
          protectedCartIssue(confirmed, protection) || findInvalidPilotLine(confirmed)) {
        throw new Error('Your shade carrier reduction could not be confirmed. Please refresh your bag before continuing.');
      }
      var parents = confirmed.items.filter(function (item) {
        return !isCarrierVariant(item) && !nativeParentKey(item) && groups.sameSelection(item, plan.parent);
      });
      if (parents.length !== 1 || parentQuantity(confirmed, parents[0]) !== plan.parentQuantity ||
          carrierQuantityForParent(confirmed, parents[0]) !== plan.desired) {
        throw new Error('Your shade carrier quantity changed during confirmation. Please refresh your bag.');
      }
      var retained = plan.lines.filter(function (line) { return line.quantity > 0; });
      var current = linkedCarriers(confirmed, parents[0]);
      if (!unchangedReductionLines(plan.unchanged, confirmed.items.filter(function (item) { return current.indexOf(item) === -1; }), false,
          {beforeLines: plan.referenceLines, currentLines: confirmed.items, excludedKeys: plan.excludedKeys})) {
        throw new Error('Other items in your bag changed during the shade carrier reduction. Please refresh your bag.');
      }
      if (current.length !== retained.length || retained.some(function (line) {
        var matches = current.filter(function (item) { return groups.sameSelection(item, line.descriptor); });
        return matches.length !== 1 || numericId(matches[0].product_id) !== line.productId ||
          matches[0].quantity !== line.quantity || matches[0].original_price !== line.originalPrice ||
          matches[0].original_line_price !== line.originalPrice * line.quantity || !isComplimentaryLine(matches[0]);
      })) throw new Error('Your shade carrier selection could not be confirmed. Please refresh your bag.');
      return observeCarrierPreferences(confirmed);
    }
    return groups.run(function () {
      if (!canMutate()) throw new Error('Your bag changed before the shade carrier reduction could be saved.');
      return requestJson(route('cartUpdate', 'cart/update.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes, updates: plan.updates })
      }).then(function (updated) { return attachCarrierMappings(updated, false); })
        .catch(function (error) {
          // Shopify may have committed despite a rejected or lost response.
          // Recover by reading once, with the established one-proof retry only.
          // An unproven result must never fall through to serial child writes.
          if (error && error.mekhannContextRetried) throw error;
          return getCart();
        }).then(verify).catch(function (error) {
          ownedQuantityUncertain = true;
          unverifiedMutation = true;
          syncCheckoutGuards();
          throw error;
        });
    });
  }

  // Follow increments reuse the same monetary proof and token rollback as an
  // explicit add. Persist suspension before sending so reload cannot repeat an
  // uncertain or failed add. Only a proven whole batch re-enables following.
  function growCarrierPreference(cart, parent, preference, canMutate) {
    var groups = cartGroups();
    var identity = groups.selectionDescriptor(parent);
    var desired = desiredCarrierQuantity(cart, parent, preference);
    var amount = desired - carrierQuantityForParent(cart, parent);
    var choice = preference.mode === 'follow' ? 'follow' : preference.quantity;
    var token = BUILD + '-follow-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    var before = commerceSnapshot(cart);
    var sent = false;
    var addError = null;
    var data = { quantity: amount, carrierVariantId: preferredCarrier(cart, parent),
      parentVariantId: parent.variant_id, parentLineKey: parent.key,
      parentTitle: parent.product_title || parent.title || 'Lampshade', parentVariantTitle: parent.variant_title || '',
      parentGroup: JSON.stringify(identity), parentSelectionKey: preference.selectionKey || '' };
    if (amount < 1 || !data.carrierVariantId || !data.parentSelectionKey || !canMutate()) return Promise.resolve(cart);
    return saveCarrierPreference(cart, parent, choice, true, canMutate).then(function (saved) {
      if (!canMutate() || protectedCartIssue(saved, before)) throw new Error('Your bag changed while the shade carrier preference was saving. Please check your selection.');
      var savedParent = saved.items.find(function (item) { return !isCarrierVariant(item) && groups.sameSelection(item, identity); });
      if (!savedParent) throw new Error('Your lampshade selection has changed.');
      data.parentLineKey = savedParent.key;
      persistPendingPdpAdd(saved, savedParent, token, amount, before);
      pendingAddToken = token;
      pendingAddQuantity = amount;
      pendingAddProtection = before;
      pendingAddAcknowledged = false;
      pendingAddRollback = false;
      pendingPdpUncertain = true;
      unverifiedMutation = true;
      sent = true;
      return requestJson(route('cartAdd', 'cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(buildAddPayload(data, token))
      }, 'context').then(function (response) { pendingAddAcknowledged = true; return response; }, function (error) {
        addError = error;
        // Read the uncertain result; never resubmit this token or quantity.
      }).then(function (response) { return getCart(false, response); });
    }).then(function (current) {
      return confirmAddedLine(current, token, amount, before);
    }).then(function (confirmation) {
      if (!canMutate()) throw new Error('Your bag changed while the shade carrier was being checked.');
      if (!confirmation.issue && confirmation.line) {
        pendingPdpUncertain = false;
        return saveCarrierPreference(confirmation.cart, parent, choice, false, canMutate).then(function (saved) {
          if (protectedCartIssue(saved, before) || findInvalidPilotLine(saved)) throw new Error('Your shade carrier pricing is still being checked.');
          clearPendingAdd();
          return saved;
        });
      }
      pendingAddRollback = true;
      var definitiveRejection = addError && !addError.mekhannMutationUnknown && [400, 404, 422].indexOf(addError.httpStatus) !== -1;
      if (!confirmation.line && !definitiveRejection) {
        throw new Error('The additional fitting request could not be confirmed. Your lampshades and verified shade carriers remain in your bag. Please check your bag before trying again.');
      }
      pendingPdpUncertain = false;
      return rollbackAddedToken(confirmation.cart, token, canMutate)
        .then(function (restored) { return confirmProtectedRestoration(restored, before); })
        .then(function (restored) {
          clearPendingAdd();
          // The persisted suspended Follow intent rehydrates a per-selection
          // shortfall and explicit Retry in the verified final bag render.
          // Do not send the customer to a PDP that cannot repair this group.
          return restored;
        });
    }).catch(function (error) {
      if (sent) unverifiedMutation = true;
      if (pendingAddToken === token) pendingAddRollback = true;
      throw error;
    });
  }

  function trimCarrierPreference(cart, parent, desired, canMutate) {
    var identity = cartGroups().selectionDescriptor(parent);
    var protection = commerceSnapshot(cart);
    linkedCarriers(cart, parent).forEach(function (child) {
      delete protection.carriers[normaliseProperties(child.properties)._mekhann_pilot_token];
    });
    pendingReductionProtection = protection;
    unverifiedMutation = true;
    var changes = 0;
    function next(current) {
      if (!canMutate()) throw new Error('Your bag changed while the shade carrier quantity was updating.');
      var currentParent = current.items.find(function (item) { return !isCarrierVariant(item) && cartGroups().sameSelection(item, identity); });
      if (!currentParent) throw new Error('Your lampshade selection has changed. Please check your bag.');
      var selected = carrierQuantityForParent(current, currentParent);
      if (selected <= desired) return confirmProtectedRestoration(current, protection);
      if (++changes > Math.max(MAX_RECONCILE_REMOVALS, cart.items.length + 1)) throw new Error('The shade carrier quantity could not be updated safely.');
      var child = linkedCarriers(current, currentParent)[0];
      return postChange(child.key, Math.max(0, Number(child.quantity) - (selected - desired))).then(next);
    }
    return next(cart);
  }

  function reconcileCarrierPreferences(result, canMutate) {
    if (result.deferred || !canMutate()) return Promise.resolve(result);
    var groups = cartGroups();
    if (!groups) return Promise.resolve(result);
    var selections = carrierPreferences(result.cart);
    var keys = Object.keys(selections);
    var changed = false;
    keys.forEach(function (key) {
      var preference = selections[key];
      var parent = validCarrierPreference(preference) && preference.parent && result.cart.items.find(function (item) {
        return !isCarrierVariant(item) && !nativeParentKey(item) && groups.sameSelection(item, preference.parent);
      });
      if (!parent) { delete selections[key]; changed = true; }
      else if (preference.mode === 'custom' && Number(preference.quantity) > parentQuantity(result.cart, parent)) {
        // A clipped numeric choice stays clipped. Only explicit follow consent
        // may increase carriers when this lampshade quantity later increases.
        preference.quantity = parentQuantity(result.cart, parent);
        changed = true;
      }
    });
    var current = changed ? writeCarrierPreferences(result.cart, selections, canMutate) : Promise.resolve(result.cart);
    return current.then(function (cart) {
      var sequence = Promise.resolve(cart);
      Object.keys(selections).forEach(function (key) {
        sequence = sequence.then(function (latest) {
          var preference = carrierPreferences(latest)[key];
          if (!validCarrierPreference(preference) || !canMutate()) return latest;
          var parent = latest.items.find(function (item) { return !isCarrierVariant(item) && groups.sameSelection(item, preference.parent); });
          if (!parent) return latest;
          var desired = desiredCarrierQuantity(latest, parent, preference);
          var selected = carrierQuantityForParent(latest, parent);
          if (desired < selected) {
            changed = true;
            return trimCarrierPreference(latest, parent, desired, canMutate);
          }
          if (desired === selected || preference.mode !== 'follow' || preference.suspended) return latest;
          changed = true;
          return growCarrierPreference(latest, parent, preference, canMutate);
        });
      });
      return sequence;
    }).then(function (cart) {
      result.cart = observeCarrierPreferences(cart);
      result.preferenceChanged = changed;
      return result;
    });
  }

  // A full scan is synchronous and read-only. Reuse its calculations only until
  // that call returns; never attach this context to a cart, journal or async task.
  // Every later scan (even of the same, enriched cart object) starts fresh.
  function createPilotValidationContext(cart) {
    var parents = new Map(), members = new Map(), quantities = new Map(), linked = new Map();
    var groups = cartGroups(), preferences, preferencesRead = false;
    function once(cache, key, read) {
      if (!cache.has(key)) cache.set(key, read());
      return cache.get(key);
    }
    var validation = {
      resolveParent: function (item) {
        return once(parents, item, function () { return resolveParent(cart, item); });
      },
      selectionMembers: function (parent) {
        return once(members, parent, function () { return groups ? groups.selectionMembers(cart, parent) : [parent]; });
      },
      parentQuantity: function (parent) {
        return once(quantities, parent, function () { return parentQuantity(cart, parent, validation); });
      },
      linkedCarriers: function (parent) {
        return once(linked, parent, function () { return linkedCarriers(cart, parent, validation); });
      },
      carrierPreference: function (parent) {
        if (!groups || !parent) return null;
        if (!preferencesRead) { preferences = carrierPreferences(cart); preferencesRead = true; }
        return preferences[groups.selectionSignature(parent)] || null;
      }
    };
    return validation;
  }

  // Shopify lists recent additions first. Retain existing carriers first when
  // their parent quantity decreases; the active new batch is always last.
  // Several physical lines may share a token when Shopify splits a discount.
  function allowedCarrierQuantity(cart, item, parent, validation) {
    var remaining = validation ? validation.parentQuantity(parent) : parentQuantity(cart, parent);
    var children = (validation ? validation.linkedCarriers(parent) : linkedCarriers(cart, parent)).slice().reverse();
    if (pendingAddToken) {
      children = children.filter(function (child) {
        return normaliseProperties(child.properties)._mekhann_pilot_token !== pendingAddToken;
      }).concat(children.filter(function (child) {
        return normaliseProperties(child.properties)._mekhann_pilot_token === pendingAddToken;
      }));
    }
    for (var index = 0; index < children.length; index += 1) {
      var child = children[index];
      var quantity = positiveQuantity(child.quantity) ? Number(child.quantity) : 0;
      var allowed = Math.min(quantity, Math.max(0, remaining));
      if (child === item || child.key === item.key) return allowed;
      remaining -= allowed;
    }
    return 0;
  }

  function getPilotLineIssue(cart, item, validation) {
    if (!isKnownPilotLine(item)) return null;

    var properties = normaliseProperties(item.properties);
    var parentKey = actualParentKey(item);
    var declaredParentKey = properties._mekhann_parent_line_key || '';
    var parent = validation ? validation.resolveParent(item) : resolveParent(cart, item);

    if (!isCurrentPilotLine(item)) return 'legacy-pilot';
    if (!positiveQuantity(item.quantity)) return 'wrong-carrier-quantity';
    var nativeBatch = properties._mekhann_native_batch === NATIVE_BATCH_MARKER;
    if (isGroupedChild(item)) {
      if (!parent || !groupedChildParent(cart, item)) return 'wrong-parent';
    } else if (nativeBatch) {
      if (!nativeParentKey(item) || !parent || declaredParentKey || properties._mekhann_parent_selection_key ||
          !nativeBatchDescriptorMatches(parent, storedParentGroup(item))) return 'wrong-parent';
    } else {
      if (!declaredParentKey || !parent) return 'orphan';
      if (nativeParentKey(item) && declaredParentKey !== parentKey) return 'wrong-parent';
    }
    if (numericId(parent.variant_id) !== numericId(properties._mekhann_parent_variant_id)) return 'wrong-parent';
    if ((validation ? validation.parentQuantity(parent) : parentQuantity(cart, parent)) < 1) return 'unsupported-parent-quantity';
    if (!carrierAllowed(cart, parent.variant_id, item.variant_id, true)) return 'wrong-carrier';
    var preference = validation ? validation.carrierPreference(parent) : carrierPreference(cart, parent);
    if (preference && preference.mode !== 'off' && numericId(preference.chosenCarrierVariantId) &&
        numericId(preference.chosenCarrierVariantId) !== numericId(item.variant_id)) return 'wrong-carrier';
    if (!properties._mekhann_pilot_token) return 'invalid-pilot-marker';
    // Reduce excess units before discount proof: Shopify can charge the excess
    // when a parent is reduced. Recheck the entire remaining line afterwards.
    if (allowedCarrierQuantity(cart, item, parent, validation) < Number(item.quantity)) return 'excess-carrier-quantity';
    if (!isComplimentaryLine(item)) return 'not-complimentary';
    var groups = cartGroups();
    var parentMembers = validation ? validation.selectionMembers(parent) : groups ? groups.selectionMembers(cart, parent) : [parent];
    if (!parentMembers.length || parentMembers.some(function (member) {
      return !sameMoney(member.original_line_price, member.final_line_price);
    })) return 'parent-price-changed';
    return null;
  }

  function findInvalidPilotLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var validation = createPilotValidationContext(cart);
    var monetaryFailure = null;
    var quantityFailure = null;
    for (var index = 0; index < cart.items.length; index += 1) {
      var item = cart.items[index];
      if (!isKnownPilotLine(item)) continue;
      var issue = getPilotLineIssue(cart, item, validation);
      if (!issue) continue;
      var failure = { item: item, issue: issue };
      if (issue === 'excess-carrier-quantity') {
        failure.targetQuantity = allowedCarrierQuantity(cart, item, validation.resolveParent(item), validation);
        if (!quantityFailure) quantityFailure = failure;
        continue;
      }
      // Parent removal/reduction can temporarily move discount allocations.
      // Settle the entitlement first, then evaluate monetary failures afresh.
      if (issue === 'not-complimentary' || issue === 'parent-price-changed') {
        if (!monetaryFailure) monetaryFailure = failure;
      } else return failure;
    }
    return quantityFailure || monetaryFailure;
  }

  function findPilotLinesByToken(cart, token) {
    if (!cart || !Array.isArray(cart.items) || !token) return [];
    return cart.items.filter(function (item) {
      return isCurrentPilotLine(item) &&
        normaliseProperties(item.properties)._mekhann_pilot_token === token;
    });
  }

  function findPilotLineByToken(cart, token) {
    return findPilotLinesByToken(cart, token)[0] || null;
  }

  function commerceSnapshot(cart) {
    var groups = cartGroups();
    if (!groups || !cart || !Array.isArray(cart.items)) return null;
    var products = Object.create(null);
    var carriers = Object.create(null);
    cart.items.forEach(function (item) {
      if (isCurrentPilotLine(item)) {
        var token = normaliseProperties(item.properties)._mekhann_pilot_token;
        var entry = carriers[token] || { quantity: 0, original: 0, final: 0 };
        entry.quantity += Number(item.quantity);
        entry.original += Number(item.original_line_price);
        entry.final += Number(item.final_line_price);
        carriers[token] = entry;
      } else {
        var signature = groups.selectionSignature(item);
        var product = products[signature] || { quantity: 0, original: 0, final: 0 };
        product.quantity += Number(item.quantity);
        product.original += Number(item.original_line_price);
        product.final += Number(item.final_line_price);
        products[signature] = product;
      }
    });
    // final_line_price excludes order-level discounts. A fully discounted
    // carrier can still displace one of those discounts and increase the
    // amount payable, so protect the server cart total as well as each line.
    return { products: products, carriers: carriers,
      currency: cart.currency, payableTotal: cart.total_price };
  }

  function protectedCartIssue(cart, before) {
    if (!before) return null;
    var after = commerceSnapshot(cart);
    if (!after || typeof before.currency !== 'string' || !before.currency ||
        before.currency !== after.currency || !validMoney(before.payableTotal) ||
        !validMoney(after.payableTotal) || after.payableTotal > before.payableTotal) {
      return 'parent-price-changed';
    }
    var productKeys = Object.keys(before.products);
    if (productKeys.length !== Object.keys(after.products).length || productKeys.some(function (key) {
      return JSON.stringify(before.products[key]) !== JSON.stringify(after.products[key]);
    })) return 'parent-price-changed';
    if (Object.keys(before.carriers).some(function (token) {
      return JSON.stringify(before.carriers[token]) !== JSON.stringify(after.carriers[token]) ||
        !findPilotLinesByToken(cart, token).every(isComplimentaryLine);
    })) return 'existing-carrier-changed';
    return null;
  }

  function confirmProtectedRestoration(cart, before) {
    if (!protectedCartIssue(cart, before)) return Promise.resolve(cart);
    return delay(250).then(getCart).then(function (freshCart) {
      if (protectedCartIssue(freshCart, before)) {
        throw new Error('Your previous shade carrier selection is still being restored. Refresh your bag before checkout.');
      }
      return freshCart;
    });
  }

  function confirmAddedLine(cart, token, expectedQuantity, before) {
    function inspect(currentCart) {
      var lines = findPilotLinesByToken(currentCart, token);
      if (!lines.length) return { cart: currentCart, line: null, lines: [], issue: 'missing' };
      var quantity = lines.reduce(function (total, line) { return total + Number(line.quantity); }, 0);
      var issue = positiveQuantity(expectedQuantity) && quantity !== Number(expectedQuantity)
        ? 'incomplete-carrier-add' : protectedCartIssue(currentCart, before);
      for (var index = 0; !issue && index < lines.length; index += 1) {
        issue = getPilotLineIssue(currentCart, lines[index]);
      }
      return { cart: currentCart, line: lines[0], lines: lines, issue: issue };
    }
    var first = inspect(cart);
    if (['not-complimentary', 'missing', 'incomplete-carrier-add', 'existing-carrier-changed',
      'parent-price-changed'].indexOf(first.issue) === -1) return Promise.resolve(first);
    return delay(250).then(getCart).then(inspect);
  }

  function rollbackAddedToken(cart, token, canMutate) {
    var changes = 0;
    var limit = Math.max(MAX_RECONCILE_REMOVALS, cart && cart.items ? cart.items.length + 1 : 0);
    function next(currentCart) {
      var lines = findPilotLinesByToken(currentCart, token);
      if (!lines.length) return Promise.resolve(currentCart);
      if (!canMutate() || changes >= limit || !lines[0].key) {
        throw new Error('Shade carrier cleanup is still pending. Refresh your bag before checkout.');
      }
      changes += 1;
      return postChange(lines[0].key, 0).then(next);
    }
    return next(cart);
  }

  function cartSections() {
    return window.theme && window.theme.mekhannCartSections;
  }

  function requestJson(url, options, sectionMode) {
    var sections = cartSections();
    if (sections && String(options.method || '').toUpperCase() === 'POST') {
      options = sections.prepare(options, sectionMode || 'response');
    }
    var trace = window.theme && window.theme.mekhannCartTrace;
    var traceEnd = trace && trace.request(url, options);
    var traceStatus = 0;
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    if (controller) options.signal = controller.signal;
    // A deadline must settle the caller even if AbortController is unavailable
    // or the browser transport never settles after abort. A timed-out POST is
    // uncertain, so its caller verifies the cart instead of resending it.
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        if (controller) controller.abort();
        if (traceEnd) traceEnd('timeout', traceStatus);
        reject(new Error('The shopping bag update could not be confirmed in time. Please check your bag before trying again.'));
      }, 15000);
      Promise.resolve().then(function () { return fetch(url, options); }).then(function (response) {
        traceStatus = response.status;
        return parseResponse(response).catch(function (error) {
          // Shopify can commit a bundled mutation and still return 400 for
          // invalid section parameters. Never treat that status as proof that
          // this POST did not happen; callers verify, without replaying it.
          if (options.mekhannBundled && error.httpStatus === 400) error.mekhannMutationUnknown = true;
          throw error;
        });
      }).then(function (data) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        if (traceEnd) traceEnd('complete', traceStatus);
        resolve(data);
      }, function (error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        if (traceEnd) traceEnd('error', traceStatus);
        reject(error);
      });
    });
  }

  function parseResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok || data.status) {
        var responseError = new Error(data.description || data.message || 'The shopping bag could not be updated.');
        responseError.httpStatus = response.status;
        throw responseError;
      }
      return data;
    });
  }

  function cartIdentity(items) {
    return items.map(function (item) {
      return String(item.key) + ':' + numericId(item.variant_id) + ':' + Number(item.quantity);
    }).sort().join('|');
  }

  function validMoney(value) {
    return typeof value === 'number' && isFinite(value) &&
      value >= 0 && Math.floor(value) === value;
  }

  function sameMoney(left, right) {
    return validMoney(left) && validMoney(right) && left === right;
  }

  function mergeDiscountTypes(cart, context) {
    // Ajax and Liquid can independently omit application.type. After both
    // responses prove the same cart/allocation, preserve any explicit Ajax
    // type and fill only a missing one from Liquid. Never infer "automatic".
    // V2.34-HAR1: a blank Liquid type is absence, not contrary evidence.
    if (!cart || !context || !Array.isArray(cart.items) ||
        !Array.isArray(context.items) || cart.items.length !== context.items.length ||
        typeof cart.currency !== 'string' || !cart.currency ||
        cart.currency !== context.currency ||
        !sameMoney(cart.total_price, context.total_price) ||
        !sameMoney(cart.total_discount, context.total_discount)) return null;

    var byKey = Object.create(null);
    var seen = Object.create(null);
    for (var index = 0; index < context.items.length; index += 1) {
      var proof = context.items[index];
      if (!proof || typeof proof.key !== 'string' || !proof.key || byKey[proof.key]) return null;
      byKey[proof.key] = proof;
    }

    var merged = [];
    for (var itemIndex = 0; itemIndex < cart.items.length; itemIndex += 1) {
      var item = cart.items[itemIndex];
      if (!item || typeof item.key !== 'string' || seen[item.key]) return null;
      seen[item.key] = true;
      var lineProof = byKey[item.key];
      if (!lineProof || numericId(item.variant_id) <= 0 ||
          numericId(item.variant_id) !== numericId(lineProof.variant_id) ||
          !Number.isInteger(item.quantity) || item.quantity <= 0 ||
          item.quantity !== lineProof.quantity ||
          !sameMoney(item.original_line_price, lineProof.original_line_price) ||
          !sameMoney(item.final_line_price, lineProof.final_line_price) ||
          !Array.isArray(item.line_level_discount_allocations) ||
          !Array.isArray(lineProof.allocations) ||
          item.line_level_discount_allocations.length !== lineProof.allocations.length) return null;

      var allocations = [];
      for (var allocationIndex = 0; allocationIndex < lineProof.allocations.length; allocationIndex += 1) {
        var allocation = item.line_level_discount_allocations[allocationIndex];
        var allocationProof = lineProof.allocations[allocationIndex];
        var application = allocation && allocation.discount_application;
        if (!allocationProof || !application ||
            !sameMoney(allocation.amount, allocationProof.amount) ||
            typeof application.title !== 'string' || application.title !== allocationProof.title) return null;
        if (allocationProof.type !== undefined && allocationProof.type !== null &&
            typeof allocationProof.type !== 'string') return null;
        var ajaxType = application.type;
        if (ajaxType !== undefined && ajaxType !== null && typeof ajaxType !== 'string') return null;
        var typeMissing = ajaxType === undefined || ajaxType === null || ajaxType === '';
        var proofTypeMissing = allocationProof.type === undefined || allocationProof.type === null || allocationProof.type === '';
        // Reject conflicting explicit types; an omitted Liquid type must not
        // discard the stronger, explicit type returned by the same mutation.
        if (!typeMissing && !proofTypeMissing && ajaxType !== allocationProof.type) return null;
        var mergedApplication = Object.assign({}, application);
        if (typeMissing) {
          mergedApplication.type = typeof allocationProof.type === 'string' ? allocationProof.type : '';
          mergedApplication._mekhann_type_source = 'liquid';
        }
        allocations.push(Object.assign({}, allocation, { discount_application: mergedApplication }));
      }
      merged.push(Object.assign({}, item, { line_level_discount_allocations: allocations }));
    }
    return merged;
  }

  function readCarrierContext() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var url = root.replace(/\/?$/, '/') + 'cart?view=mekhann-carrier&t=' + Date.now();
    return requestJson(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      // Request the Liquid view. Shopify negotiates application/json as the
      // standard cart response and skips this view; its rendered body is JSON.
      headers: { 'Accept': 'text/html' }
    });
  }

  function attachCarrierMappings(cart, retry, suppliedContext) {
    if (!cart || !Array.isArray(cart.items)) {
      throw new Error('Your bag could not be checked. Please refresh before checkout.');
    }
    if (!cart.items.length) {
      cart._mekhann_carrier_mappings = {};
      cart._mekhann_carrier_options = {};
      return Promise.resolve(cart);
    }
    var sections = cartSections();
    var bundledContext = arguments.length < 3 && sections ? sections.context(cart) : null;
    var bundledProof = Boolean(bundledContext || arguments[3]);
    var fallbackStarted = false;
    function retryFreshProof() {
      fallbackStarted = true;
      return getCart(true).catch(function (error) {
        error.mekhannContextRetried = true;
        throw error;
      });
    }
    var contextRead = arguments.length > 2 ? Promise.resolve(suppliedContext) :
      bundledContext ? Promise.resolve(bundledContext) : readCarrierContext();
    return contextRead.then(function (context) {
      if (!context || [2, 3, 4].indexOf(context.version) === -1 || !Array.isArray(context.items) || !Array.isArray(context.mappings)) {
        throw new Error('Shade carrier options could not be loaded. Please refresh your bag.');
      }
      // The Liquid view supplies actual variant metafields, which /cart.js
      // does not expose. Reject a view from a different cart revision.
      var mergedItems = mergeDiscountTypes(cart, context);
      if (!mergedItems || cartIdentity(cart.items) !== cartIdentity(context.items)) {
        if (!retry) return retryFreshProof();
        throw new Error('Your bag is still updating. Please try again in a moment.');
      }
      var mappings = {};
      var allOptions = {};
      context.mappings.forEach(function (mapping) {
        var parentId = numericId(mapping.parent_variant_id);
        var carrierId = numericId(mapping.carrier_variant_id);
        if (!(parentId > 0) || !(carrierId > 0) || parentId === carrierId ||
            (mappings[parentId] && mappings[parentId] !== carrierId)) {
          throw new Error('Shade carrier options could not be confirmed. Please contact an advisor.');
        }
        mappings[parentId] = carrierId;
        var options = Array.isArray(mapping.options) ? mapping.options : [];
        var optionIds = Object.create(null);
        options = options.map(function (option) {
          if (!option || !Number.isSafeInteger(option.id) || option.id <= 0 || optionIds[option.id] ||
              typeof option.label !== 'string' || typeof option.available !== 'boolean' ||
              typeof option.recommended !== 'boolean' || ['uk_eu', 'us'].indexOf(option.fitting) === -1) {
            throw new Error('Shade carrier choices could not be confirmed. Please refresh your bag.');
          }
          optionIds[option.id] = true;
          return option;
        });
        if (allOptions[parentId] && JSON.stringify(allOptions[parentId]) !== JSON.stringify(options)) {
          throw new Error('Shade carrier choices changed while your bag was loading.');
        }
        allOptions[parentId] = options;
      });
      var selectionKeys = Object.create(null);
      context.items.forEach(function (proof) { selectionKeys[proof.key] = proof.selection_key || ''; });
      mergedItems.forEach(function (item) { item._mekhann_parent_selection_key = selectionKeys[item.key]; });
      cart.items = mergedItems;
      cart._mekhann_carrier_mappings = mappings;
      cart._mekhann_carrier_options = allOptions;
      return cart;
    }).catch(function (error) {
      // A malformed bundled proof is a rendering/read failure, not a reason
      // to replay the write. Retry the established fresh read pair once.
      if (bundledProof && !retry && !fallbackStarted) return retryFreshProof();
      throw error;
    });
  }

  function getCart(retry, mutationResponse) {
    var url = route('cart', 'cart.js');
    url += (url.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now();

    var cartRead = requestJson(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
    // These are independent reads, not mutations. Pair them within this call
    // only: the existing revision, currency, price and allocation checks still
    // have to agree, with one fresh pair on mismatch. No cross-action cache.
    var sections = cartSections();
    var bundledContext = mutationResponse && sections ? sections.context(mutationResponse) : null;
    var contextRead = (bundledContext ? Promise.resolve(bundledContext) : readCarrierContext()).then(function (context) {
      return { context: context };
    }, function (error) { return { error: error }; });
    return cartRead.then(function (cart) {
      if (mutationResponse && sections) sections.carry(mutationResponse, cart);
      // An empty cart needs no mapping/discount evidence. Its independent proof
      // request already has an error handler and cannot delay empty-cart use.
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
        return attachCarrierMappings(cart, retry === true, null).then(observeCarrierPreferences);
      }
      return contextRead.then(function (proof) {
        if (proof.error) throw proof.error;
        return attachCarrierMappings(cart, retry === true, proof.context, Boolean(bundledContext)).then(observeCarrierPreferences);
      });
    }).then(checkPendingPdpCart);
  }

  function delay(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function discountFailureReason(item, cart) {
    var allocations = item && Array.isArray(item.line_level_discount_allocations)
      ? item.line_level_discount_allocations
      : [];

    if (allocations.length > 1) return 'NC-MULTI-ALLOC';
    if (allocations.length === 0) {
      var parent = resolveParent(cart, item);
      if (discountAllocations(parent).length) return 'NC-PARENT-ALLOCATED';
      return Number(item && item.final_line_price) === 0
        ? 'NC-ZERO-UNPROVEN'
        : 'NC-CHARGED-NO-DISCOUNT';
    }

    var allocation = allocations[0] || {};
    var application = allocation.discount_application || {};
    if (!hasSupportedDiscountEvidence(application)) return 'NC-TYPE';
    if (Number(allocation.amount) !== Number(item && item.original_line_price)) return 'NC-AMOUNT';
    return 'NC-ZERO-UNPROVEN';
  }

  function issueReasonCode(issue, item, cart) {
    if (issue === 'not-complimentary') return discountFailureReason(item, cart);
    if (issue === 'parent-price-changed') return 'NC-PARENT-PRICE';
    if (issue === 'orphan' || issue === 'wrong-parent' || issue === 'unsupported-parent-quantity') {
      return 'NC-PARENT-ONLY';
    }
    if (issue === 'excess-carrier-quantity') return 'NC-QUANTITY';
    if (issue === 'existing-carrier-changed') return 'NC-EXISTING-CARRIER';
    return 'NC-LINK';
  }

  function failureSnapshot(issue, item, cart, phase) {
    var parent = resolveParent(cart, item);

    return {
      build: BUILD,
      phase: phase || 'reconcile',
      issue: issue || 'unknown',
      reasonCode: issueReasonCode(issue, item, cart),
      capturedAt: new Date().toISOString(),
      carrier: {
        lineKey: item && item.key || '',
        operationToken: normaliseProperties(item && item.properties)._mekhann_pilot_token || '',
        variantId: numericId(item && item.variant_id),
        quantity: Number(item && item.quantity || 0),
        originalLinePrice: Number(item && item.original_line_price || 0),
        finalLinePrice: Number(item && item.final_line_price || 0),
        hasNativeParentRelationship: Boolean(nativeParentKey(item)),
        allocations: discountAllocations(item)
      },
      parent: {
        found: Boolean(parent),
        variantId: numericId(parent && parent.variant_id),
        quantity: parent ? parentQuantity(cart, parent) : 0,
        lineQuantity: Number(parent && parent.quantity || 0),
        originalLinePrice: Number(parent && parent.original_line_price || 0),
        finalLinePrice: Number(parent && parent.final_line_price || 0),
        allocations: discountAllocations(parent)
      },
      cart: {
        itemCount: Number(cart && cart.item_count || 0),
        totalPrice: Number(cart && cart.total_price || 0),
        totalDiscount: Number(cart && cart.total_discount || 0)
      }
    };
  }

  function recordCarrierFailure(issue, item, cart, phase) {
    var snapshot = failureSnapshot(issue, item, cart, phase);
    snapshot.status = phase === 'reconcile' ? 'cleanup-pending' : 'active';
    saveCarrierDiagnostic(snapshot);

    if (window.console && typeof window.console.warn === 'function') {
      window.console.warn('[Mekhann carrier pilot]', snapshot);
    }

    return snapshot;
  }

  function saveCarrierDiagnostic(snapshot) {
    window.__mekhannCarrierPilotLastFailure = snapshot;

    try {
      window.sessionStorage.setItem('mekhannCarrierPilotLastFailure', JSON.stringify(snapshot));
    } catch (storageError) {
      // Diagnostics remain available on window when sessionStorage is unavailable.
    }

  }

  function recordCleanupFailure(snapshot, error) {
    if (window.__mekhannCarrierPilotLastFailure !== snapshot) return;
    var failed = Object.assign({}, snapshot, {
      status: 'active', cleanupFailedAt: new Date().toISOString(),
      cleanupError: error && error.message || 'Carrier cleanup could not be confirmed.'
    });
    saveCarrierDiagnostic(failed);
    if (window.console && typeof window.console.warn === 'function') {
      window.console.warn('[Mekhann carrier cleanup failed]', failed);
    }
  }

  function recordCarrierRecovery(cart) {
    var snapshot = window.__mekhannCarrierPilotLastFailure;
    if (!snapshot || snapshot.status === 'recovered' || !snapshot.carrier ||
        !Array.isArray(cart && cart.items)) return;
    var identity = snapshot.carrier;
    if (!identity.lineKey && !identity.operationToken) return;
    var remaining = cart.items.filter(function (item) {
      return item.key === identity.lineKey || identity.operationToken &&
        normaliseProperties(item.properties)._mekhann_pilot_token === identity.operationToken;
    });
    if (remaining.some(function (item) { return !isKnownPilotLine(item) || getPilotLineIssue(cart, item); })) return;
    var recovered = Object.assign({}, snapshot, {
      status: 'recovered', resolvedAt: new Date().toISOString(),
      resolution: { scope: 'server-cart', action: remaining.length ? 'revalidated' : 'removed',
        itemCount: Number(cart.item_count || 0), totalPrice: Number(cart.total_price || 0) }
    });
    saveCarrierDiagnostic(recovered);
    if (window.console && typeof window.console.info === 'function') {
      window.console.info('[Mekhann carrier recovery]', recovered);
    }
  }

  function clearCarrierFailure() {
    window.__mekhannCarrierPilotLastFailure = null;

    try {
      if (window.sessionStorage && typeof window.sessionStorage.removeItem === 'function') {
        window.sessionStorage.removeItem('mekhannCarrierPilotLastFailure');
      }
    } catch (storageError) {
      // A successful validation is still authoritative when storage is unavailable.
    }
  }

  function postChange(lineKey, quantity) {
    return requestJson(route('cartChange', 'cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (cart) {
      return attachCarrierMappings(cart, false);
    }).then(function (cart) {
      return pendingPdpRecord && pendingPdpRecord.tokenSource === 'prior-ajax-token' ? checkPendingPdpCart(cart) : cart;
    });
  }

  function reconcileCart(initialCart, canMutate) {
    var removed = [];
    var retriedTokens = {};
    var changeLimit = null;

    function next(cart) {
      if (changeLimit === null) changeLimit = Math.max(MAX_RECONCILE_REMOVALS, cart.items.length + 1);
      var invalid = findInvalidPilotLine(cart);
      if (!invalid) return Promise.resolve({ cart: cart, removed: removed, deferred: false });

      var properties = normaliseProperties(invalid.item.properties);
      var retryIdentity = properties._mekhann_pilot_token || invalid.item.key || 'unknown';
      if (invalid.issue === 'not-complimentary' && !retriedTokens[retryIdentity]) {
        retriedTokens[retryIdentity] = true;
        return delay(250).then(getCart).then(next);
      }

      if (removed.length >= changeLimit) {
        throw new Error('The complimentary shade carrier could not be validated safely.');
      }

      if (!invalid.item.key) {
        throw new Error('The complimentary shade carrier is missing required bag data.');
      }

      if (canMutate && !canMutate()) {
        return Promise.resolve({ cart: cart, removed: removed, deferred: true });
      }

      var diagnostic = recordCarrierFailure(invalid.issue, invalid.item, cart, 'reconcile');

      if (canMutate && !canMutate()) {
        return Promise.resolve({ cart: cart, removed: removed, deferred: true });
      }

      var targetQuantity = invalid.issue === 'excess-carrier-quantity' ? invalid.targetQuantity : 0;
      return postChange(invalid.item.key, targetQuantity).then(function (updatedCart) {
        recordCarrierRecovery(updatedCart);
        removed.push({
          key: invalid.item.key,
          token: properties._mekhann_pilot_token || '',
          issue: invalid.issue,
          reasonCode: diagnostic.reasonCode,
          previousQuantity: Number(invalid.item.quantity),
          quantity: targetQuantity
        });
        return next(updatedCart);
      }).catch(function (error) {
        recordCleanupFailure(diagnostic, error);
        throw error;
      });
    }

    return (initialCart ? Promise.resolve(initialCart) : getCart()).then(next);
  }

  function stableValue(value) {
    if (Array.isArray(value)) return value.map(stableValue);
    if (!value || typeof value !== 'object') return value;
    var sorted = Object.create(null);
    Object.keys(value).sort().forEach(function (key) { sorted[key] = stableValue(value[key]); });
    return sorted;
  }

  // Shopify version:1 Liquid proof escapes cart attributes, line properties
  // and cart.note. Real saved-preview captures cover these fields. Compare raw
  // Ajax text in that representation exactly once; never decode proof text or
  // mutate either cart. Literal "&quot;" must remain distinct from a quote.
  function renderCartText(value, rendered) {
    if (typeof value !== 'string') return null;
    if (rendered) return value;
    var entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return value.replace(/[&<>"']/g, function(character) { return entities[character]; });
  }

  function renderCartAttributes(attributes, rendered) {
    if (!attributes || typeof attributes !== 'object' || Array.isArray(attributes)) return null;
    var output = Object.create(null);
    var keys = Object.keys(attributes);
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = renderCartText(attributes[key], rendered);
      if (value === null) return null;
      output[renderCartText(key, rendered)] = value;
    }
    return output;
  }

  function renderCartFingerprint(cart, fields, rendered) {
    var currency = cart && cart.currency && (typeof cart.currency === 'string' ? cart.currency : cart.currency.iso_code);
    if (!cart || !Array.isArray(cart.items) || typeof currency !== 'string' ||
        !validMoney(cart.total_price) || !validMoney(cart.total_discount)) return '';
    if (rendered && cart.version !== 1) return '';
    var attributes = renderCartAttributes(rendered ? cart.attributes : (cart.attributes || {}), rendered);
    if (!attributes) return '';
    var note = renderCartText(cart.note == null ? '' : cart.note, rendered);
    if (note === null) return '';
    var propertyMaps = cart.items.map(function (item) {
      return renderCartAttributes(item.properties == null ? {} : item.properties, rendered);
    });
    if (propertyMaps.some(function (properties) { return properties === null; })) return '';
    var lines = cart.items.map(function (item, index) {
      return { key: item.key, variant: numericId(item.variant_id), product: numericId(item.product_id), quantity: item.quantity,
        original: item.original_line_price, final: item.final_line_price,
        properties: propertyMaps[index], parent: nativeParentKey(item),
        sellingPlan: numericId(item.selling_plan_allocation && (item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || item.selling_plan_allocation.selling_plan_id)),
        allocations: (item.line_level_discount_allocations || []).map(function (allocation) {
          // The prior Liquid context has already proven the automatic type.
          // The render snapshot must retain exactly those amounts/titles.
          return { amount: allocation.amount, title: allocation.discount_application && allocation.discount_application.title || '' };
        }).sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); }) };
    }).sort(function (a, b) { return String(a.key).localeCompare(String(b.key)); });
    return JSON.stringify(stableValue({ currency: currency,
      total: cart.total_price, discount: cart.total_discount, note: note,
      shipping: Boolean(cart.requires_shipping), taxes: fields && !fields.taxes ? null : Boolean(cart.taxes_included),
      orderDiscounts: (cart.cart_level_discount_applications || []).map(function (discount) {
        return { title: discount.title || '', amount: discount.total_allocated_amount };
      }).sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); }),
      attributes: attributes, lines: lines }));
  }

  function renderedProofMatches(token, renderedCart) {
    if (token && token.guard) {
      try { token.guard(); } catch (error) { return false; }
    }
    return Boolean(token && activeRender === token && token.stamp === generationStamp() &&
      (!renderedCart || !renderedCart.token || !token.cartToken || renderedCart.token === token.cartToken) &&
      !externalMutationPending && token.fingerprint && token.fingerprint === renderCartFingerprint(renderedCart, token.fields, true));
  }

  function canCommitRender(token, renderedCart) {
    // This is the synchronous pre-commit boundary. Drain and process older
    // structural edits first, so an unrelated removal cannot be mistaken for
    // the following owned clear/append records.
    cartObservers.forEach(function (entry) {
      var pending = entry.observer.takeRecords();
      if (pending.length) entry.handle(pending);
    });
    return renderedProofMatches(token, renderedCart);
  }

  function acceptRenderedProof(detail) {
    if (!detail || !detail.products || !renderedProofMatches(detail.renderToken, detail.renderedCart)) return false;
    var token = detail.renderToken;
    if (token.products.indexOf(detail.products) === -1) token.products.push(detail.products);
    cartObservers.forEach(function (entry) {
      if (entry.products !== detail.products) return;
      var records = entry.observer.takeRecords();
      // Own only the synchronous top-level replacement. Any other structural
      // edits still go through the ordinary unknown-render verification path.
      var unknown = records.filter(function (record) {
        if (record.target !== detail.products) return true;
        var currentItems = detail.products.querySelector('.cart__items');
        return Array.prototype.some.call(record.addedNodes || [], function (node) {
          return cartStructureNode(node) && node !== currentItems;
        });
      });
      if (unknown.length) entry.handle(unknown);
    });
    return true;
  }

  function refreshCart(cart, guard) {
    if (guard) { try { guard(); } catch (error) { return Promise.reject(error); } }
    pilotLinePresent = Boolean(cart && Array.isArray(cart.items) && cart.items.some(isKnownPilotLine));
    syncCheckoutGuards();
    var renders = [];
    // Ajax omits taxes_included in some responses. In that case the rendered
    // Liquid field is authoritative footer copy, not an invented false value;
    // every payable amount and discount remains in the compared projection.
    var fields = { taxes: typeof (cart && cart.taxes_included) === 'boolean' };
    var renderToken = { stamp: generationStamp(), cartToken: cart && cart.token, fields: fields, fingerprint: renderCartFingerprint(cart, fields), products: [], guard: guard || null };
    activeRender = renderToken;
    document.dispatchEvent(new CustomEvent('cart:build', {
      detail: { source: BUILD, carrierGeneration: cartMutationGeneration, carrierSignal: cartSignalGeneration, carrierExternalGeneration: externalMutationGeneration, renderToken: renderToken, markup: cartSections() ? cartSections().markup(cart) : null, renderPromises: renders }
    }));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart, source: BUILD }
    }));
    // V2.26.1: dispatching a build starts an asynchronous HTML replacement.
    // Resolve a bounded result, including when an older theme has no consumer;
    // fire-and-forget reconciliation callers must not create rejected promises.
    if (!renders.length) {
      renderVerificationPending = true;
      unverifiedMutation = true;
      document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
        form.setAttribute('data-mekhann-cart-unverified', 'true');
      });
      return Promise.resolve(false);
    }
    return Promise.all(renders.map(function (operation) {
      return Promise.resolve(operation).then(function (rendered) { return rendered === true; }, function () { return false; });
    })).then(function (results) {
      if (guard) guard();
      var rendered = results.every(function (value) { return value; });
      if (!rendered) { renderVerificationPending = true; unverifiedMutation = true; syncCheckoutGuards(); }
      if (rendered && activeRender === renderToken && renderToken.stamp === generationStamp() && renderToken.products.length) {
        renderVerificationPending = false;
        lastRenderReceipt = { stamp: renderToken.stamp, extrasRevision: cartExtras ? cartExtras.revision() : 0 };
      }
      return rendered;
    });
  }

  function requireCartRefresh(cart, guard) {
    var generation = cartMutationGeneration;
    var externalGeneration = externalMutationGeneration;
    return refreshCart(cart, guard).then(function (rendered) {
      if (guard) guard();
      if (!rendered) throw new Error('Your bag could not be refreshed. Please refresh it before continuing.');
      if (generation !== cartMutationGeneration || externalGeneration !== externalMutationGeneration || externalMutationPending) {
        throw new Error('Your bag changed during confirmation. Please wait for it to finish updating.');
      }
      if (!reconcileAfterMutation) { renderVerificationPending = false; return cart; }
      // Structural replacement requires fresh proof. Keep that proof inside
      // the current action, before success/ready, rather than letting a timer
      // re-lock the bag after the action has apparently finished.
      reconcileAfterMutation = false;
      window.clearTimeout(reconcileTimer);
      var signal = cartSignalGeneration;
      return getCart().then(function (confirmed) {
        if (guard) guard();
        var sameCart = cartIdentity(cart.items) === cartIdentity(confirmed.items) &&
          cart.currency === confirmed.currency &&
          sameMoney(cart.total_price, confirmed.total_price) &&
          sameMoney(cart.total_discount, confirmed.total_discount) &&
          String((cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] || '') ===
            String((confirmed.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] || '') &&
          !protectedCartIssue(confirmed, commerceSnapshot(cart)) &&
          !protectedCartIssue(cart, commerceSnapshot(confirmed)) &&
          !findInvalidPilotLine(confirmed);
        if (!sameCart || generation !== cartMutationGeneration ||
            externalGeneration !== externalMutationGeneration || externalMutationPending ||
            signal !== cartSignalGeneration || reconcileAfterMutation) {
          throw new Error('Your bag changed during confirmation. Please wait for it to finish updating.');
        }
        pilotLinePresent = confirmed.items.some(isKnownPilotLine);
        renderVerificationPending = false;
        return confirmed;
      }).catch(function (error) {
        unverifiedMutation = true;
        reconcileAfterMutation = true;
        throw error;
      });
    });
  }

  function resumeDeferredReconcile() {
    if (!reconcileAfterMutation) return;
    reconcileAfterMutation = false;
    scheduleReconcile(true);
  }

  function publishNotice(message) {
    document.dispatchEvent(new CustomEvent('mekhann:notice', {
      detail: {
        message: message,
        showCartLink: true
      }
    }));
  }

  function cleanupNotice(removed) {
    if (removed && removed.length && removed.every(function (entry) { return entry.issue === 'excess-carrier-quantity'; })) {
      return 'Shade carrier quantities were adjusted to match the lampshades in your bag.';
    }
    if (removed && removed.some(function (entry) { return entry.issue === 'orphan'; })) {
      return 'The shade carrier was removed because its matching lampshade is no longer in your bag.';
    }
    return 'The shade carrier could not be confirmed as complimentary and was removed. Your lampshade remains in the bag.';
  }

  function restorePendingPdpAdd() {
    try {
      var saved = window.sessionStorage && window.sessionStorage.getItem(PDP_PENDING_KEY);
      if (!saved) return;
      var record = JSON.parse(saved);
      if (!record || record.version !== 1 || typeof record.cartToken !== 'string' || !record.cartToken ||
          typeof record.token !== 'string' || !record.token || !positiveQuantity(record.quantity) ||
          (record.tokenSource !== undefined && record.tokenSource !== 'prior-ajax-token') ||
          (record.tokenSource === 'prior-ajax-token' && (!Number.isSafeInteger(record.requestedCarrierVariantId) || record.requestedCarrierVariantId <= 0)) ||
          (record.requiresOff !== undefined && (record.tokenSource !== 'prior-ajax-token' || typeof record.requiresOff !== 'boolean')) ||
          !record.protection || !record.protection.products || !record.protection.carriers || !record.parent) {
        throw new Error('The previous fitting request could not be restored.');
      }
      pendingPdpRecord = record;
      restoredPdpPending = true;
      pendingAddToken = record.token;
      pendingAddQuantity = record.quantity;
      pendingAddProtection = record.protection;
      pendingAddRollback = true;
      pendingPdpUncertain = record.requiresOff !== false;
      unverifiedMutation = true;
      pilotLinePresent = true;
    } catch (error) {
      pdpRecoveryFault = true;
      unverifiedMutation = true;
    }
  }

  function priorCartToken(cart) {
    var sections = cartSections();
    return sections && typeof sections.priorToken === 'function' ? sections.priorToken(cart) : '';
  }

  // Native batches own a separate journal. They must never enter the older
  // carrier-only rollback/grow pipeline: the parent was sent in the same POST.
  function nativeObject(value) { return value && typeof value === 'object' && !Array.isArray(value); }
  function nativeStable(value) {
    if (Array.isArray(value)) return value.map(nativeStable);
    if (!nativeObject(value)) return value;
    var sorted = Object.create(null);
    Object.keys(value).sort().forEach(function (key) { sorted[key] = nativeStable(value[key]); });
    return sorted;
  }
  function nativeEqual(a, b) { return JSON.stringify(nativeStable(a)) === JSON.stringify(nativeStable(b)); }
  function nativeClone(value) { return JSON.parse(JSON.stringify(value)); }
  function nativeGroupProperties(properties) {
    return nativeObject(properties) && Object.keys(properties).length === 1 &&
      typeof properties._mekhann_fitting_group === 'string' && /^[A-Za-z0-9_-]{8,120}$/.test(properties._mekhann_fitting_group);
  }
  function nativeBatchDescriptorMatches(parent, descriptor) {
    return Boolean(parent && descriptor && cartGroups() && !nativeParentKey(parent) &&
      (nativeGroupProperties(parent.properties) || groupedParentProperties(parent.properties)) && nativeEqual(cartGroups().selectionDescriptor(parent), descriptor));
  }
  function nativeLineEvidence(item) {
    var plan = item && item.selling_plan_allocation;
    return { key: item.key, variantId: numericId(item.variant_id || item.id), productId: numericId(item.product_id),
      quantity: item.quantity, properties: item.properties || {}, parentKey: nativeParentKey(item),
      sellingPlanId: numericId(plan && (plan.selling_plan && plan.selling_plan.id || plan.selling_plan_id)),
      originalPrice: item.original_price, finalPrice: item.final_price,
      originalLinePrice: item.original_line_price, finalLinePrice: item.final_line_price,
      allocations: (item.line_level_discount_allocations || []).map(function (allocation) {
        var application = allocation.discount_application || {};
        return { amount: allocation.amount, type: application.type == null ? '' : application.type, title: application.title || '' };
      }) };
  }
  function validNativeLineEvidence(line) {
    return nativeObject(line) && typeof line.key === 'string' && Boolean(line.key) &&
      Number.isSafeInteger(line.variantId) && line.variantId > 0 && Number.isSafeInteger(line.productId) && line.productId > 0 &&
      Number.isSafeInteger(line.quantity) && line.quantity > 0 && nativeObject(line.properties) &&
      typeof line.parentKey === 'string' && Number.isSafeInteger(line.sellingPlanId) && line.sellingPlanId >= 0 &&
      ['originalPrice', 'finalPrice', 'originalLinePrice', 'finalLinePrice'].every(function (key) { return validMoney(line[key]); }) &&
      Array.isArray(line.allocations) && line.allocations.every(function (allocation) {
        return nativeObject(allocation) && validMoney(allocation.amount) && typeof allocation.type === 'string' && typeof allocation.title === 'string';
      });
  }
  function nativeBaseline(cart) {
    return { currency: cart.currency, totalPrice: cart.total_price, totalDiscount: cart.total_discount,
      itemCount: cart.item_count, note: cart.note || '', attributes: nativeClone(cart.attributes || {}),
      items: cart.items.map(nativeLineEvidence) };
  }
  function validNativeBaseline(baseline) {
    return nativeObject(baseline) && typeof baseline.currency === 'string' && Boolean(baseline.currency) &&
      validMoney(baseline.totalPrice) && validMoney(baseline.totalDiscount) && Number.isSafeInteger(baseline.itemCount) && baseline.itemCount >= 0 &&
      typeof baseline.note === 'string' && nativeObject(baseline.attributes) && Array.isArray(baseline.items) &&
      baseline.items.every(validNativeLineEvidence) &&
      new Set(baseline.items.map(function (item) { return item.key; })).size === baseline.items.length &&
      baseline.items.reduce(function (sum, item) { return sum + item.quantity; }, 0) === baseline.itemCount &&
      baseline.items.reduce(function (sum, item) { return sum + item.finalLinePrice; }, 0) === baseline.totalPrice &&
      baseline.items.reduce(function (sum, item) { return sum + item.originalLinePrice - item.finalLinePrice; }, 0) === baseline.totalDiscount;
  }
  function nativeBatchItems(record) {
    var parentProperties = Object.create(null);
    record.parentDescriptor.properties.forEach(function (pair) { parentProperties[pair[0]] = pair[1]; });
    if (record.version === 2 && record.carrierVariantId === 0) {
      return [{ id: record.parentVariantId, quantity: record.quantity, properties: parentProperties }];
    }
    var child = { id: record.carrierVariantId, quantity: record.quantity, properties: {
      _mekhann_addon_type: 'shade_carrier', _mekhann_carrier_pilot: PILOT_MARKER,
      _mekhann_parent_variant_id: String(record.parentVariantId),
      _mekhann_parent_group: JSON.stringify(record.parentDescriptor), _mekhann_pilot_token: record.token
    } };
    if (record.kind === 'grouped') {
      child.properties._mekhann_grouped_batch = 'V1';
      child.properties._mekhann_fitting_group = parentProperties._mekhann_fitting_group;
    } else {
      child.parent_id = record.parentVariantId;
      child.properties._mekhann_native_batch = NATIVE_BATCH_MARKER;
    }
    return [{ id: record.parentVariantId, quantity: record.quantity, properties: parentProperties }, child];
  }
  function provisionalFreeCarrier(item) {
    if (!isCurrentPilotLine(item) || !positiveQuantity(item.quantity) || !validMoney(item.original_price) || item.original_price <= 0 ||
        item.original_line_price !== item.original_price * item.quantity || item.final_price !== 0 || item.final_line_price !== 0 ||
        !Array.isArray(item.line_level_discount_allocations) || item.line_level_discount_allocations.length !== 1) return false;
    var allocation = item.line_level_discount_allocations[0], application = allocation.discount_application || {};
    // Eligibility only, never a FREE proof: the final Ajax cart and matched
    // Liquid allocation must still validate. Do not fabricate automatic type.
    return allocation.amount === item.original_line_price && typeof application.title === 'string' && Boolean(application.title) &&
      (application.type == null || application.type === '' || application.type === 'automatic');
  }
  function validNativeRecord(record) {
    if (record && record.version === 2) return validScopedNativeRecord(record);
    if (!nativeObject(record) || record.version !== 1 || (record.kind !== undefined && record.kind !== 'grouped') || ['prepared', 'sent'].indexOf(record.phase) === -1 || typeof record.token !== 'string' || !record.token ||
        (record.purpose !== undefined && (record.purpose !== 'quantity-plus' || record.kind !== 'grouped' || record.quantity !== 1)) ||
        typeof record.originalCartToken !== 'string' || !record.originalCartToken || typeof record.originalCartWasEmpty !== 'boolean' ||
        typeof record.acknowledged !== 'boolean' || (record.boundCartToken !== null && (typeof record.boundCartToken !== 'string' || !record.boundCartToken)) ||
        (record.followValue !== null && (typeof record.followValue !== 'string' || !record.followValue)) ||
        (record.cleanup !== null && (!nativeObject(record.cleanup) || !Number.isSafeInteger(record.cleanup.parentQuantity) || record.cleanup.parentQuantity < 0 || record.cleanup.parentQuantity > record.quantity ||
          (record.cleanup.offSent !== undefined && typeof record.cleanup.offSent !== 'boolean') ||
          (record.cleanup.offValue !== null && (typeof record.cleanup.offValue !== 'string' || !record.cleanup.offValue)))) ||
        !nativeObject(record.outcome) || !Number.isSafeInteger(record.outcome.httpStatus) || record.outcome.httpStatus < 0 || record.outcome.httpStatus > 599 || typeof record.outcome.unknown !== 'boolean' ||
        ![record.parentVariantId, record.carrierVariantId, record.expectedProductId, record.quantity].every(function (id) { return Number.isSafeInteger(id) && id > 0; }) ||
        record.parentVariantId === record.carrierVariantId || !validNativeBaseline(record.baseline) ||
        record.originalCartWasEmpty !== (record.baseline.items.length === 0) ||
        record.baseline.items.some(function (item) { return record.kind !== 'grouped' && item.variantId === record.parentVariantId || item.properties._mekhann_pilot_token === record.token; }) ||
        !nativeObject(record.parentDescriptor) || !Array.isArray(record.parentDescriptor.properties) || record.parentDescriptor.properties.length !== (record.kind === 'grouped' ? 3 : 1)) return false;
    if (record.phase === 'prepared' && (record.acknowledged || record.boundCartToken || record.followValue || record.cleanup ||
        record.outcome.httpStatus !== 0 || !record.outcome.unknown)) return false;
    var props = Object.create(null);
    if (record.parentDescriptor.properties.some(function (pair) {
      if (!Array.isArray(pair) || pair.length !== 2 || Object.prototype.hasOwnProperty.call(props, pair[0])) return true;
      props[pair[0]] = pair[1]; return false;
    })) return false;
    var expected = cartGroups().selectionDescriptor({ variant_id: record.parentVariantId, properties: props });
    return (record.kind === 'grouped' ? groupedParentProperties(props) && Number(props._mekhann_grouped_carrier_id) === record.carrierVariantId : nativeGroupProperties(props)) && nativeEqual(expected, record.parentDescriptor) &&
      !record.baseline.items.some(function (item) { return item.properties._mekhann_fitting_group === props._mekhann_fitting_group; }) &&
      nativeEqual(record.items, nativeBatchItems(record));
  }
  // DIAG1: opt-in, bounded DOM evidence only. No cart values, identifiers,
  // customer text, property values or transaction state are exposed.
  var NATIVE_DIAGNOSTIC_BUILD = 'V2.35-DIAG1-2026-09-22';
  var nativeDiagnosticEntries = [], nativeDiagnosticSequence = 0;
  function nativeDiagnosticEnabled() {
    return Boolean(window.theme && window.theme.mekhannCartTrace && window.theme.mekhannCartTrace.enabled);
  }
  function publishNativeDiagnostic(reason, details) {
    if (!nativeDiagnosticEnabled()) return;
    try {
      document.documentElement.setAttribute('data-mekhann-native-diagnostic-build', NATIVE_DIAGNOSTIC_BUILD);
      if (typeof reason === 'string' && /^[a-zA-Z0-9 _-]{1,80}$/.test(reason)) {
        nativeDiagnosticEntries.push({sequence: ++nativeDiagnosticSequence, reason: reason, details: details || null});
        if (nativeDiagnosticEntries.length > 8) nativeDiagnosticEntries.shift();
      }
      document.documentElement.setAttribute('data-mekhann-native-diagnostic', JSON.stringify({
        version: 1, build: NATIVE_DIAGNOSTIC_BUILD, entries: nativeDiagnosticEntries
      }));
    } catch (ignore) { /* Diagnostics cannot change the transaction outcome. */ }
  }
  function nativeDiagnosticType(type) {
    return !type ? 'blank' : type === 'automatic' ? 'automatic' : type === 'discount_code' ? 'discount_code' : 'other';
  }
  function nativeExistingDiagnostic(cart, record, old, used, remapped, matchCount) {
    if (!nativeDiagnosticEnabled()) return;
    try {
      var sameVariant = cart.items.filter(function (item) { return numericId(item.variant_id || item.id) === old.variantId; });
      var sameProperties = sameVariant.filter(function (item) { return nativeEqual(item.properties || {}, old.properties); });
      var candidates = (sameProperties.length ? sameProperties : sameVariant).slice(0, 3);
      var fields = ['key', 'variantId', 'productId', 'quantity', 'properties', 'parentKey', 'sellingPlanId',
        'originalPrice', 'finalPrice', 'originalLinePrice', 'finalLinePrice', 'allocations'];
      return {
        scope: 'existing-line', matchCount: matchCount, sameVariantCount: sameVariant.length,
        samePropertiesCount: sameProperties.length, baselineLineCount: record.baseline.items.length,
        currentLineCount: cart.items.length,
        candidates: candidates.map(function (item) {
          var actual = nativeLineEvidence(item), expected = nativeClone(old);
          var rawMismatchFields = fields.filter(function (field) { return !nativeEqual(actual[field], expected[field]); });
          var allocationChecks = expected.allocations.slice(0, 3).map(function (allocation, index) {
            var current = actual.allocations[index];
            return {currentPresent: Boolean(current), amountMatches: Boolean(current && allocation.amount === current.amount),
              titleMatches: Boolean(current && allocation.title === current.title),
              beforeType: nativeDiagnosticType(allocation.type), currentType: current ? nativeDiagnosticType(current.type) : 'missing'};
          });
          var baselineAllocationCount = expected.allocations.length, currentAllocationCount = actual.allocations.length;
          if (record.kind === 'grouped') {
            expected.key = actual.key;
            if (expected.parentKey && remapped[expected.parentKey]) expected.parentKey = remapped[expected.parentKey];
            if (!isCarrierVariant(item) && !actual.parentKey && actual.originalLinePrice === actual.finalLinePrice) {
              actual.allocations = actual.allocations.filter(function (entry) { return entry.amount !== 0; });
              expected.allocations = expected.allocations.filter(function (entry) { return entry.amount !== 0; });
            }
            actual.allocations.forEach(function (allocation, index) {
              var previous = expected.allocations[index];
              if (previous && previous.type === '' && allocation.type === 'automatic') allocation.type = '';
            });
          }
          return {alreadyMatched: used.indexOf(item.key) !== -1,
            carrierLine: isCurrentPilotLine(item), complimentary: isCurrentPilotLine(item) ? isComplimentaryLine(item) : null,
            rawMismatchFields: rawMismatchFields,
            comparedMismatchFields: fields.filter(function (field) { return !nativeEqual(actual[field], expected[field]); }),
            baselineAllocationCount: baselineAllocationCount, currentAllocationCount: currentAllocationCount,
            allocationChecks: allocationChecks};
        })
      };
    } catch (ignore) { return {scope: 'existing-line', diagnosticUnavailable: true}; }
  }
  function nativeContentsDiagnostic(cart, record, expectedAttributes) {
    if (!nativeDiagnosticEnabled()) return;
    try {
      var before = record.baseline;
      return {scope: 'cart-contents', checks: {
        currencyMatches: cart.currency === before.currency, noteMatches: String(cart.note || '') === before.note,
        attributesMatch: nativeEqual(cart.attributes || {}, expectedAttributes),
        discountListValid: Array.isArray(cart.cart_level_discount_applications),
        noCartDiscounts: Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length === 0,
        unmergedLineCountMatches: cart.items.length === before.items.length + 2,
        itemCountMatches: cart.item_count === before.itemCount + record.quantity * 2,
        uniqueLineKeys: new Set(cart.items.map(function (item) { return item.key; })).size === cart.items.length
      }, counts: {beforeLines: before.items.length, currentLines: cart.items.length,
        expectedUnmergedLines: before.items.length + 2, beforeItems: before.itemCount, currentItems: cart.item_count,
        expectedItems: before.itemCount + record.quantity * 2,
        cartDiscounts: Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications.length : null}};
    } catch (ignore) { return {scope: 'cart-contents', diagnosticUnavailable: true}; }
  }
  function nativePairDiagnostic(cart, record, added, parent, children, child) {
    if (!nativeDiagnosticEnabled()) return;
    try {
      var before = record.baseline;
      return {scope: 'complete-pair', counts: {addedLines: added.length, children: children.length}, checks: {
        parentFound: Boolean(parent), childFound: Boolean(child),
        parentQuantityMatches: Boolean(parent && parent.quantity === record.quantity),
        parentProductMatches: Boolean(parent && numericId(parent.product_id) === record.expectedProductId),
        parentOriginalPriceValid: Boolean(parent && validMoney(parent.original_price) && parent.original_price > 0),
        parentFullPrice: Boolean(parent && parent.final_price === parent.original_price),
        parentOriginalLineMatches: Boolean(parent && parent.original_line_price === parent.original_price * record.quantity),
        parentFinalLineMatches: Boolean(parent && parent.final_line_price === parent.original_line_price),
        parentNoPositiveAllocations: Boolean(parent && !(parent.line_level_discount_allocations || []).some(function (allocation) { return allocation.amount !== 0; })),
        childInAddedLines: Boolean(child && added.indexOf(child) !== -1),
        childVariantMatches: Boolean(child && numericId(child.variant_id) === record.carrierVariantId),
        childQuantityMatches: Boolean(child && child.quantity === record.quantity),
        childAssociationMatches: Boolean(child && parent && batchChildMatches(cart, child, parent, record)),
        childPropertiesMatch: Boolean(child && nativeEqual(child.properties || {}, record.items[1].properties)),
        childComplimentary: Boolean(child && isComplimentaryLine(child)),
        childOriginalLineMatches: Boolean(child && child.original_line_price === child.original_price * record.quantity),
        childFinalUnitZero: Boolean(child && child.final_price === 0),
        childIssueClear: Boolean(child && !getPilotLineIssue(cart, child)),
        carrierMappingPresent: carrierOptions(cart, record.parentVariantId).some(function (option) { return option.id === record.carrierVariantId; }),
        totalPriceDeltaMatches: Boolean(parent && cart.total_price === before.totalPrice + parent.final_line_price),
        totalDiscountDeltaMatches: Boolean(child && cart.total_discount === before.totalDiscount + child.original_line_price)
      }};
    } catch (ignore) { return {scope: 'complete-pair', diagnosticUnavailable: true}; }
  }
  function nativeBatchError(reason, diagnostic) {
    ownedParentUncertain = true;
    unverifiedMutation = true;
    syncCheckoutGuards();
    var error = new Error(nativeBatchFault ? NATIVE_FAULT_MESSAGE : nativeRecoveryNeedsRefresh ? NATIVE_REFRESH_MESSAGE :
      'Your previous addition needs checking. Select Check bag in your shopping bag before continuing.');
    error.mekhannReason = reason;
    publishNativeDiagnostic(reason, diagnostic);
    if (nativeBatchRecord && validNativeRecord(nativeBatchRecord)) error.mekhannNativeBatchToken = nativeBatchRecord.token;
    return error;
  }
  function persistNativeRecord(record, unsent) {
    try {
      if (!validNativeRecord(record) || !window.sessionStorage) throw new Error();
      var encoded = JSON.stringify(record);
      window.sessionStorage.setItem(NATIVE_PENDING_KEY, encoded);
      if (window.sessionStorage.getItem(NATIVE_PENDING_KEY) !== encoded) throw new Error();
    } catch (error) {
      if (unsent) {
        // No transport can have started: prepare has not returned its payload.
        // Remove only the journal this synchronous attempt tried to create.
        try {
          // At the sent transition the form partner already exists. Prune it
          // first so an interrupted unsent cancellation leaves a native journal.
          clearNativeFormAttempt(record);
          // A failed native readback must not prevent removing our own write.
          window.sessionStorage.removeItem(NATIVE_PENDING_KEY);
          if (window.sessionStorage.getItem(NATIVE_PENDING_KEY)) throw new Error();
        } catch (storageError) { /* Storage unavailable; no request was sent. */ }
        throw new Error('Your combined request could not be saved. No items were added; please try again.');
      }
      nativeBatchFault = true; throw nativeBatchError('saved request');
    }
    nativeBatchRecord = record;
    ownedParentUncertain = true;
    unverifiedMutation = true;
  }
  function clearNativeFormAttempt(record) {
    var saved = window.sessionStorage.getItem(NATIVE_FORM_PENDING_KEY);
    var attempts = JSON.parse(saved || '[]');
    if (!Array.isArray(attempts)) throw new Error();
    var kept = attempts.filter(function (attempt) {
      return !(attempt && attempt.fittingIntent && attempt.fittingIntent.nativeBatch && attempt.fittingIntent.nativeBatch.token === record.token);
    });
    if (kept.length === attempts.length) return;
    if (kept.length) window.sessionStorage.setItem(NATIVE_FORM_PENDING_KEY, JSON.stringify(kept));
    else window.sessionStorage.removeItem(NATIVE_FORM_PENDING_KEY);
    if (!nativeEqual(JSON.parse(window.sessionStorage.getItem(NATIVE_FORM_PENDING_KEY) || '[]'), kept)) throw new Error();
  }
  function restoreNativeBatch() {
    try {
      var encoded = window.sessionStorage && window.sessionStorage.getItem(NATIVE_PENDING_KEY);
      if (!encoded) return;
      var record = JSON.parse(encoded);
      if (!validNativeRecord(record) || pendingPdpRecord || pendingAddToken || pdpRecoveryFault) throw new Error();
      if (record.phase === 'prepared') {
        // Transport is forbidden until markNativeBatchSent commits. Clear the
        // matching form journal first, preserving every unrelated attempt.
        clearNativeFormAttempt(record);
        window.sessionStorage.removeItem(NATIVE_PENDING_KEY);
        if (window.sessionStorage.getItem(NATIVE_PENDING_KEY)) throw new Error();
        nativeAbandonedTokens.push(record.token);
        return;
      }
      nativeBatchRecord = record;
      ownedParentUncertain = true;
      unverifiedMutation = true;
    } catch (error) { nativeBatchFault = true; ownedParentUncertain = true; unverifiedMutation = true; }
  }
  function clearNativeBatch(owner, record) {
    if (!record || nativeBatchRecord !== record || !ownedCurrent(owner)) throw nativeBatchError('request owner');
    try {
      // Retain the authoritative native journal until its form partner has
      // been removed. A crash between removals can reconstruct and reverify it.
      clearNativeFormAttempt(record);
      window.sessionStorage.removeItem(NATIVE_PENDING_KEY);
      if (window.sessionStorage.getItem(NATIVE_PENDING_KEY)) throw new Error();
    } catch (error) { nativeBatchFault = true; throw nativeBatchError('completion record'); }
    nativeBatchRecord = null;
    nativeBatchFault = false;
    nativeResolvedTokens.push(record.token);
    if (nativeResolvedTokens.length > 20) nativeResolvedTokens.shift();
    nativeRecoveryMessage = '';
    nativeRecoveryNeedsRefresh = false;
    ownedParentUncertain = false;
    unverifiedMutation = false;
    owner.nativeBatchResolved = record.token;
  }
  function prepareNativeBatch(owner, intent, choices, cart) {
    if (!ownedCurrent(owner) || owner.parentRecovery || nativeBatchRecord || nativeBatchFault || pendingAddToken || pendingPdpRecord ||
        pdpRecoveryFault || ownedParentUncertain || ownedQuantityUncertain || pendingReductionProtection || !intent || intent.edit ||
        !Array.isArray(choices) || choices.length !== 1 || !cart || !Array.isArray(cart.items) || priorCartToken(cart) ||
        typeof cart.token !== 'string' || !cart.token || !Array.isArray(cart.cart_level_discount_applications) || cart.cart_level_discount_applications.length) return null;
    var choice = choices[0], props = choice.properties;
    if (!Number.isSafeInteger(choice.id) || choice.id <= 0 || !Number.isSafeInteger(choice.quantity) || choice.quantity <= 0 ||
        Number(choice.plan) !== 0 || !nativeGroupProperties(props) || props._mekhann_fitting_group !== intent.parentGroupId ||
        choice.id !== Number(intent.expectedVariantId) || !Number.isSafeInteger(Number(intent.expectedProductId)) || Number(intent.expectedProductId) <= 0 ||
        !Number.isSafeInteger(Number(intent.carrierVariantId)) || Number(intent.carrierVariantId) <= 0 || Number(intent.carrierVariantId) === choice.id ||
        cart.items.some(function (item) { return normaliseProperties(item.properties)._mekhann_fitting_group === intent.parentGroupId ||
          (item.original_line_price !== item.final_line_price && !provisionalFreeCarrier(item)) ||
          (item.original_line_price === item.final_line_price && (item.line_level_discount_allocations || []).some(function (allocation) { return Number(allocation.amount) !== 0; })); })) return null;
    var preferences = (cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE];
    if (preferences) {
      try { var parsed = JSON.parse(preferences); if (!parsed || parsed.version !== 1 || !nativeObject(parsed.selections)) return null; }
      catch (error) { return null; }
    }
    var baseline = nativeBaseline(cart);
    if (!validNativeBaseline(baseline)) return null;
    props = Object.assign({}, props, { _mekhann_grouped_parent: 'V1', _mekhann_grouped_carrier_id: String(intent.carrierVariantId) });
    var record = { version: 1, kind: 'grouped', phase: 'prepared', token: BUILD + '-grouped-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12),
      originalCartToken: cart.token, originalCartWasEmpty: cart.items.length === 0,
      baseline: baseline, parentDescriptor: cartGroups().selectionDescriptor({ variant_id: choice.id, properties: props }),
      parentVariantId: choice.id, carrierVariantId: Number(intent.carrierVariantId), expectedProductId: Number(intent.expectedProductId),
      quantity: choice.quantity, acknowledged: false, boundCartToken: null, followValue: null, cleanup: null, outcome: { httpStatus: 0, unknown: true } };
    if (intent.quantityPlus === true) record.purpose = 'quantity-plus';
    record.items = nativeBatchItems(record);
    persistNativeRecord(record, true);
    owner.nativeBatchToken = record.token;
    syncCheckoutGuards();
    var batch = nativeClone(record);
    batch.choices = [{ id: choice.id, quantity: choice.quantity, plan: 0, properties: nativeClone(props) }];
    return batch;
  }

  // ADD2: a new PDP request owns fresh, unique line properties. It can be
  // verified against its own receipt and the actual resulting Ajax cart,
  // without freezing unrelated items or notes at an earlier cart revision.
  // Version 1 continues to own quantity-plus and every older saved request.
  function validScopedNativeRecord(record) {
    if (!nativeObject(record) || record.version !== 2 || record.kind !== 'grouped' || record.scope !== 'pdp-add' ||
        record.purpose !== undefined || ['prepared', 'sent'].indexOf(record.phase) === -1 ||
        typeof record.token !== 'string' || !record.token || record.baseline !== null ||
        record.originalCartToken !== null || record.originalCartWasEmpty !== null ||
        typeof record.acknowledged !== 'boolean' || record.followValue !== null ||
        (record.boundCartToken !== null && (typeof record.boundCartToken !== 'string' || !record.boundCartToken)) ||
        !nativeObject(record.outcome) || !Number.isSafeInteger(record.outcome.httpStatus) || record.outcome.httpStatus < 0 ||
        record.outcome.httpStatus > 599 || typeof record.outcome.unknown !== 'boolean' ||
        ![record.parentVariantId, record.expectedProductId, record.quantity].every(function (value) { return Number.isSafeInteger(value) && value > 0; }) ||
        record.carrierVariantId !== 0 ||
        !nativeObject(record.parentDescriptor) || !Array.isArray(record.parentDescriptor.properties) ||
        record.parentDescriptor.properties.length !== 1) return false;
    var props = Object.create(null);
    if (record.parentDescriptor.properties.some(function (pair) {
      if (!Array.isArray(pair) || pair.length !== 2 || Object.prototype.hasOwnProperty.call(props, pair[0])) return true;
      props[pair[0]] = pair[1]; return false;
    })) return false;
    if (!nativeGroupProperties(props) ||
        !nativeEqual(cartGroups().selectionDescriptor({variant_id: record.parentVariantId, properties: props}), record.parentDescriptor) ||
        !nativeEqual(record.items, nativeBatchItems(record))) return false;
    if (record.phase === 'prepared' && (record.acknowledged || record.boundCartToken || record.cleanup ||
        record.outcome.httpStatus !== 0 || !record.outcome.unknown)) return false;
    return record.cleanup === null;
  }

  function prepareScopedNativeBatch(owner, intent, choices) {
    if (!ownedCurrent(owner) || owner.parentRecovery || nativeBatchRecord || nativeBatchFault || pendingAddToken || pendingPdpRecord ||
        pdpRecoveryFault || ownedParentUncertain || ownedQuantityUncertain || pendingReductionProtection ||
        !intent || intent.edit || intent.quantityPlus || !Array.isArray(choices) || choices.length !== 1) return null;
    var choice = choices[0], props = choice.properties, carrier = Number(intent.carrierVariantId);
    // Release boundary: paired Adds retain the existing fresh preflight and
    // serial fallback, which protects a parent's promotion from being displaced
    // by its complimentary child. A post-only snapshot cannot prove that.
    if (carrier !== 0) return null;
    if (!Number.isSafeInteger(choice.id) || choice.id <= 0 || !Number.isSafeInteger(choice.quantity) || choice.quantity <= 0 ||
        Number(choice.plan) !== 0 || !nativeGroupProperties(props) || props._mekhann_fitting_group !== intent.parentGroupId ||
        choice.id !== Number(intent.expectedVariantId) || !Number.isSafeInteger(Number(intent.expectedProductId)) || Number(intent.expectedProductId) <= 0 ||
        !Number.isSafeInteger(carrier) || carrier < 0 || carrier === choice.id) return null;
    props = nativeClone(props);
    var record = {version: 2, kind: 'grouped', scope: 'pdp-add', phase: 'prepared',
      token: BUILD + '-scoped-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12),
      originalCartToken: null, originalCartWasEmpty: null, baseline: null,
      parentDescriptor: cartGroups().selectionDescriptor({variant_id: choice.id, properties: props}),
      parentVariantId: choice.id, carrierVariantId: carrier, expectedProductId: Number(intent.expectedProductId),
      quantity: choice.quantity, acknowledged: false, boundCartToken: null, followValue: null, cleanup: null,
      outcome: {httpStatus: 0, unknown: true}};
    record.items = nativeBatchItems(record);
    persistNativeRecord(record, true);
    owner.nativeBatchToken = record.token;
    syncCheckoutGuards();
    var batch = nativeClone(record);
    batch.choices = [{id: choice.id, quantity: choice.quantity, plan: 0, properties: nativeClone(props)}];
    return batch;
  }

  function scopedSnapshot(cart) {
    var snapshot = nativeBaseline(cart);
    snapshot.orderDiscounts = (cart.cart_level_discount_applications || []).map(function (discount) {
      return {amount: discount.total_allocated_amount, title: discount.title};
    });
    return snapshot;
  }

  function validScopedSnapshot(snapshot) {
    if (!nativeObject(snapshot) || typeof snapshot.currency !== 'string' || !/^[A-Z]{3}$/.test(snapshot.currency) ||
        !validMoney(snapshot.totalPrice) || !validMoney(snapshot.totalDiscount) || !Number.isSafeInteger(snapshot.itemCount) || snapshot.itemCount < 0 ||
        typeof snapshot.note !== 'string' || !nativeObject(snapshot.attributes) || !Array.isArray(snapshot.items) || !Array.isArray(snapshot.orderDiscounts)) return false;
    var lines = snapshot.items;
    if (!lines.every(validNativeLineEvidence) || new Set(lines.map(function (line) { return line.key; })).size !== lines.length ||
        lines.some(function (line) { return line.finalLinePrice > line.originalLinePrice ||
          line.originalLinePrice !== line.originalPrice * line.quantity ||
          line.allocations.reduce(function (sum, allocation) { return sum + allocation.amount; }, 0) !== line.originalLinePrice - line.finalLinePrice; }) ||
        snapshot.orderDiscounts.some(function (discount) { return !discount || !validMoney(discount.amount) || typeof discount.title !== 'string'; })) return false;
    // final_line_price includes line-level discounts. Cart-level allocations
    // apply after that subtotal and must also reconcile to the actual total.
    var original = lines.reduce(function (sum, line) { return sum + line.originalLinePrice; }, 0);
    var subtotal = lines.reduce(function (sum, line) { return sum + line.finalLinePrice; }, 0);
    var orderDiscount = snapshot.orderDiscounts.reduce(function (sum, discount) { return sum + discount.amount; }, 0);
    return snapshot.itemCount === lines.reduce(function (sum, line) { return sum + line.quantity; }, 0) &&
      subtotal - orderDiscount === snapshot.totalPrice && original - snapshot.totalPrice === snapshot.totalDiscount;
  }

  function scopedCartShape(cart, record) {
    return Boolean(cart && !priorCartToken(cart) && typeof cart.token === 'string' && cart.token &&
      (!record.boundCartToken || record.boundCartToken === cart.token) && Array.isArray(cart.items) &&
      Array.isArray(cart.cart_level_discount_applications) && validScopedSnapshot(scopedSnapshot(cart)));
  }

  function scopedNativeLines(cart, record) {
    var group = record.items[0].properties._mekhann_fitting_group;
    var members = cart.items.filter(function (item) { return (item.properties || {})._mekhann_fitting_group === group; });
    var parents = members.filter(function (item) { return numericId(item.variant_id) === record.parentVariantId && nativeBatchDescriptorMatches(item, record.parentDescriptor); });
    var children = cart.items.filter(function (item) { return (item.properties || {})._mekhann_pilot_token === record.token; });
    // A foreign line must not inherit this operation simply by sharing a group.
    if (parents.length > 1 || children.length > 1 || members.some(function (item) { return parents.indexOf(item) === -1 && children.indexOf(item) === -1; })) {
      throw nativeBatchError('scoped request identity');
    }
    return {parent: parents[0] || null, child: children[0] || null, members: members};
  }

  function validateScopedNativeBatch(cart, record, owner, detachedRecovery) {
    if (!ownedCurrent(owner) || nativeBatchFault || !validScopedNativeRecord(record) ||
        (nativeBatchRecord !== record && !(detachedRecovery && !nativeBatchRecord && owner.nativeRecoveryRequested)) ||
        !scopedCartShape(cart, record)) throw nativeBatchError('scoped Ajax cart');
    var lines = scopedNativeLines(cart, record), parent = lines.parent, child = lines.child;
    if (!parent || parent.quantity !== record.quantity || numericId(parent.product_id) !== record.expectedProductId ||
        nativeParentKey(parent) || !validMoney(parent.original_price) || parent.original_price <= 0 ||
        parent.original_line_price !== parent.original_price * record.quantity ||
        !parent._mekhann_parent_selection_key || lines.members.length !== record.items.length) throw nativeBatchError('scoped parent proof');
    if (child || linkedCarriers(cart, parent).length) throw nativeBatchError('scoped parent-only proof');
    if (findInvalidPilotLine(cart)) throw nativeBatchError('scoped cart integrity');
    return parent;
  }

  function completeScopedNativeBatch(owner, intent, cart) {
    var record = nativeOwnedRecord(owner, intent && intent.nativeBatch);
    validateScopedNativeBatch(cart, record, owner, false);
    if (!record.boundCartToken) { record = Object.assign({}, record, {boundCartToken: cart.token}); persistNativeRecord(record); }
    return requireCartRefresh(cart).then(function (rendered) {
      validateScopedNativeBatch(rendered, record, owner, false);
      if (!lastRenderReceipt || lastRenderReceipt.stamp !== generationStamp()) throw nativeBatchError('scoped render proof');
      clearNativeBatch(owner, record); releaseServerVerificationLocks();
      pilotLinePresent = rendered.items.some(isKnownPilotLine); observeCarrierPreferences(rendered);
      return {cart: rendered, renderReceipt: lastRenderReceipt, nativeBatchResolved: record.token};
    });
  }

  // Parent-only Add has no child to compensate. A known terminal response may
  // have added a limited available quantity or no item. Verify the exact owned
  // group, preserve the actual current cart, and render it without another write.
  // A timed-out/unknown Add still cannot be cleared merely because a GET is empty.
  function scopedTerminalParent(cart, record, owner) {
    if (!record || record.version !== 2 || !ownedCurrent(owner) || nativeBatchFault ||
        nativeBatchRecord !== record || !scopedCartShape(cart, record) ||
        !(record.acknowledged || !record.outcome.unknown && [400, 404, 422].indexOf(record.outcome.httpStatus) !== -1)) {
      throw nativeBatchError('scoped uncertain outcome');
    }
    var lines = scopedNativeLines(cart, record), parent = lines.parent;
    if (lines.child || findInvalidPilotLine(cart) || parent &&
        (numericId(parent.product_id) !== record.expectedProductId || !positiveQuantity(parent.quantity) || parent.quantity > record.quantity ||
         nativeParentKey(parent) || parent.original_price <= 0 || parent.original_line_price !== parent.original_price * parent.quantity ||
         !parent._mekhann_parent_selection_key || linkedCarriers(cart, parent).length)) {
      throw nativeBatchError('scoped terminal parent');
    }
    return parent;
  }

  function cleanupTerminalScopedBatch(owner, cart) {
    var record = nativeBatchRecord, parent = scopedTerminalParent(cart, record, owner);
    var quantity = parent ? parent.quantity : 0;
    if (!record.boundCartToken) { record = Object.assign({}, record, {boundCartToken: cart.token}); persistNativeRecord(record); }
    return requireCartRefresh(cart).then(function (rendered) {
      var finalParent = scopedTerminalParent(rendered, record, owner);
      if ((finalParent ? finalParent.quantity : 0) !== quantity || !lastRenderReceipt || lastRenderReceipt.stamp !== generationStamp()) {
        throw nativeBatchError('scoped terminal render');
      }
      clearNativeBatch(owner, record); releaseServerVerificationLocks();
      pilotLinePresent = rendered.items.some(isKnownPilotLine); observeCarrierPreferences(rendered);
      return {cart: rendered, renderReceipt: lastRenderReceipt, nativeBatchResolved: record.token,
        warning: quantity ? 'Your bag contains the available quantity. Please check it before continuing.' :
          'Your addition is not in your bag. Please check your bag before trying again.'};
    });
  }
  function nativeOwnedRecord(owner, batch) {
    if (nativeBatchFault || !ownedCurrent(owner) || !nativeBatchRecord || !batch ||
        batch.version !== nativeBatchRecord.version ||
        batch.kind !== nativeBatchRecord.kind || batch.purpose !== nativeBatchRecord.purpose || owner.nativeBatchToken !== nativeBatchRecord.token || batch.token !== nativeBatchRecord.token ||
        !nativeEqual(batch.items, nativeBatchRecord.items) || !nativeEqual(batch.baseline, nativeBatchRecord.baseline) ||
        !nativeEqual(batch.parentDescriptor, nativeBatchRecord.parentDescriptor) ||
        batch.originalCartToken !== nativeBatchRecord.originalCartToken || batch.originalCartWasEmpty !== nativeBatchRecord.originalCartWasEmpty) {
      throw nativeBatchError('request identity');
    }
    return nativeBatchRecord;
  }
  function abandonUnsentNativeBatch(owner, batch) {
    var record = nativeOwnedRecord(owner, batch);
    if (record.phase !== 'prepared' || record.acknowledged || record.boundCartToken || record.followValue) throw nativeBatchError('request already sent');
    clearNativeBatch(owner, record);
    syncCheckoutGuards();
    return true;
  }
  function markNativeBatchSent(owner, batch) {
    var record = nativeOwnedRecord(owner, batch);
    if (record.phase !== 'prepared') throw nativeBatchError('request already sent');
    // If this durable transition fails, the caller must not start transport.
    persistNativeRecord(Object.assign({}, record, { phase: 'sent' }), true);
    return true;
  }
  function recoverNativeAttempt() {
    if (nativeBatchFault) throw nativeBatchError('saved request needs checking');
    if (!nativeBatchRecord) return null;
    var record = nativeBatchRecord;
    if (record.phase !== 'sent' || !validNativeRecord(record)) throw nativeBatchError('saved request shape');
    var choice = { id: record.parentVariantId, quantity: record.quantity, plan: 0, properties: nativeClone(record.items[0].properties) };
    return { choices: [choice], before: [0], token: record.originalCartToken, fittingIntent: {
      expectedVariantId: record.parentVariantId, expectedProductId: record.expectedProductId,
      parentGroupId: choice.properties._mekhann_fitting_group, carrierVariantId: record.carrierVariantId,
      choices: [nativeClone(choice)], nativeBatch: nativeClone(record)
    } };
  }
  function checkNativeBatch() {
    if (nativeRecoveryOperation) return nativeRecoveryOperation;
    var attempt;
    try { attempt = recoverNativeAttempt(); }
    catch (error) { return Promise.reject(error); }
    if (!attempt) return Promise.reject(new Error('There is no previous addition to check.'));
    var token = null;
    nativeRecoveryMessage = '';
    var task = Promise.resolve().then(function () {
      return beginOwnedMutation({ parentRecovery: true });
    }).then(function (owner) {
      token = owner;
      // Check the durable original request, independently of the displayed PDP.
      // The existing settlement owns all proof and any known-terminal cleanup;
      // this action never creates or replays an Add request.
      var grouping = cartGroups();
      return grouping && grouping.run ? grouping.run(function () { return getCart(); }) : getCart();
    }).then(function (cart) {
      // An initially empty full-cart page has no CartPageForm to commit the
      // verified lines into. Keep the durable guard and offer its real page
      // refresh instead of treating a hidden header drawer as rendered proof.
      if (document.body.classList.contains('template-cart') && document.querySelector('[data-mekhann-native-recovery-host]') &&
          !document.getElementById('CartPageForm') && cart.items && cart.items.length) {
        nativeRecoveryNeedsRefresh = true;
        throw nativeBatchError('page refresh required');
      }
      return settleOwnedMutation(token, { cart: cart, fitting: attempt.fittingIntent });
    }).then(function (result) {
      if (result.nativeBatchResolved === attempt.fittingIntent.nativeBatch.token && receiptCurrent(result.renderReceipt)) {
        document.dispatchEvent(new CustomEvent('mekhann:native-batch:resolved', { detail: {
          token: result.nativeBatchResolved, intent: attempt.fittingIntent, renderReceipt: result.renderReceipt
        } }));
      }
      var drawer = window.theme && window.theme.mekhannCartDrawer;
      var presentation = drawer && drawer.pendingAddPresentation;
      if (presentation && presentation.phase === 'unverified' &&
          presentation.parentGroupId === attempt.fittingIntent.parentGroupId &&
          result.nativeBatchResolved === attempt.fittingIntent.nativeBatch.token && receiptCurrent(result.renderReceipt)) {
        drawer.finishPendingAdd(presentation, { cart: result.cart, renderReceipt: result.renderReceipt, accepted: true, warning: result.warning });
      }
      return result;
    }).catch(function (error) {
      nativeRecoveryMessage = error.description || error.message || 'Your previous addition could not be checked. Please try Check bag again.';
      if (token && ownedMutation === token) {
        return abortOwnedMutation(token, { uncertain: true }).catch(function () {}).then(function () { throw error; });
      }
      throw error;
    }).finally(function () {
      if (nativeRecoveryOperation === task) nativeRecoveryOperation = null;
      syncCheckoutGuards();
    });
    nativeRecoveryOperation = task;
    syncCheckoutGuards();
    return task;
  }
  function acknowledgeNativeBatch(owner, batch, successful, outcome) {
    var record = nativeOwnedRecord(owner, batch);
    if (record.phase !== 'sent') throw nativeBatchError('request was not marked sent');
    outcome = outcome || {};
    persistNativeRecord(Object.assign({}, record, { acknowledged: successful === true,
      outcome: { httpStatus: successful ? 200 : Number(outcome.httpStatus) || 0, unknown: successful ? false : outcome.unknown !== false } }));
  }
  function nativeMatchesBaseline(cart, record) {
    return Boolean(cart && !priorCartToken(cart) && cart.token === record.originalCartToken &&
      Array.isArray(cart.items) && Array.isArray(cart.cart_level_discount_applications) && !cart.cart_level_discount_applications.length &&
      nativeEqual(nativeBaseline(cart), record.baseline));
  }
  function rejectNativeBatch(owner, batch, cart, httpStatus, unknown) {
    var record = nativeOwnedRecord(owner, batch);
    if (record.version === 2) {
      if (unknown || record.outcome.unknown || record.outcome.httpStatus !== Number(httpStatus) ||
          [400, 404, 422].indexOf(Number(httpStatus)) === -1 || record.acknowledged || record.cleanup ||
          !scopedCartShape(cart, record)) return false;
      var scoped = scopedNativeLines(cart, record);
      if (scoped.members.length || scoped.child) return false;
      clearNativeBatch(owner, record); syncCheckoutGuards();
      return true;
    }
    if (unknown || record.outcome.unknown || record.outcome.httpStatus !== Number(httpStatus) ||
        [400, 404, 422].indexOf(Number(httpStatus)) === -1 || record.acknowledged || record.boundCartToken || record.followValue ||
        !nativeMatchesBaseline(cart, record)) return false;
    clearNativeBatch(owner, record);
    syncCheckoutGuards();
    return true;
  }
  function batchChildMatches(cart, child, parent, record) {
    return record.kind === 'grouped' ? groupedChildParent(cart, child) === parent : nativeParentKey(child) === parent.key;
  }
  // FIX2: Shopify may split or coalesce unaffected No-carrier parent lines
  // when zero-value eligibility allocations change. Prove the whole exact
  // selection atomically, retaining the original journal and every unit of value.
  function nativePartitionIdentity(line) {
    return {variantId: line.variantId, productId: line.productId, properties: line.properties,
      parentKey: line.parentKey, sellingPlanId: line.sellingPlanId,
      originalPrice: line.originalPrice, finalPrice: line.finalPrice};
  }
  function nativePartitionEligible(line) {
    return validNativeLineEvidence(line) && nativeGroupProperties(line.properties) &&
      !line.parentKey && line.sellingPlanId === 0 &&
      [line.quantity, line.originalPrice, line.finalPrice, line.originalLinePrice, line.finalLinePrice].every(Number.isSafeInteger) &&
      line.originalPrice > 0 && line.finalPrice === line.originalPrice &&
      line.originalLinePrice === line.originalPrice * line.quantity && line.finalLinePrice === line.originalLinePrice &&
      line.allocations.every(function (allocation) { return allocation.amount === 0; });
  }
  function nativePartitionHasReference(lines, keys, selection, selectionKey) {
    var group = selection.properties._mekhann_fitting_group;
    return lines.some(function (line) {
      if (keys.indexOf(line.key) !== -1) return false;
      var props = line.properties || {};
      if (keys.indexOf(line.parentKey) !== -1 || keys.indexOf(props._mekhann_parent_line_key) !== -1 ||
          props._mekhann_fitting_group === group) return true;
      // Liquid can resolve a legacy child by selection hash before its stored
      // descriptor. Check the verified current parent hash as well as identity.
      if (props._mekhann_parent_selection_key &&
          (!selectionKey || props._mekhann_parent_selection_key === selectionKey || !props._mekhann_parent_group)) return true;
      if (props._mekhann_parent_group) {
        try {
          var descriptor = JSON.parse(props._mekhann_parent_group);
          if (!descriptor || !Number.isSafeInteger(descriptor.variantId) || !Array.isArray(descriptor.properties)) return true;
          if (cartGroups().sameSelection({variant_id: selection.variantId, properties: selection.properties}, descriptor)) return true;
        } catch (ignore) { return true; }
      }
      return false;
    });
  }
  function nativeExistingPartition(beforeLines, currentItems, old, used, consumedBefore, context) {
    if (!context || !Array.isArray(context.beforeLines) || !Array.isArray(context.currentLines) || !nativePartitionEligible(old)) return null;
    function sameSelection(line) { return line.variantId === old.variantId && nativeEqual(line.properties, old.properties); }
    // A changed operation target is never an unchanged cohort, even when its
    // expected retained rows happen to have full-price No-carrier properties.
    if ((context.excludedKeys || []).some(function (key) {
      return context.beforeLines.some(function (line) { return line.key === key && sameSelection(line); });
    }) || (context.excludedSelections || []).some(function (selection) {
      return cartGroups().sameSelection({variant_id: old.variantId, properties: old.properties}, selection);
    })) return null;
    var before = beforeLines.filter(sameSelection);
    var currentEvidence = currentItems.map(nativeLineEvidence), current = currentEvidence.filter(sameSelection);
    if (!before.length || !current.length || before.length === 1 && current.length === 1) return null;
    var fullBefore = context.beforeLines.filter(sameSelection);
    var fullCurrentEvidence = context.currentLines.map(nativeLineEvidence), fullCurrent = fullCurrentEvidence.filter(sameSelection);
    // Retained-line callers must still account for the entire selection in the
    // original and current graphs; filtering targets cannot hide a cohort row.
    if (fullBefore.length !== before.length || fullCurrent.length !== current.length ||
        !before.every(function (line) { return fullBefore.some(function (item) { return nativeEqual(line, item); }); }) ||
        !current.every(function (line) { return fullCurrent.some(function (item) { return nativeEqual(line, item); }); }) ||
        before.some(function (line) { return consumedBefore[line.key] || !nativePartitionEligible(line) ||
          !nativeEqual(nativePartitionIdentity(line), nativePartitionIdentity(old)); }) ||
        current.some(function (line) { return used.indexOf(line.key) !== -1 || !nativePartitionEligible(line) ||
          !nativeEqual(nativePartitionIdentity(line), nativePartitionIdentity(old)); })) return null;
    var beforeKeys = before.map(function (line) { return line.key; }), currentKeys = current.map(function (line) { return line.key; });
    if (new Set(beforeKeys).size !== beforeKeys.length || new Set(currentKeys).size !== currentKeys.length) return null;
    var actual = context.currentLines.filter(function (item) { return currentKeys.indexOf(item.key) !== -1; });
    if (actual.length !== current.length || actual.some(isCarrierVariant)) return null;
    var selectionKey = actual[0]._mekhann_parent_selection_key || '';
    if (actual.some(function (item) { return (item._mekhann_parent_selection_key || '') !== selectionKey; }) ||
        nativePartitionHasReference(context.beforeLines, beforeKeys, old, selectionKey) ||
        nativePartitionHasReference(fullCurrentEvidence, currentKeys, old, selectionKey)) return null;
    function totals(lines) {
      var result = {quantity: 0, originalLinePrice: 0, finalLinePrice: 0};
      return lines.every(function (line) {
        return Object.keys(result).every(function (field) { result[field] += line[field]; return Number.isSafeInteger(result[field]); });
      }) ? result : null;
    }
    var previousTotals = totals(before), currentTotals = totals(current);
    if (!previousTotals || !currentTotals || !nativeEqual(previousTotals, currentTotals)) return null;
    return {beforeKeys: beforeKeys, currentKeys: currentKeys};
  }
  function batchExistingKeys(cart, record) {
    var used = [], remapped = Object.create(null), consumedBefore = Object.create(null), before = record.baseline.items.slice();
    // Bind parents first so a proven native child may follow the same parent's
    // physical-key change. No quantity/price/properties or token may change.
    before.sort(function (a, b) { return Number(Boolean(a.parentKey)) - Number(Boolean(b.parentKey)); });
    before.forEach(function (old) {
      if (consumedBefore[old.key]) return;
      var partition = nativeExistingPartition(before, cart.items, old, used, consumedBefore,
        {beforeLines: record.baseline.items, currentLines: cart.items, excludedSelections: [record.parentDescriptor]});
      if (partition) {
        partition.beforeKeys.forEach(function (key) {
          consumedBefore[key] = true;
          if (partition.currentKeys.length === 1) remapped[key] = partition.currentKeys[0];
        });
        used = used.concat(partition.currentKeys);
        return;
      }
      var matches = cart.items.filter(function (item) {
        if (used.indexOf(item.key) !== -1) return false;
        var actual = nativeLineEvidence(item), expected = nativeClone(old);
        if (record.kind === 'grouped') {
          expected.key = actual.key;
          if (expected.parentKey && remapped[expected.parentKey]) expected.parentKey = remapped[expected.parentKey];
          var fullPriceParent = !isCarrierVariant(item) && !actual.parentKey && actual.originalLinePrice === actual.finalLinePrice;
          if (fullPriceParent) {
            // Zero eligibility allocations can rekey an otherwise identical
            // parent. Positive allocations and every monetary field remain exact.
            actual.allocations = actual.allocations.filter(function (entry) { return entry.amount !== 0; });
            expected.allocations = expected.allocations.filter(function (entry) { return entry.amount !== 0; });
          }
          actual.allocations.forEach(function (allocation, index) {
            var previous = expected.allocations[index];
            if (previous && previous.type === '' && allocation.type === 'automatic') allocation.type = '';
          });
        }
        return nativeEqual(actual, expected) && (!isCurrentPilotLine(item) || isComplimentaryLine(item));
      });
      if (matches.length !== 1) {
        throw nativeBatchError('existing items changed', nativeExistingDiagnostic(cart, record, old, used, remapped, matches.length));
      }
      consumedBefore[old.key] = true;
      used.push(matches[0].key); remapped[old.key] = matches[0].key;
    });
    return used;
  }
  function validateNativeBatch(cart, record, owner, final, detachedRecovery) {
    if (record && record.version === 2) return validateScopedNativeBatch(cart, record, owner, detachedRecovery);
    if (!ownedCurrent(owner) || nativeBatchFault ||
        (nativeBatchRecord !== record && !(detachedRecovery && !nativeBatchRecord && owner.nativeRecoveryRequested)) ||
        !cart || !Array.isArray(cart.items)) throw nativeBatchError('current cart');
    var before = record.baseline, priorToken = priorCartToken(cart);
    if (priorToken) {
      if (final || owner.parentRecovery || !record.acknowledged || record.originalCartWasEmpty || priorToken !== record.originalCartToken) throw nativeBatchError('Ajax identity');
    } else if (typeof cart.token !== 'string' || !cart.token ||
        (record.boundCartToken ? cart.token !== record.boundCartToken : !record.originalCartWasEmpty && cart.token !== record.originalCartToken)) throw nativeBatchError('cart identity changed');
    var expectedAttributes = nativeClone(before.attributes);
    if (record.followValue && (final || (cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] === record.followValue)) expectedAttributes[CARRIER_PREFERENCE_ATTRIBUTE] = record.followValue;
    if (cart.currency !== before.currency || String(cart.note || '') !== before.note || !nativeEqual(cart.attributes || {}, expectedAttributes) ||
        !Array.isArray(cart.cart_level_discount_applications) || cart.cart_level_discount_applications.length ||
        cart.item_count !== before.itemCount + record.quantity * 2 ||
        new Set(cart.items.map(function (item) { return item.key; })).size !== cart.items.length) throw nativeBatchError('cart contents', nativeContentsDiagnostic(cart, record, expectedAttributes));
    var previousKeys = batchExistingKeys(cart, record);
    // The existing-line proof accounts for every original unit, including a
    // proven No-carrier partition. Exactly two owned physical lines remain.
    if (cart.items.length !== previousKeys.length + 2) throw nativeBatchError('owned line count', {
      scope: 'owned-line-count', beforeLines: before.items.length, provenExistingLines: previousKeys.length,
      currentLines: cart.items.length, expectedLines: previousKeys.length + 2
    });
    var added = cart.items.filter(function (item) { return previousKeys.indexOf(item.key) === -1; });
    var parent = added.find(function (item) { return numericId(item.variant_id) === record.parentVariantId && nativeBatchDescriptorMatches(item, record.parentDescriptor); });
    var children = findPilotLinesByToken(cart, record.token);
    var child = children[0];
    if (added.length !== 2 || !parent || parent.quantity !== record.quantity || numericId(parent.product_id) !== record.expectedProductId ||
        !validMoney(parent.original_price) || parent.original_price <= 0 || parent.final_price !== parent.original_price ||
        parent.original_line_price !== parent.original_price * record.quantity || parent.final_line_price !== parent.original_line_price ||
        (parent.line_level_discount_allocations || []).some(function (allocation) { return allocation.amount !== 0; }) ||
        children.length !== 1 || added.indexOf(child) === -1 || numericId(child.variant_id) !== record.carrierVariantId || child.quantity !== record.quantity ||
        !batchChildMatches(cart, child, parent, record) || !nativeEqual(child.properties || {}, record.items[1].properties) ||
        !isComplimentaryLine(child) || child.original_line_price !== child.original_price * record.quantity || child.final_price !== 0 ||
        getPilotLineIssue(cart, child) ||
        !carrierOptions(cart, record.parentVariantId).some(function (option) { return option.id === record.carrierVariantId; }) ||
        cart.total_price !== before.totalPrice + parent.final_line_price || cart.total_discount !== before.totalDiscount + child.original_line_price) {
      throw nativeBatchError('complete free pair', nativePairDiagnostic(cart, record, added, parent, children, child));
    }
    if (!parent._mekhann_parent_selection_key) throw nativeBatchError('parent selection proof');
    return parent;
  }
  function nativeFollowValue(record, parent) {
    var preferences = carrierPreferences({ attributes: record.baseline.attributes });
    preferences[cartGroups().selectionSignature(parent)] = { parent: cartGroups().selectionDescriptor(parent), mode: 'follow',
      selectionKey: parent._mekhann_parent_selection_key, chosenCarrierVariantId: record.carrierVariantId };
    return JSON.stringify({ version: 1, selections: preferences });
  }
  function recoverCompletedNativeBatch(owner, batch, cart) {
    if (!owner.nativeRecoveryRequested || nativeBatchRecord || nativeBatchFault || priorCartToken(cart) || !validNativeRecord(batch)) {
      nativeBatchFault = true;
      throw nativeBatchError('missing completion journal');
    }
    var record = nativeClone(batch);
    var parent = cart.items.find(function (item) { return nativeBatchDescriptorMatches(item, record.parentDescriptor); });
    if (!parent || !parent._mekhann_parent_selection_key) { nativeBatchFault = true; throw nativeBatchError('completed parent'); }
    if (record.kind !== 'grouped') record.followValue = nativeFollowValue(record, parent);
    try { validateNativeBatch(cart, record, owner, true, true); }
    catch (error) { nativeBatchFault = true; throw error; }
    return requireCartRefresh(cart).then(function (rendered) {
      validateNativeBatch(rendered, record, owner, true, true);
      if (!lastRenderReceipt || lastRenderReceipt.stamp !== generationStamp()) throw nativeBatchError('completed render');
      ownedParentUncertain = false; unverifiedMutation = false;
      owner.nativeBatchResolved = record.token;
      releaseServerVerificationLocks();
      return { cart: rendered, renderReceipt: lastRenderReceipt, nativeBatchResolved: record.token };
    }).catch(function (error) { nativeBatchFault = true; ownedParentUncertain = true; unverifiedMutation = true; syncCheckoutGuards(); throw error; });
  }
  function completeNativeBatch(owner, intent, cart) {
    var record = nativeOwnedRecord(owner, intent && intent.nativeBatch);
    if (record.version === 2) return completeScopedNativeBatch(owner, intent, cart);
    if (record.kind === 'grouped' && priorCartToken(cart)) {
      return getCart(false, cart).then(function (fresh) { return completeNativeBatch(owner, intent, fresh); });
    }
    var parent = validateNativeBatch(cart, record, owner, false);
    if (record.kind === 'grouped') {
      if (!record.boundCartToken) { record = Object.assign({}, record, { boundCartToken: cart.token }); persistNativeRecord(record); }
      validateNativeBatch(cart, record, owner, true);
      var preference = carrierPreference(cart, parent);
      if (!preference || preference.mode !== 'follow' || preference.suspended || Number(preference.chosenCarrierVariantId) !== record.carrierVariantId) throw nativeBatchError('grouped Follow intent');
      return requireCartRefresh(cart).then(function (rendered) {
        validateNativeBatch(rendered, record, owner, true);
        if (!lastRenderReceipt || lastRenderReceipt.stamp !== generationStamp()) throw nativeBatchError('grouped render proof');
        clearNativeBatch(owner, record); releaseServerVerificationLocks();
        pilotLinePresent = rendered.items.some(isKnownPilotLine);
        observeCarrierPreferences(rendered);
        return { cart: rendered, renderReceipt: lastRenderReceipt, nativeBatchResolved: record.token };
      });
    }
    if (record.followValue && (cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] !== record.followValue) {
      throw nativeBatchError('previous Follow is unconfirmed');
    }
    if (!priorCartToken(cart) && !record.boundCartToken) {
      record = Object.assign({}, record, { boundCartToken: cart.token }); persistNativeRecord(record);
    }
    var followValue = nativeFollowValue(record, parent);
    if (record.followValue && record.followValue !== followValue) throw nativeBatchError('saved fitting preference');
    if (!record.followValue) { record = Object.assign({}, record, { followValue: followValue }); persistNativeRecord(record); }
    var canMutate = function () { return ownedCurrent(owner) && nativeBatchRecord === record && !nativeBatchFault; };
    return saveCarrierPreference(cart, parent, 'follow', false, canMutate, record.carrierVariantId).then(function (confirmed) {
      validateNativeBatch(confirmed, record, owner, true);
      if (!record.boundCartToken) { record = Object.assign({}, record, { boundCartToken: confirmed.token }); persistNativeRecord(record); }
      return requireCartRefresh(confirmed).then(function (rendered) {
        validateNativeBatch(rendered, record, owner, true);
        if (!lastRenderReceipt || lastRenderReceipt.stamp !== generationStamp()) throw nativeBatchError('render proof');
        clearNativeBatch(owner, record);
        releaseServerVerificationLocks();
        pilotLinePresent = rendered.items.some(isKnownPilotLine);
        return { cart: rendered, renderReceipt: lastRenderReceipt, nativeBatchResolved: record.token };
      });
    }).catch(function (error) { ownedParentUncertain = true; unverifiedMutation = true; syncCheckoutGuards(); throw error; });
  }

  function inspectNativeCleanup(cart, record, owner) {
    if (!ownedCurrent(owner) || nativeBatchFault || nativeBatchRecord !== record || !cart || priorCartToken(cart) ||
        typeof cart.token !== 'string' || !cart.token || !Array.isArray(cart.items)) throw nativeBatchError('cleanup identity');
    var before = record.baseline, previousKeys = batchExistingKeys(cart, record);
    var added = cart.items.filter(function (item) { return previousKeys.indexOf(item.key) === -1; });
    var parents = added.filter(function (item) { return numericId(item.variant_id) === record.parentVariantId && nativeBatchDescriptorMatches(item, record.parentDescriptor); });
    var parent = parents[0], children = findPilotLinesByToken(cart, record.token);
    var parentQuantity = parent ? parent.quantity : 0;
    if (record.boundCartToken ? cart.token !== record.boundCartToken :
        (!record.originalCartWasEmpty || !parent) && cart.token !== record.originalCartToken) throw nativeBatchError('cleanup cart changed');
    var attributes = nativeClone(before.attributes), currentPreference = (cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE];
    if (record.cleanup && record.cleanup.offValue && currentPreference === record.cleanup.offValue) attributes[CARRIER_PREFERENCE_ATTRIBUTE] = record.cleanup.offValue;
    else if (record.followValue) {
      // A missing preference cannot disprove a late Follow. Only its exact
      // committed value (or our subsequently proven Off) permits compensation.
      if (currentPreference !== record.followValue) throw nativeBatchError('unconfirmed Follow');
      attributes[CARRIER_PREFERENCE_ATTRIBUTE] = record.followValue;
    }
    if (cart.currency !== before.currency || String(cart.note || '') !== before.note || !nativeEqual(cart.attributes || {}, attributes) ||
        !Array.isArray(cart.cart_level_discount_applications) || cart.cart_level_discount_applications.length ||
        new Set(cart.items.map(function (item) { return item.key; })).size !== cart.items.length ||
        parents.length > 1 || !Number.isSafeInteger(parentQuantity) || parentQuantity < 0 || parentQuantity > record.quantity ||
        (record.cleanup && record.cleanup.parentQuantity !== parentQuantity) ||
        added.length !== parents.length + children.length ||
        (parent && (parentQuantity < 1 || numericId(parent.product_id) !== record.expectedProductId || !validMoney(parent.original_price) || parent.original_price <= 0 ||
          parent.final_price !== parent.original_price || parent.original_line_price !== parent.original_price * parentQuantity || parent.final_line_price !== parent.original_line_price ||
          (parent.line_level_discount_allocations || []).some(function (allocation) { return allocation.amount !== 0; }))) ||
        children.some(function (child) {
          return added.indexOf(child) === -1 || !parent || !batchChildMatches(cart, child, parent, record) || numericId(child.variant_id) !== record.carrierVariantId ||
            !nativeEqual(child.properties || {}, record.items[1].properties) || !Number.isSafeInteger(child.quantity) || child.quantity < 1 || child.quantity > record.quantity ||
            !validMoney(child.original_price) || child.original_price <= 0 || child.original_line_price !== child.original_price * child.quantity ||
            !validMoney(child.final_line_price) || child.final_line_price > child.original_line_price;
        }) ||
        cart.item_count !== before.itemCount + parentQuantity + children.reduce(function (sum, item) { return sum + item.quantity; }, 0) ||
        cart.total_price !== before.totalPrice + (parent ? parent.final_line_price : 0) + children.reduce(function (sum, item) { return sum + item.final_line_price; }, 0) ||
        cart.total_discount !== before.totalDiscount + children.reduce(function (sum, item) { return sum + item.original_line_price - item.final_line_price; }, 0)) {
      throw nativeBatchError('protected cleanup contents');
    }
    return { parent: parent, children: children, parentQuantity: parentQuantity };
  }
  function cleanupTerminalNativeBatch(owner, cart) {
    var record = nativeBatchRecord;
    if (record && record.version === 2) return cleanupTerminalScopedBatch(owner, cart);
    if (!record || !(record.acknowledged || !record.outcome.unknown && [400, 404, 422].indexOf(record.outcome.httpStatus) !== -1)) {
      throw nativeBatchError('uncertain batch outcome');
    }
    var inspection = inspectNativeCleanup(cart, record, owner);
    if (!record.cleanup) {
      var offValue = null;
      if (record.kind === 'grouped' && inspection.parent) {
        var groupedPreferences = carrierPreferences(cart), groupedKey = cartGroups().selectionSignature(inspection.parent);
        groupedPreferences[groupedKey] = { parent: cartGroups().selectionDescriptor(inspection.parent), mode: 'off',
          selectionKey: inspection.parent._mekhann_parent_selection_key || '', chosenCarrierVariantId: record.carrierVariantId };
        // PLUS1: a terminal partial +1 keeps the original fitting intent. The
        // verified new parent remains, with explicit Retry and no automatic
        // growth on reload. The existing durable cleanup write still cannot
        // be replayed after an uncertain response.
        if (record.purpose === 'quantity-plus') {
          if (!groupedPreferences[groupedKey].selectionKey) throw nativeBatchError('Plus retry selection proof');
          groupedPreferences[groupedKey].mode = 'follow';
          groupedPreferences[groupedKey].suspended = true;
        }
        offValue = JSON.stringify({ version: 1, selections: groupedPreferences });
      } else if (record.followValue) {
        var preferences = JSON.parse(record.followValue);
        var key = JSON.stringify(record.parentDescriptor);
        if (!preferences.selections[key]) throw nativeBatchError('cleanup preference');
        preferences.selections[key].mode = 'off';
        offValue = JSON.stringify(preferences);
      }
      record = Object.assign({}, record, { boundCartToken: cart.token, cleanup: { parentQuantity: inspection.parentQuantity, offValue: offValue, offSent: false } });
      persistNativeRecord(record);
    }
    var needsOff = record.cleanup.offValue && (cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] !== record.cleanup.offValue;
    if (needsOff) {
      // Persist before transport. A missing Off after a possibly sent write
      // cannot authorize its replay, including on explicit Check or reload.
      if (record.cleanup.offSent !== false) throw nativeBatchError('previous Off is unconfirmed');
      record = Object.assign({}, record, { cleanup: Object.assign({}, record.cleanup, { offSent: true }) });
      persistNativeRecord(record);
    }
    var canMutate = function () { return ownedCurrent(owner) && nativeBatchRecord === record && !nativeBatchFault; };
    var off = needsOff ? writeCarrierPreferences(cart, JSON.parse(record.cleanup.offValue).selections, canMutate) : Promise.resolve(cart);
    var removals = 0;
    function next(current) {
      if (!canMutate()) throw nativeBatchError('cleanup owner');
      var inspected = inspectNativeCleanup(current, record, owner);
      if (!inspected.children.length) return Promise.resolve(current);
      if (removals >= record.quantity || !inspected.children[0].key) throw nativeBatchError('cleanup limit');
      removals += 1;
      return postChange(inspected.children[0].key, 0).then(next);
    }
    return off.then(next).then(function (confirmed) {
      var inspected = inspectNativeCleanup(confirmed, record, owner);
      if (inspected.children.length) throw nativeBatchError('cleanup incomplete');
      return requireCartRefresh(confirmed).then(function (rendered) {
        if (inspectNativeCleanup(rendered, record, owner).children.length || !lastRenderReceipt || lastRenderReceipt.stamp !== generationStamp()) throw nativeBatchError('cleanup render');
        clearNativeBatch(owner, record);
        releaseServerVerificationLocks();
        pilotLinePresent = rendered.items.some(isKnownPilotLine);
        observeCarrierPreferences(rendered);
        return { cart: rendered, renderReceipt: lastRenderReceipt, nativeBatchResolved: record.token,
          warning: inspected.parentQuantity ? (record.purpose === 'quantity-plus' ?
            'The additional lampshade is in your bag, but its selected carrier could not be confirmed. Your fitting choice is saved. Use Retry below to add it.' :
            'Your lampshade remains in your bag. The selected carrier could not be confirmed and was not kept.') :
            'The combined addition was not completed. No new items were kept; please check your bag.' };
      });
    });
  }
  function settleNativeBatch(owner, intent, cart) {
    return Promise.resolve().then(function () {
      var record = nativeOwnedRecord(owner, intent && intent.nativeBatch);
      return record.cleanup ? cleanupTerminalNativeBatch(owner, cart) : completeNativeBatch(owner, intent, cart);
    }).catch(function (error) {
      if (!ownedCurrent(owner) || !nativeBatchRecord || nativeBatchFault) throw error;
      // A failed same-response projection is never the cleanup authority.
      // Read the actual cart once; terminal compensation can remove only this
      // batch's exact token/variant/native-parent lines, preserving the parent.
      return getCart().then(function (fresh) {
        var record = nativeBatchRecord;
        if (record.cleanup) return cleanupTerminalNativeBatch(owner, fresh);
        try { validateNativeBatch(fresh, record, owner, false); }
        catch (invalidPair) { return cleanupTerminalNativeBatch(owner, fresh); }
        // A valid committed pair survives an unprovable projection/render.
        // An earlier Follow may be checked, never blindly replayed.
        if (record.followValue && (fresh.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE] !== record.followValue) throw error;
        return completeNativeBatch(owner, intent, fresh);
      });
    });
  }

  function persistPendingPdpOffRequirement(required) {
    var record = Object.assign({}, pendingPdpRecord, { requiresOff: required });
    try {
      if (!pendingPdpRecord || record.tokenSource !== 'prior-ajax-token' || !window.sessionStorage) throw new Error();
      var encoded = JSON.stringify(record);
      window.sessionStorage.setItem(PDP_PENDING_KEY, encoded);
      if (window.sessionStorage.getItem(PDP_PENDING_KEY) !== encoded) throw new Error();
    } catch (error) {
      pdpRecoveryFault = true;
      unverifiedMutation = true;
      throw new Error('Your fitting recovery could not be saved safely. Please refresh your shopping bag before continuing.');
    }
    pendingPdpRecord = record;
  }

  function persistPendingPdpAdd(cart, parent, token, quantity, protection, provisionalIdentity, requestedCarrierVariantId) {
    var priorToken = priorCartToken(cart);
    var record = { version: 1, cartToken: cart && cart.token || priorToken, token: token, quantity: quantity,
      protection: protection, parent: cartGroups().selectionDescriptor(parent) };
    // A bundled Liquid snapshot proves response contents, not the Ajax token.
    // Preserve the last real token as provenance until a real cart proves it.
    if (priorToken || provisionalIdentity) {
      record.tokenSource = 'prior-ajax-token';
      record.requestedCarrierVariantId = requestedCarrierVariantId;
    }
    try {
      if (typeof record.cartToken !== 'string' || !record.cartToken || !protection || !window.sessionStorage) throw new Error();
      if (record.tokenSource && (!Number.isSafeInteger(record.requestedCarrierVariantId) || record.requestedCarrierVariantId <= 0)) throw new Error();
      var encoded = JSON.stringify(record);
      window.sessionStorage.setItem(PDP_PENDING_KEY, encoded);
      if (window.sessionStorage.getItem(PDP_PENDING_KEY) !== encoded) throw new Error();
    } catch (error) {
      throw new Error('The fitting request could not be saved safely. Your lampshade remains in your bag without a carrier.');
    }
    pendingPdpRecord = record;
    pendingPdpIdentityConfirmed = false;
    restoredPdpPending = false;
  }

  function checkPendingPdpCart(cart) {
    if (pdpRecoveryFault) throw new Error('Your previous fitting request could not be checked safely. Please return to your bag.');
    if (!pendingPdpRecord) return cart;
    var priorToken = priorCartToken(cart);
    if (priorToken) {
      if (pendingPdpRecord.tokenSource !== 'prior-ajax-token' || priorToken !== pendingPdpRecord.cartToken ||
          restoredPdpPending || !ownedCurrent(ownedMutation) || ownedMutation.parentRecovery ||
          !pendingAddAcknowledged || pendingPdpRecord.token !== pendingAddToken) {
        throw new Error('Your fitting response could not be matched to the active bag update.');
      }
      // This request-local projection cannot release or clear the pending ledger.
      pendingPdpIdentityConfirmed = false;
      return cart;
    }
    if (!cart || typeof cart.token !== 'string' || !cart.token) throw new Error('Your previous fitting request could not be matched to this bag.');
    if (cart.token !== pendingPdpRecord.cartToken) {
      if (pendingPdpRecord.tokenSource === 'prior-ajax-token') {
        pendingPdpIdentityConfirmed = false;
        pendingPdpUncertain = true;
        unverifiedMutation = true;
        throw new Error('Your shopping bag changed while the fitting was being checked.');
      }
      var restored = restoredPdpPending;
      clearPendingAdd();
      if (!restored) throw new Error('Your shopping bag changed while the fitting was being checked.');
      unverifiedMutation = false;
    } else {
      pendingPdpIdentityConfirmed = true;
      if (pendingPdpRecord.requiresOff !== undefined) {
        var parent = cart.items.find(function (item) {
          return !isCarrierVariant(item) && !nativeParentKey(item) && cartGroups().sameSelection(item, pendingPdpRecord.parent);
        });
        var preference = parent && carrierPreference(cart, parent);
        if (parent && (!validCarrierPreference(preference) || preference.mode !== 'off')) {
          unverifiedMutation = true;
          throw new Error('Your shade carrier preference still needs to be switched off before this addition can be cleared.');
        }
        // Keep the false marker through cleanup/reload: recovery must continue
        // proving Off and must never grow the failed batch from saved Follow.
        if (pendingPdpRecord.requiresOff) persistPendingPdpOffRequirement(false);
        pendingPdpUncertain = false;
      }
    }
    return cart;
  }

  function requirePendingPdpOff(cart, canMutate) {
    var record = pendingPdpRecord;
    if (!record || record.tokenSource !== 'prior-ajax-token' || priorCartToken(cart) ||
        !cart || cart.token !== record.cartToken) {
      throw new Error('Your fitting recovery needs a current shopping bag check.');
    }
    persistPendingPdpOffRequirement(true);
    if (!canMutate()) throw new Error('Your bag changed before the fitting could be recovered.');
    var parent = cart.items.find(function (item) {
      return !isCarrierVariant(item) && !nativeParentKey(item) && cartGroups().sameSelection(item, record.parent);
    });
    if (!parent) return Promise.resolve(checkPendingPdpCart(cart));
    if (protectedCartIssue(cart, record.protection)) {
      throw new Error('Your existing bag contents could not be confirmed before fitting recovery.');
    }
    return saveCarrierPreference(cart, parent, 0, false, canMutate, record.requestedCarrierVariantId).then(function (confirmed) {
      checkPendingPdpCart(confirmed);
      if (!canMutate() || protectedCartIssue(confirmed, record.protection)) {
        throw new Error('Your bag changed while the fitting was being recovered.');
      }
      return confirmed;
    });
  }

  function clearPendingAdd() {
    if (pendingPdpRecord) {
      if (pendingPdpRecord.tokenSource === 'prior-ajax-token' && (!pendingPdpIdentityConfirmed || pendingPdpRecord.requiresOff === true)) {
        throw new Error('Your fitting confirmation still needs a current shopping bag check.');
      }
      try {
        window.sessionStorage.removeItem(PDP_PENDING_KEY);
        if (window.sessionStorage.getItem(PDP_PENDING_KEY)) throw new Error();
      } catch (error) {
        throw new Error('Your fitting confirmation could not be saved safely. Please return to your bag.');
      }
      pendingPdpRecord = null;
      pendingPdpIdentityConfirmed = false;
      restoredPdpPending = false;
    }
    pendingAddToken = '';
    pendingAddAcknowledged = false;
    pendingAddQuantity = 0;
    pendingAddProtection = null;
    pendingAddRollback = false;
    pendingPdpUncertain = false;
  }

  function pendingAddRemoval(result) {
    if (!pendingAddToken || !result || !Array.isArray(result.removed)) return null;
    return result.removed.find(function (entry) {
      return entry.token === pendingAddToken;
    }) || null;
  }

  function formDataset(form) {
    return form && form.dataset ? form.dataset : {};
  }

  function seedClientVerificationLocks() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      if (!form.querySelector(PILOT_LINE_SELECTOR)) return;

      formDataset(form).mekhannCarrierAwaitingVerification = 'true';
      var control = checkoutControl(form, null);
      if (!control) return;

      formDataset(control).mekhannCarrierServerLock = 'true';
      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
    });
  }

  function releaseServerVerificationLocks() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      var dataset = formDataset(form);
      if (dataset.mekhannCarrierAwaitingVerification !== 'true') return;

      delete dataset.mekhannCarrierAwaitingVerification;
      if (typeof form.removeAttribute === 'function') {
        form.removeAttribute('data-mekhann-carrier-awaiting-verification');
      }

      var control = checkoutControl(form, null);
      if (!control || formDataset(control).mekhannCarrierServerLock !== 'true') return;

      delete formDataset(control).mekhannCarrierServerLock;
      if (typeof control.removeAttribute === 'function') {
        control.removeAttribute('data-mekhann-carrier-server-lock');
        if (!control.hasAttribute('data-mekhann-add-checkout-lock') && !control.hasAttribute('data-mekhann-checkout-verification-lock') &&
            !control.hasAttribute('data-mekhann-checkout-pending-lock')) {
          control.removeAttribute('disabled');
          control.removeAttribute('aria-disabled');
        }
      }
      if (!control.hasAttribute('data-mekhann-add-checkout-lock') && !control.hasAttribute('data-mekhann-checkout-verification-lock') &&
          !control.hasAttribute('data-mekhann-checkout-pending-lock')) control.disabled = false;
    });
  }

  function markPilotSignal() {
    pilotLinePresent = true;
    cartSignalGeneration += 1;
  }

  function runReconcile(initialCart, silent, ownerToken, guard) {
    if (guard) { try { guard(); } catch (error) { return Promise.reject(error); } }
    if (!isPilotEnvironment()) return Promise.resolve({ cart: initialCart || null, removed: [] });
    if (nativeBatchRecord || nativeBatchFault) return Promise.reject(nativeBatchError('pending native batch'));
    if (removalJournalFault) return Promise.reject(new Error('Your last removal could not be checked. Please contact us before continuing.'));
    if (removalJournal && !ownedMutation) {
      if (!removalJournalRestored) return Promise.reject(new Error('Your last removal could not be confirmed. Refresh your bag before continuing.'));
      return recoverRemovalJournal(guard).then(function (cart) { return runReconcile(cart, silent, ownerToken, guard); });
    }
    if (ownedQuantityUncertain) return Promise.reject(new Error('Your last quantity update could not be confirmed. Refresh your bag before continuing.'));
    if (ownedParentUncertain) return Promise.reject(new Error('Your last bag request could not be confirmed. Check that request before trying again.'));
    if (pdpRecoveryFault) return Promise.reject(new Error('Your previous fitting request could not be checked safely. Please return to your bag.'));
    if (ownerToken && !ownedCurrent(ownerToken)) return Promise.reject(new Error('Your bag changed during this update. Please refresh it before continuing.'));
    if (ownedMutation && ownerToken !== ownedMutation) return Promise.resolve({ cart: initialCart || null, removed: [], deferred: true });
    if (externalMutationPending) {
      return Promise.resolve({ cart: initialCart || null, removed: [], deferred: true });
    }
    if (reconcileInFlight) {
      // A structural signal invalidates this run's snapshot, and its shared
      // continuation already obtains fresh proof before resolving. Join that
      // continuation when only the signal differs; a second waiter must not
      // add another read after the fresh retry. Mutation/external generations,
      // recovery state, metadata revision and history guard must still match.
      if (reconcileGuard === (guard || null) && reconcileShared) {
        if (reconcileStamp === reconciliationStamp()) return reconcileShared;
        if (reconcileStamp === reconciliationStamp(reconcileStartedSignalGeneration)) {
          // Keep the changed-signal waiter's existing fresh recovery on a
          // failed read. Only successful shared work removes the extra pair.
          return reconcileShared.catch(function () { return runReconcile(null, silent, ownerToken, guard); });
        }
      }
      // A history lifecycle cannot inherit an unguarded run (or another
      // history epoch). Wait for it, then obtain fresh proof under this guard.
      return (reconcileShared || reconcileInFlight)
        .catch(function () { return null; })
        .then(function () { return runReconcile(null, silent, ownerToken, guard); });
    }

    var startedGeneration = cartMutationGeneration;
    var startedSignalGeneration = cartSignalGeneration;
    var startedExternalGeneration = externalMutationGeneration;
    var startedDuringMutation = addInFlight || Boolean(addOperation) || Boolean(removeOperation);
    var startedWithPilotSignal = (pilotLinePresent || Boolean(pendingAddToken) ||
      Boolean(document.querySelector(PILOT_LINE_SELECTOR))) &&
      !(ownerToken && ownerToken.removalAcknowledged && initialCart && removalComplete(initialCart, ownerToken.removalAcknowledged));
    var canMutate = function () {
      if (guard) guard();
      return !externalMutationPending &&
        startedGeneration === cartMutationGeneration &&
        startedSignalGeneration === cartSignalGeneration &&
        startedExternalGeneration === externalMutationGeneration &&
        !addInFlight && !addOperation && !removeOperation && (!ownerToken || ownedCurrent(ownerToken));
    };
    var inputCart = initialCart ? Promise.resolve(initialCart).then(checkPendingPdpCart) : getCart();
    var activeReconcile = inputCart.then(function (cart) {
      // A timed-out or rejected add can still have reached Shopify. Verify the
      // whole requested batch before generic cleanup can keep just its free half.
      if (!pendingAddToken || !pendingAddQuantity || !canMutate()) return cart;
      var token = pendingAddToken;
      var before = pendingAddProtection;
      function restorePreviousSelection(currentCart) {
        if (pendingPdpUncertain && !findPilotLinesByToken(currentCart, token).length) {
          throw new Error('Your fitting request could not be confirmed. Refresh your bag before trying again.');
        }
        return rollbackAddedToken(currentCart, token, canMutate)
          .then(function (restoredCart) { return confirmProtectedRestoration(restoredCart, before); })
          .then(function (restoredCart) {
            if (!canMutate()) throw new Error('Your bag is still updating. Please wait before checkout.');
            if (pendingAddToken === token) clearPendingAdd();
            publishNotice('The additional shade carriers could not be confirmed and were removed. Please check your bag.');
            return restoredCart;
          });
      }
      // Preserve the snapshot until restoration is proven. Generic cleanup
      // must not delete an older carrier whose discount has not yet returned.
      if (restoredPdpPending && pendingPdpRecord && pendingPdpRecord.tokenSource === 'prior-ajax-token' &&
          pendingPdpRecord.requiresOff === undefined) {
        var restoredRecord = pendingPdpRecord;
        return confirmAddedLine(cart, token, restoredRecord.quantity, before).then(function (confirmation) {
          var confirmed = checkPendingPdpCart(confirmation.cart);
          if (!canMutate() || pendingPdpRecord !== restoredRecord) throw new Error('Your bag changed while the previous fitting was being checked.');
          var parent = confirmed.items.find(function (item) {
            return !isCarrierVariant(item) && !nativeParentKey(item) && cartGroups().sameSelection(item, restoredRecord.parent);
          });
          var preference = parent && carrierPreference(confirmed, parent);
          var committedFollow = validCarrierPreference(preference) && preference.mode === 'follow' && !preference.suspended &&
            numericId(preference.chosenCarrierVariantId) === restoredRecord.requestedCarrierVariantId;
          var ownBatch = !confirmation.issue && confirmation.lines.length && confirmation.lines.every(function (line) {
            var linked = resolveParent(confirmed, line);
            return numericId(line.variant_id) === restoredRecord.requestedCarrierVariantId && linked &&
              cartGroups().sameSelection(linked, restoredRecord.parent);
          });
          if (committedFollow && ownBatch) {
            // Follow committed before the page stopped, and a real cart now
            // proves the original whole intent. Keep that batch without writes.
            pendingPdpUncertain = false;
            clearPendingAdd();
            return confirmed;
          }
          if (validCarrierPreference(preference) && preference.mode !== 'off') {
            return requirePendingPdpOff(confirmed, canMutate).then(restorePreviousSelection);
          }
          return restorePreviousSelection(confirmed);
        });
      }
      if (pendingAddRollback) return restorePreviousSelection(cart);
      return confirmAddedLine(cart, token, pendingAddQuantity, before).then(function (confirmation) {
        if (!canMutate()) return confirmation.cart;
        if (!confirmation.line) return confirmProtectedRestoration(confirmation.cart, before);
        if (!confirmation.issue) {
          var parent = resolveParent(confirmation.cart, confirmation.line);
          var preference = carrierPreference(confirmation.cart, parent);
          if (validCarrierPreference(preference) && preference.mode !== 'off') {
            return saveCarrierPreference(confirmation.cart, parent, preference.mode === 'follow' ? 'follow' : preference.quantity, false, canMutate);
          }
          return confirmation.cart;
        }
        recordCarrierFailure(confirmation.issue, confirmation.line, confirmation.cart, 'recover-add');
        pendingAddRollback = true;
        return restorePreviousSelection(confirmation.cart);
      });
    }).then(function (cart) {
      // A failed quantity reduction may still have reached Shopify. Preserve all
      // other selections before generic cleanup can touch their carrier lines.
      if (pendingReductionProtection && canMutate()) return confirmProtectedRestoration(cart, pendingReductionProtection);
      return cart;
    }).then(function (cart) { return reconcileCart(cart, canMutate); })
      .then(function (result) {
        var firstReadHasPilot = Boolean(
          result.cart && Array.isArray(result.cart.items) && result.cart.items.some(isKnownPilotLine)
        );

        /* A server/DOM carrier signal or any sent add POST is stronger than one
         * possibly stale clean cart read. Require a second authoritative absence
         * before releasing checkout, while still allowing cleanup to settle. */
        if (startedWithPilotSignal &&
            canMutate() &&
            !firstReadHasPilot &&
            result.removed.length === 0 &&
            !result.deferred) {
          return delay(250).then(getCart).then(function (freshCart) {
            return reconcileCart(freshCart, canMutate);
          }).then(function (confirmedResult) {
            var confirmedReadHasPilot = Boolean(
              confirmedResult.cart &&
              Array.isArray(confirmedResult.cart.items) &&
              confirmedResult.cart.items.some(isKnownPilotLine)
            );
            confirmedResult.confirmedPilotAbsence = !confirmedReadHasPilot &&
              confirmedResult.removed.length === 0 &&
              !confirmedResult.deferred;
            return confirmedResult;
          });
        }

        return result;
      })
      .then(function (result) { return reconcileCarrierPreferences(result, canMutate); })
      .then(function (result) {
        if (result.deferred ||
            startedDuringMutation ||
            startedGeneration !== cartMutationGeneration ||
            startedSignalGeneration !== cartSignalGeneration ||
            startedExternalGeneration !== externalMutationGeneration ||
            externalMutationPending ||
            (unverifiedMutation && (addInFlight || addOperation || removeOperation))) {
          return { needsFreshCart: true, result: result };
        }

        var pendingLine = pendingAddToken
          ? findPilotLineByToken(result.cart, pendingAddToken)
          : null;
        var pendingRemoval = pendingAddRemoval(result);
        var acknowledgedAddStillMissing = Boolean(
          pendingAddToken &&
          pendingAddAcknowledged &&
          !pendingLine &&
          !pendingRemoval
        );

        if (acknowledgedAddStillMissing) {
          unverifiedMutation = true;
          pilotLinePresent = true;
          syncCheckoutGuards();
          return { needsFreshCart: false, result: result, awaitingAddConvergence: true };
        }

        if (pendingReductionProtection) {
          if (protectedCartIssue(result.cart, pendingReductionProtection)) {
            throw new Error('Your previous shade carrier selections are still being checked. Refresh your bag before checkout.');
          }
          pendingReductionProtection = null;
        }
        if (pendingAddToken && pendingLine && !getPilotLineIssue(result.cart, pendingLine)) {
          // A lost response can recover successfully after the first attempt
          // displayed an error. Clear only this now-proven selection's error.
          var recoveredSelection = normaliseProperties(pendingLine.properties)._mekhann_parent_selection_key;
          if (recoveredSelection) {
            delete offerFeedback[recoveredSelection];
            document.querySelectorAll(OFFER_SELECTOR).forEach(function (offer) {
              if (offer.dataset.parentSelectionKey === recoveredSelection) renderStatus(offer, '', false);
            });
          }
        }
        if (pendingAddToken) clearPendingAdd();
        var recoveredUnverifiedMutation = unverifiedMutation;
        // A history guard also owns its forced render. Never transfer that
        // requirement through a global flag to a concurrent unguarded run.
        var needsRender = !ownerToken && (Boolean(guard) || renderVerificationPending || result.removed.length ||
          recoveredUnverifiedMutation || result.confirmedPilotAbsence || result.preferenceChanged);
        return (needsRender ? requireCartRefresh(result.cart, guard) : Promise.resolve(result.cart)).then(function (confirmed) {
          result.cart = confirmed;
          if (!canMutate()) return { needsFreshCart: true, result: result };
          unverifiedMutation = false;
          pilotLinePresent = Boolean(confirmed && confirmed.items && confirmed.items.some(isKnownPilotLine));
          syncCheckoutGuards();
          releaseServerVerificationLocks();
          revealOffers();
          recordCarrierRecovery(confirmed);
          if (pilotLinePresent && !findInvalidPilotLine(confirmed)) clearCarrierFailure();
          if (result.removed.length && !silent) publishNotice(cleanupNotice(result.removed));
          return { needsFreshCart: false, result: result };
        });
      })
      .finally(function () {
        if (reconcileInFlight === activeReconcile) {
          reconcileInFlight = null;
          reconcileStartedSignalGeneration = null;
          reconcileGuard = null;
        }
        syncCheckoutGuards();
      });

    reconcileInFlight = activeReconcile;
    reconcileStamp = reconciliationStamp();
    reconcileStartedSignalGeneration = startedSignalGeneration;
    reconcileGuard = guard || null;
    syncCheckoutGuards();

    reconcileShared = activeReconcile.then(function (outcome) {
      if (!outcome.needsFreshCart) return outcome.result;
      if (externalMutationPending) {
        return outcome.result || { cart: initialCart || null, removed: [], deferred: true };
      }

      var pendingMutation = addOperation || removeOperation;
      return (pendingMutation ? pendingMutation.catch(function () { return null; }) : Promise.resolve())
        .then(function () { return runReconcile(null, silent, ownerToken, guard); });
    });
    return reconcileShared;
  }

  function scheduleReconcile(force) {
    if (!isPilotEnvironment()) return;

    window.clearTimeout(reconcileTimer);
    if (ownedMutation || addInFlight || addOperation || removeOperation) {
      reconcileAfterMutation = true;
      return;
    }
    reconcileTimer = window.setTimeout(function () {
      if (ownedMutation || addInFlight || addOperation || removeOperation) {
        reconcileAfterMutation = true;
        return;
      }
      if (!force && !pilotLinePresent && !pendingAddToken &&
          !document.querySelector(PILOT_LINE_SELECTOR)) return;
      runReconcile(null, false).catch(function (error) {
        publishNotice(error && error.message ? error.message : 'The complimentary shade carrier could not be checked.');
      });
    }, 50);
  }

  function loadOfferPreferences() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(preferenceKey) || 'null');
      if (saved && typeof saved === 'object') {
        offerPreferences = { expanded: saved.expanded === true, selection: String(saved.selection || '') };
      }
    } catch (error) { /* In-memory choice works when storage is unavailable. */ }
  }

  function saveOfferPreferences() {
    try { window.sessionStorage.setItem(preferenceKey, JSON.stringify(offerPreferences)); }
    catch (error) { /* Storage must never prevent shopping. */ }
  }

  function setOfferText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function inlineRemoveBusy() {
    return Boolean(nativeBatchRecord || nativeBatchFault || addInFlight || unverifiedMutation || removeOperation || reconcileInFlight || extrasPending ||
      externalMutationPending || externalVerificationInFlight || groupBusy());
  }

  function syncInlineRemoveControls(root) {
    root.querySelectorAll('[data-mekhann-carrier-remove-parent]').forEach(function (control) {
      control.disabled = isPilotEnvironment() && inlineRemoveBusy();
    });
  }

  function syncOfferChoice(offer, changed) {
    // Parent identity comes from the adjacent server-rendered product. There is
    // no global parent selector and no capacity inherited from a different shade.
    var selected = Math.max(0, Number(offer.dataset.carrierSelected || 0));
    var maximum = Math.max(0, Number(offer.dataset.carrierTotalMax || 0));
    if (!Number.isSafeInteger(selected)) selected = 0;
    if (!Number.isSafeInteger(maximum)) maximum = 0;
    var parentLabel = offer.dataset.parentTitle || 'this lampshade';
    if (offer.dataset.parentVariantTitle && offer.dataset.parentVariantTitle !== 'Default Title') {
      parentLabel += ' · ' + offer.dataset.parentVariantTitle;
    }
    var quantity = offer.querySelector('[data-mekhann-carrier-quantity]');
    var quantityField = offer.querySelector('[data-mekhann-carrier-quantity-field]');
    if (quantity) {
      var preference = offerCarrierPreference(offer);
      var quantityIdentity = String(offer.dataset.parentSelectionKey || '') + ':' + selected + ':' + maximum + ':' + JSON.stringify(preference);
      if (quantity.dataset.mekhannQuantityIdentity !== quantityIdentity) {
        while (quantity.firstChild) quantity.removeChild(quantity.firstChild);
        var followOption = document.createElement('option');
        followOption.value = 'follow';
        followOption.textContent = 'One per lampshade';
        quantity.appendChild(followOption);
        for (var amount = selected > 0 ? 0 : 1; amount <= maximum; amount += 1) {
          var option = document.createElement('option');
          option.value = String(amount);
          option.textContent = amount === 0 ? 'None' : String(amount);
          quantity.appendChild(option);
        }
        quantity.dataset.mekhannQuantityIdentity = quantityIdentity;
        quantity.value = preference && preference.mode === 'custom' ? String(Math.min(Number(preference.quantity), maximum)) :
          preference && preference.mode === 'follow' ? 'follow' : selected > 0 ? String(Math.min(selected, maximum)) : 'follow';
      }
      quantity.disabled = addInFlight || Boolean(removeOperation) || maximum < 1;
    }
    if (quantityField) quantityField.hidden = selected === 0 && maximum < 2;
    var unavailable = offer.querySelector('[data-mekhann-carrier-availability]');
    if (unavailable) unavailable.hidden = Boolean(offer.dataset.carrierVariantId && maximum > 0);
    var add = offer.querySelector('[data-mekhann-carrier-add]');
    if (add) {
      add.hidden = selected === 0 && maximum < 1;
      add.disabled = addInFlight || Boolean(removeOperation) || (selected === 0 && maximum < 1);
      var desired = quantity && quantity.value !== 'follow' ? Number(quantity.value) : maximum;
      setOfferText(add, selected > 0 ? 'Save' : 'Add ' + desired + (desired === 1 ? ' shade carrier' : ' shade carriers'));
      add.setAttribute('aria-label', (selected > 0 ? 'Save ' : 'Add ') + desired + (desired === 1 ? ' shade carrier for ' : ' shade carriers for ') + parentLabel);
    }
    var remove = offer.querySelector('[data-mekhann-carrier-remove-parent]');
    if (remove) remove.disabled = inlineRemoveBusy();
    var advisor = offer.querySelector('[data-mekhann-advisor-open]');
    if (advisor) {
      advisor.dataset.mekhannAdvisorProduct = offer.dataset.parentTitle || 'Shade carrier';
      advisor.dataset.mekhannAdvisorVariant = offer.dataset.parentVariantTitle || '';
      advisor.dataset.mekhannAdvisorUrl = offer.dataset.parentUrl || '';
    }
    if (changed && !offerFeedback[String(offer.dataset.parentSelectionKey || offer.dataset.parentVariantId || '')]) renderStatus(offer, '', false);
    syncFollowRetry(offer);
  }

  // A retry is a new explicit request for a previously proven shortfall. Keep
  // its physical selection identity: display aggregation must never retarget
  // it to another purchase of the same variant or a different carrier.
  function followRetryPlan(cart, descriptor) {
    var groups = cartGroups();
    if (!groups || !cart || !Array.isArray(cart.items) || priorCartToken(cart) || !cart.token || !descriptor) return null;
    var parents = cart.items.filter(function (item) {
      return !isCarrierVariant(item) && !nativeParentKey(item) && groups.sameSelection(item, descriptor);
    });
    if (parents.length !== 1) return null;
    var parent = parents[0], preference = carrierPreference(cart, parent);
    if (!validCarrierPreference(preference) || preference.mode !== 'follow' || preference.suspended !== true ||
        !preference.selectionKey) return null;
    var quantity = parentQuantity(cart, parent), selected = carrierQuantityForParent(cart, parent);
    if (!positiveQuantity(quantity) || !Number.isSafeInteger(selected) || selected < 0 || selected >= quantity ||
        !sameMoney(parent.original_line_price, parent.final_line_price) || findInvalidPilotLine(cart)) return null;
    var variantId = numericId(preference.chosenCarrierVariantId);
    var option = carrierOptions(cart, parent.variant_id).find(function (entry) { return entry.id === variantId; });
    if (!variantId || !option || linkedCarriers(cart, parent).some(function (child) {
      return numericId(child.variant_id) !== variantId || getPilotLineIssue(cart, child);
    })) return null;
    return { parent: groups.selectionDescriptor(parent), quantity: quantity, selected: selected,
      carrierVariantId: variantId, selectionKey: preference.selectionKey, currency: cart.currency,
      originalPrice: parent.original_price, finalPrice: parent.final_price, cartToken: cart.token,
      available: Boolean(option.available) };
  }

  function followRetryBlocked() {
    return Boolean(followRetryOperation || inlineRemoveBusy() || ownedMutation || pendingAddToken || pendingPdpRecord ||
      pendingReductionProtection || ownedParentUncertain || ownedQuantityUncertain || pdpRecoveryFault || checkoutInFlight);
  }

  function syncFollowRetry(offer) {
    var region = offer.querySelector('[data-mekhann-carrier-shortfall]');
    if (!region) return;
    var descriptor;
    try { descriptor = JSON.parse(offer.dataset.parentGroup || ''); } catch (error) { descriptor = null; }
    var preference = offerCarrierPreference(offer);
    // Healthy, custom and Off selections need no extra cart/economic walk on
    // every guard sync. Full proof is reserved for an actual suspended deficit.
    var plan = preference && preference.mode === 'follow' && preference.suspended === true
      ? followRetryPlan(observedCarrierCart, descriptor) : null;
    // Metadata must describe the same verified physical rows currently shown.
    if (plan && (plan.quantity !== Number(offer.dataset.parentQuantity) || plan.selected !== Number(offer.dataset.carrierSelected) ||
        plan.selectionKey !== offer.dataset.parentSelectionKey || offer.dataset.carrierProven !== 'true')) plan = null;
    offer.__mekhannFollowRetry = plan;
    var recovery = offer.querySelector('[data-mekhann-carrier-retry-recovery]');
    if (recovery) {
      var feedback = offerFeedback[String(offer.dataset.parentSelectionKey || '')];
      var pendingHere = pendingPdpRecord && descriptor && cartGroups().sameSelection(descriptor, pendingPdpRecord.parent);
      recovery.hidden = !(unverifiedMutation && !ownedMutation && !addInFlight && !addOperation && !reconcileInFlight &&
        (plan || pendingHere || feedback && feedback.isError));
    }
    region.hidden = !plan;
    var control = region.querySelector('[data-mekhann-carrier-retry]');
    if (!plan) { if (control) control.disabled = true; return; }
    setOfferText(region.querySelector('[data-mekhann-carrier-shortfall-message]'),
      plan.selected + ' of ' + plan.quantity + ' shade carriers added.');
    if (control) {
      control.disabled = followRetryBlocked() || !plan.available;
      control.setAttribute('aria-label', 'Retry shade carriers for ' + (offer.dataset.parentTitle || 'this lampshade'));
    }
    var unavailable = region.querySelector('[data-mekhann-carrier-retry-unavailable]');
    if (unavailable) unavailable.hidden = plan.available;
  }

  function retryFollowCarrier(control) {
    var offer = control.closest(OFFER_SELECTOR);
    if (!isPilotEnvironment() || !offer || !document.contains(control) || offer.hidden || control.disabled || followRetryBlocked()) return;
    var command = offer.__mekhannFollowRetry;
    if (!command || !command.available) return;
    // Reserve synchronously, before beginOwnedMutation's asynchronous idle
    // check, so double clicks cannot queue two requests for the same deficit.
    followRetryOperation = true;
    var owner = null;
    var latest = null;
    var growthStarted = false;
    setStatus(offer, 'Adding…', false);
    syncCheckoutGuards();
    followRetryOperation = beginOwnedMutation().then(function (token) {
      owner = token;
      return getCart();
    }).then(function (cart) {
      latest = cart;
      var fresh = followRetryPlan(cart, command.parent);
      if (!ownedCurrent(owner) || !fresh || !nativeEqual(fresh, command)) {
        throw new Error('Your bag has changed. Refresh it before retrying the shade carriers.');
      }
      var parent = cart.items.find(function (item) {
        return !isCarrierVariant(item) && !nativeParentKey(item) && cartGroups().sameSelection(item, command.parent);
      });
      growthStarted = true;
      return growCarrierPreference(cart, parent, carrierPreference(cart, parent), function () { return ownedCurrent(owner); });
    }).then(function (cart) {
      return settleOwnedMutation(owner, { cart: cart });
    }).then(function (result) {
      // Failure can be a verified restoration with a remaining shortfall.
      // Its persistent quantities, not a generic success message, tell the result.
      if (receiptCurrent(result.renderReceipt)) setStatus(offer, '', false);
    }).catch(function (error) {
      function keepUnverified(failure) {
        if (owner && ownedMutation === owner) ownedMutation = null;
        if (owner) unverifiedMutation = true;
        setStatus(offer, failure && failure.message || 'The shade carriers could not be confirmed. Refresh your bag before continuing.', true);
      }
      // A stale button rejected before ANY write can accept a fresh complete
      // read/render, without reconciling or mutating a different selection.
      if (!growthStarted && owner && ownedCurrent(owner) && latest && !unverifiedMutation &&
          !pendingAddToken && !pendingPdpRecord && !findInvalidPilotLine(latest)) {
        return requireCartRefresh(latest, function () {
          if (!ownedCurrent(owner)) throw new Error('Your bag changed while it was being checked. Refresh your bag.');
        }).then(function (confirmed) {
          var result = finishOwnedMutation(owner, { cart: confirmed, renderReceipt: lastRenderReceipt });
          if (receiptCurrent(result.renderReceipt)) setStatus(offer, 'Your bag has changed. Please review the shade carrier quantity before retrying.', true);
        }).catch(keepUnverified);
      }
      keepUnverified(error);
      // In particular, a missing unknown POST remains journalled and locked.
      // Never replay it or use clean old reads to turn this into another Retry.
    }).finally(function () {
      followRetryOperation = null;
      syncCheckoutGuards();
      revealOffers();
    });
  }

  function setOfferExpanded(offer, expanded) {
    var body = offer.querySelector('[data-mekhann-carrier-expanded]');
    var restore = offer.querySelector('[data-mekhann-carrier-collapsed]');
    if (body) body.hidden = !expanded;
    if (restore) restore.hidden = expanded;
    var trigger = offer.querySelector('[data-mekhann-carrier-restore]');
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    offer.classList.toggle('is-collapsed', !expanded);
  }

  function chooseOffer(offer, expanded) {
    if (!offer || addInFlight || removeOperation) return;
    offerPreferences.expanded = expanded;
    offerPreferences.selection = expanded ? String(offer.dataset.parentSelectionKey || '') : '';
    saveOfferPreferences();
    revealOffers();
    var quantity = offer.querySelector('[data-mekhann-carrier-quantity]');
    var quantityField = offer.querySelector('[data-mekhann-carrier-quantity-field]');
    var control = expanded && quantityField && !quantityField.hidden ? quantity :
      offer.querySelector(expanded ? '[data-mekhann-carrier-add]' : '[data-mekhann-carrier-restore]');
    if (control && (control.disabled || control.hidden)) control = offer.querySelector('.mekhann-cart-carrier-pilot__help summary');
    if (control) control.focus({ preventScroll: true });
  }

  function rememberInlineFocus(offer) {
    var form = offer.closest(FORM_SELECTOR);
    inlineReturnFocus = { selection: offer.dataset.parentSelectionKey, form: form && form.id, previousNode: offer, descriptor: offer.dataset.parentGroup };
  }

  function restoreInlineFocus() {
    if (!inlineReturnFocus || addInFlight || removeOperation) return;
    var form = document.getElementById(inlineReturnFocus.form);
    if (!form) return;
    var drawer = form.closest(DRAWER_SELECTOR);
    if (drawer && !drawer.classList.contains('drawer--is-open')) { inlineReturnFocus = null; return; }
    var offer = Array.prototype.find.call(form.querySelectorAll(OFFER_SELECTOR), function (entry) {
      return entry.dataset.parentSelectionKey === inlineReturnFocus.selection;
    });
    if (offer === inlineReturnFocus.previousNode) return;
    var control = offer && offer.querySelector('[data-mekhann-carrier-remove-parent], [data-mekhann-carrier-restore]');
    if (!control) {
      var row = Array.prototype.find.call(form.querySelectorAll('[data-mekhann-parent-selection]'), function (entry) {
        try { return cartGroups().sameSelection(JSON.parse(entry.dataset.mekhannParentSelection), JSON.parse(inlineReturnFocus.descriptor)); }
        catch (error) { return false; }
      });
      control = row && row.querySelector('[data-mekhann-fitting-options]');
    }
    if (control && !control.hidden && !control.disabled) {
      inlineReturnFocus = null;
      control.focus();
    }
  }

  function revealOffers() {
    if (!isPilotEnvironment()) return;
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (drawer) drawer.classList.add(ACTIVE_CLASS);
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      form.querySelectorAll(OFFER_SELECTOR).forEach(function (offer) {
        offer.hidden = false;
        syncOfferChoice(offer, false);
        setOfferExpanded(offer, offerPreferences.expanded && offerPreferences.selection === offer.dataset.parentSelectionKey);
        var savedFeedback = offerFeedback[String(offer.dataset.parentSelectionKey || offer.dataset.parentVariantId || '')];
        if (savedFeedback) {
          renderStatus(offer, savedFeedback.message, savedFeedback.isError);
        }
      });
    });
  }

  function parentRemoveBusy(form, includeFormFlag) {
    // Match CartForm.quantityChanged, including its existing metadata-only queue.
    var queueRemove = canQueueRemoveAfterExtras();
    var cartForm = form && form.__mekhannCartForm;
    // CartForm clears its local flag after the engine's final guard sync.
    // Capture still checks it; visual locks follow the engine's live owner.
    return Boolean(includeFormFlag && cartForm && cartForm.cartItemsUpdated || form && form.getAttribute('aria-busy') === 'true' ||
      !queueRemove && (groupBusy() || nativeBatchRecord || nativeBatchFault || ownedMutation || pendingRemoveIntent ||
        addInFlight || removeOperation || reconcileInFlight || checkoutInFlight || extrasPending ||
        unverifiedMutation || externalMutationPending || externalVerificationInFlight));
  }

  function syncParentRemoveControls(form) {
    var busy = isPilotEnvironment() && parentRemoveBusy(form);
    form.querySelectorAll('[data-mekhann-group-remove]').forEach(function (control) {
      var prior = parentRemoveLocks.get(control);
      if (busy && !prior && control.getAttribute('aria-disabled') !== 'true' && !control.hasAttribute('disabled')) {
        prior = { aria: control.getAttribute('aria-disabled'), tab: control.getAttribute('tabindex'),
          opacity: control.style.getPropertyValue('opacity'), cursor: control.style.getPropertyValue('cursor'),
          opacityPriority: control.style.getPropertyPriority('opacity'), cursorPriority: control.style.getPropertyPriority('cursor') };
        parentRemoveLocks.set(control, prior);
        control.setAttribute('data-mekhann-parent-remove-busy', 'true');
        control.setAttribute('aria-disabled', 'true');
        control.setAttribute('tabindex', '-1');
        control.style.setProperty('opacity', '0.55');
        control.style.setProperty('cursor', 'wait');
      } else if (!busy && prior) {
        parentRemoveLocks.delete(control);
        if (control.getAttribute('data-mekhann-parent-remove-busy') !== 'true') return;
        control.removeAttribute('data-mekhann-parent-remove-busy');
        if (control.getAttribute('aria-disabled') === 'true' && !control.hasAttribute('disabled')) {
          if (prior.aria === null) control.removeAttribute('aria-disabled'); else control.setAttribute('aria-disabled', prior.aria);
        }
        if (control.getAttribute('tabindex') === '-1' && !control.hasAttribute('disabled')) {
          if (prior.tab === null) control.removeAttribute('tabindex'); else control.setAttribute('tabindex', prior.tab);
        }
        [['opacity', '0.55', prior.opacity, prior.opacityPriority], ['cursor', 'wait', prior.cursor, prior.cursorPriority]].forEach(function (style) {
          if (control.style.getPropertyValue(style[0]) !== style[1] || control.style.getPropertyPriority(style[0])) return;
          if (style[2]) control.style.setProperty(style[0], style[2], style[3]); else control.style.removeProperty(style[0]);
        });
        if (prior.notice && prior.notice.textContent === prior.noticeText) {
          prior.notice.textContent = ''; prior.notice.classList.add('hide');
        }
      }
    });
  }

  function guardParentRemoveClick(event) {
    var control = event.target.closest('[data-mekhann-group-remove]');
    var form = control && control.closest(FORM_SELECTOR);
    if (!form || !isPilotEnvironment() || !parentRemoveBusy(form, true) && control.getAttribute('aria-disabled') !== 'true' && !control.hasAttribute('disabled')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    syncParentRemoveControls(form);
    var cartForm = form.__mekhannCartForm, row = control.closest('[data-mekhann-cart-group]'), identity = null;
    try { identity = row && JSON.parse(row.dataset.mekhannCartGroup); } catch (ignore) {}
    if (cartForm && typeof cartForm.showCartError === 'function') {
      cartForm.showCartError(nativeBatchFault ? NATIVE_FAULT_MESSAGE : nativeRecoveryNeedsRefresh ? NATIVE_REFRESH_MESSAGE : nativeBatchRecord && !ownedMutation && !addInFlight && !addOperation && !removeOperation && !reconcileInFlight ?
        'Check your previous addition using Check bag before removing an item.' :
        'Your bag is updating. Please wait before removing this item.', identity);
      var prior = parentRemoveLocks.get(control);
      if (prior) {
        prior.notice = row && row.querySelector('[data-cart-item-error]') || form.querySelector('[data-mekhann-cart-error]');
        prior.noticeText = prior.notice && prior.notice.textContent;
      }
    }
  }

  function syncNativeRecoveryControl(form) {
    var box = form.querySelector('[data-mekhann-native-recovery]');
    if (!nativeBatchRecord && !nativeBatchFault) { if (box) box.remove(); return; }
    var active = Boolean(ownedMutation || addInFlight || addOperation || removeOperation || reconcileInFlight ||
      checkoutInFlight || extrasPending || externalMutationPending || externalVerificationInFlight);
    // The ordinary in-flight batch already has its own presentation. Offer
    // recovery only when it has stopped, keeping a started Check visible.
    if (active && !nativeRecoveryOperation && !box) return;
    if (!box) {
      box = document.createElement('div');
      box.className = 'mekhann-cart-native-recovery';
      box.setAttribute('data-mekhann-native-recovery', '');
      var message = document.createElement('p');
      message.setAttribute('data-mekhann-native-recovery-message', '');
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      box.appendChild(message);
      // Keep recovery outside an unresolved drawer Add's inert content panels.
      var panel = form.querySelector('.drawer__inner');
      var checkout = checkoutControl(form, null);
      if (panel && panel.parentNode === form) form.insertBefore(box, panel);
      else if (checkout && checkout.parentNode) checkout.parentNode.insertBefore(box, checkout);
      else form.appendChild(box);
    }
    var status = box.querySelector('[data-mekhann-native-recovery-message]');
    var control = box.querySelector('[data-mekhann-native-recovery-check]');
    var contact = box.querySelector('[data-mekhann-native-recovery-contact]');
    var refresh = box.querySelector('[data-mekhann-native-recovery-refresh]');
    if (nativeBatchFault || nativeRecoveryNeedsRefresh) {
      if (control) control.remove();
      if (nativeBatchFault && refresh) refresh.remove();
      if (!nativeBatchFault && contact) contact.remove();
      var action = nativeBatchFault ? contact : refresh;
      if (!action) {
        action = document.createElement('a');
        action.className = 'text-link';
        action.href = nativeBatchFault ? '/pages/contact' : route('cartPage', 'cart');
        action.setAttribute(nativeBatchFault ? 'data-mekhann-native-recovery-contact' : 'data-mekhann-native-recovery-refresh', '');
        action.textContent = nativeBatchFault ? 'Contact us' : 'Refresh bag'; box.appendChild(action);
      }
      status.textContent = nativeBatchFault ? NATIVE_FAULT_MESSAGE : NATIVE_REFRESH_MESSAGE;
      return;
    }
    if (contact) contact.remove();
    if (refresh) refresh.remove();
    if (!control) {
      control = document.createElement('button');
      control.type = 'button'; control.className = 'text-link';
      control.setAttribute('data-mekhann-native-recovery-check', '');
      control.addEventListener('click', function () { checkNativeBatch().catch(function () {}); });
      box.appendChild(control);
    }
    status.textContent = nativeRecoveryMessage || 'Your previous addition needs checking.';
    control.textContent = nativeRecoveryOperation ? 'Checking…' : 'Check bag';
    control.disabled = Boolean(nativeRecoveryOperation || active || nativeBatchFault);
    control.setAttribute('aria-busy', nativeRecoveryOperation ? 'true' : 'false');
  }

  function syncCheckoutVerificationControl(form) {
    var control = checkoutControl(form, null);
    if (!control) return;
    // Capture already blocks checkout after an unverified operation. Reflect
    // that terminal state on the button without competing with a running
    // Add's own presentation lock or claiming an inherited disabled control.
    var terminal = unverifiedMutation && !ownedMutation && !addInFlight && !addOperation &&
      !removeOperation && !reconcileInFlight && !externalMutationPending && !externalVerificationInFlight;
    var prior = checkoutVerificationLocks.get(control);
    if (isPilotEnvironment() && terminal && !prior && !control.disabled && control.getAttribute('aria-disabled') !== 'true') {
      prior = { aria: control.getAttribute('aria-disabled') };
      checkoutVerificationLocks.set(control, prior);
      control.setAttribute('data-mekhann-checkout-verification-lock', 'true');
      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
    } else if (prior && !unverifiedMutation && !ownedQuantityUncertain && !ownedParentUncertain &&
        !nativeBatchRecord && !nativeBatchFault && !renderVerificationPending && lastRenderReceipt && lastRenderReceipt.stamp === generationStamp()) {
      checkoutVerificationLocks.delete(control);
      if (control.getAttribute('data-mekhann-checkout-verification-lock') !== 'true') return;
      control.removeAttribute('data-mekhann-checkout-verification-lock');
      if (!control.hasAttribute('data-mekhann-add-checkout-lock') && !control.hasAttribute('data-mekhann-carrier-server-lock') &&
          !control.hasAttribute('data-mekhann-checkout-pending-lock')) {
        control.disabled = false;
        if (control.getAttribute('aria-disabled') === 'true') {
          if (prior.aria === null) control.removeAttribute('aria-disabled'); else control.setAttribute('aria-disabled', prior.aria);
        }
      }
    }
  }

  function checkoutPendingBusy() {
    // Autosaving metadata does not change the displayed quantities or prices.
    // Keep its queue/checkout proof guards, but let a Checkout click express an
    // intent that waits for the save. Only this exact metadata queue owner may
    // be visually quiet; a separate cart/form operation must still lock the CTA.
    var metadataOnly = cartExtras && cartExtras.ordinarySavePending();
    var metadataGroup = metadataOnly && cartExtras.ownsGroupTask() &&
      !document.querySelector('#CartDrawerForm[aria-busy="true"], #CartPageForm[aria-busy="true"]');
    return Boolean(ownedMutation || pendingRemoveIntent || addInFlight || addOperation || removeOperation || reconcileInFlight ||
      externalMutationPending || externalVerificationInFlight || extrasPending && !metadataOnly || groupBusy() && !metadataGroup);
  }

  function syncCheckoutPendingControl(form, pending) {
    var control = checkoutControl(form, null);
    if (!control) return;
    var busy = isPilotEnvironment() && Boolean(pending || control.hasAttribute('data-mekhann-checkout-explicit-busy'));
    var prior = checkoutPendingLocks.get(control);
    if (busy) {
      if (!prior) {
        var knownLock = control.hasAttribute('data-mekhann-add-checkout-lock') ||
          control.hasAttribute('data-mekhann-carrier-server-lock') || control.hasAttribute('data-mekhann-checkout-verification-lock');
        prior = {
          independentDisabled: control.disabled && !knownLock,
          aria: knownLock ? null : control.getAttribute('aria-disabled'),
          ariaBusy: control.getAttribute('aria-busy')
        };
        checkoutPendingLocks.set(control, prior);
      }
      control.setAttribute('data-mekhann-checkout-pending-lock', 'true');
      control.setAttribute('data-mekhann-checkout-busy', 'true');
      control.setAttribute('aria-busy', 'true');
      control.setAttribute('aria-disabled', 'true');
      control.disabled = true;
    } else if (prior) {
      checkoutPendingLocks.delete(control);
      if (control.getAttribute('data-mekhann-checkout-pending-lock') !== 'true') return;
      control.removeAttribute('data-mekhann-checkout-pending-lock');
      control.removeAttribute('data-mekhann-checkout-busy');
      if (control.getAttribute('aria-busy') === 'true') {
        if (prior.ariaBusy === null) control.removeAttribute('aria-busy');
        else control.setAttribute('aria-busy', prior.ariaBusy);
      }
      if (!prior.independentDisabled && !control.hasAttribute('data-mekhann-add-checkout-lock') &&
          !control.hasAttribute('data-mekhann-carrier-server-lock') && !control.hasAttribute('data-mekhann-checkout-verification-lock')) {
        control.disabled = false;
        if (control.getAttribute('aria-disabled') === 'true') {
          if (prior.aria === null) control.removeAttribute('aria-disabled'); else control.setAttribute('aria-disabled', prior.aria);
        }
      }
    }
  }

  function syncCheckoutGuards() {
    var pilotEnvironment = isPilotEnvironment();
    var shouldGuard = pilotEnvironment && (
      nativeBatchRecord || nativeBatchFault ||
      ownedMutation || pendingRemoveIntent ||
      addInFlight ||
      unverifiedMutation ||
      pilotLinePresent ||
      Boolean(pendingAddToken) ||
      externalMutationPending ||
      externalVerificationInFlight
    );

    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      var formHasPilotLine = Boolean(form.querySelector(PILOT_LINE_SELECTOR));
      form.classList.toggle(GUARD_CLASS, pilotEnvironment && (shouldGuard || formHasPilotLine));
      // A pending carrier request should look pending, not like a broken +.
      // Stock and a pending operation can own the same native disable. Track
      // both so rolling an optimistic maximum back cannot release a busy lock.
      var busy = pilotEnvironment && Boolean(nativeBatchRecord || nativeBatchFault || ownedMutation || pendingRemoveIntent || addInFlight || removeOperation || reconcileInFlight ||
        unverifiedMutation || externalMutationPending || externalVerificationInFlight ||
        // Ordinary metadata saves accept one owned quantity intent below.
        // Every other metadata/group owner must show its actual busy state.
        (extrasPending || groupBusy() || checkoutInFlight) && !canQueueQuantityAfterExtras());
      form.querySelectorAll('.js-qty__adjust').forEach(function (control) {
        var wrapper = control.closest('.js-qty__wrapper');
        var selector = wrapper && wrapper.__mekhannQtySelector;
        var independentlyDisabled = selector && selector.plus === control && selector.plusIndependentDisabled;
        if (busy && !independentlyDisabled && (!control.disabled || control.hasAttribute('data-mekhann-stock-limited'))) {
          control.dataset.mekhannCarrierBusyLock = 'true';
          control.disabled = true;
        } else if (!busy && control.dataset.mekhannCarrierBusyLock === 'true') {
          delete control.dataset.mekhannCarrierBusyLock;
          // Stock may have changed while this operation owned the native lock.
          // Preserve its new stock owner and independently declared aria lock.
          control.disabled = Boolean(independentlyDisabled || control.hasAttribute('data-mekhann-stock-limited') || control.getAttribute('aria-disabled') === 'true');
        }
      });
      // The section can be replaced while a fitting request is still pending.
      // Keep only inline Remove controls in step with their actual click guard.
      syncInlineRemoveControls(form);
      form.querySelectorAll(OFFER_SELECTOR).forEach(syncFollowRetry);
      syncParentRemoveControls(form);
      // Release this operation's pending lock before transferring an unresolved
      // terminal result to the existing verification lock. No event can interleave.
      var pendingBusy = checkoutPendingBusy();
      syncCheckoutPendingControl(form, pendingBusy);
      syncCheckoutVerificationControl(form);
      if (form.id === 'CartPageForm' && form.hidden) {
        var hiddenRecovery = form.querySelector('[data-mekhann-native-recovery]');
        if (hiddenRecovery) hiddenRecovery.remove();
      } else syncNativeRecoveryControl(form);
      var pending = form.querySelector('[data-mekhann-carrier-pending]');
      presentStatus(pending, pendingBusy || controlCheckoutBusy(form) ? 'Updating bag…' : '', 'pending');
    });
    var pageForm = document.getElementById('CartPageForm');
    document.querySelectorAll('[data-mekhann-native-recovery-host]').forEach(function (host) {
      if (!pageForm || pageForm.hidden) syncNativeRecoveryControl(host);
      else {
        var pageRecovery = host.querySelector('[data-mekhann-native-recovery]');
        if (pageRecovery) pageRecovery.remove();
      }
    });
  }

  function controlCheckoutBusy(form) {
    var control = checkoutControl(form, null);
    return Boolean(control && control.hasAttribute('data-mekhann-checkout-explicit-busy'));
  }

  function renderStatus(offer, message, isError) {
    var status = offer && offer.querySelector('[data-mekhann-carrier-status]');
    if (!status) return;

    presentStatus(status, message, isError ? 'error' : /^(Updating|Adding|Saving)…$/.test(message || '') ? 'pending' : 'success');
    status.classList.toggle('is-error', Boolean(isError));
  }

  // Status remains available to assistive technology. Normal progress and
  // confirmation are visually quiet; only a long wait or real error expands it.
  // Repeated renders of the same operation must not restart the four-second clock.
  function presentStatus(node, message, kind, longWaitMessage) {
    if (!node) return;
    message = message || '';
    var previous = node.__mekhannCalmStatus;
    if (message && kind === 'pending' && previous && previous.pending && previous.message === message) return;
    if (previous && previous.timer) window.clearTimeout(previous.timer);
    var state = { pending: Boolean(message && kind === 'pending'), message: message, timer: null };
    node.__mekhannCalmStatus = state;
    if (node.textContent !== message) node.textContent = message;
    node.hidden = !message;
    if (!message) { node.removeAttribute('data-mekhann-status-kind'); return; }
    node.setAttribute('data-mekhann-status-kind', kind || 'success');
    if (state.pending) {
      state.timer = window.setTimeout(function () {
        state.timer = null;
        if (node.__mekhannCalmStatus !== state || !state.pending || !document.contains(node)) return;
        node.setAttribute('data-mekhann-status-kind', 'long-wait');
        node.textContent = longWaitMessage || 'Your bag is taking longer to update.';
      }, 4000);
    }
  }

  function setStatus(offer, message, isError) {
    var parentId = offer && offer.dataset && String(offer.dataset.parentSelectionKey || offer.dataset.parentVariantId || '');
    if (parentId) {
      // Impulse replaces the offer after cart:build. Preserve feedback for the
      // replacement node, rather than writing only to the detached old node.
      if (isError) {
        // An unresolved error belongs to this selection, not to a timer.
        // Clear it only on the next explicit action or verified recovery.
        offerFeedback[parentId] = { message: message || '', isError: true };
      } else {
        delete offerFeedback[parentId];
      }
    }
    renderStatus(offer, message, isError);
    if (!parentId) return;
    document.querySelectorAll(OFFER_SELECTOR).forEach(function (currentOffer) {
      if (String(currentOffer.dataset.parentSelectionKey || currentOffer.dataset.parentVariantId || '') === parentId) {
        renderStatus(currentOffer, message, isError);
      }
    });
  }

  function setBusy(control, busy) {
    if (!control) return;
    if (control.matches && control.matches('[name="checkout"]')) {
      if (busy) control.setAttribute('data-mekhann-checkout-explicit-busy', 'true');
      else control.removeAttribute('data-mekhann-checkout-explicit-busy');
      var form = control.closest(FORM_SELECTOR);
      if (form) {
        syncCheckoutPendingControl(form, checkoutPendingBusy());
        syncCheckoutVerificationControl(form);
        presentStatus(form.querySelector('[data-mekhann-carrier-pending]'), checkoutPendingBusy() || busy ? 'Updating bag…' : '', 'pending');
      }
      return;
    }
    control.disabled = Boolean(busy || checkoutVerificationLocks.has(control) &&
      control.getAttribute('data-mekhann-checkout-verification-lock') === 'true');
    control.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function issueMessage(issue, reasonCode) {
    if (issue === 'parent-price-changed') {
      return 'We could not confirm the lampshade price. The shade carrier has been removed; please check your bag.';
    }
    if (issue === 'not-complimentary' || issue === 'existing-carrier-changed' || issue === 'incomplete-carrier-add') {
      return 'We could not confirm the additional shade carriers as complimentary. This addition was removed; your previous selection remains in the bag.';
    }

    return 'The shade carrier could not be linked to this lampshade and was removed. Please check your bag before checkout.';
  }

  function addCarrier(control) {
    var offer = control.closest(OFFER_SELECTOR);
    if (!offer || !isPilotEnvironment() || offer.hidden || addInFlight || unverifiedMutation ||
        removeOperation || reconcileInFlight || extrasPending || externalMutationPending || externalVerificationInFlight || groupBusy()) return;

    var quantityControl = offer.querySelector('[data-mekhann-carrier-quantity]');
    var choice = quantityControl ? quantityControl.value : 'follow';
    var requestedTotal = choice === 'follow' ? Number(offer.dataset.carrierTotalMax) : Number(choice);
    var renderedSelected = Number(offer.dataset.carrierSelected || 0);
    if (!Number.isSafeInteger(requestedTotal) || requestedTotal < 0) {
      setStatus(offer, 'Please choose a valid shade carrier quantity.', true);
      return;
    }
    if (requestedTotal <= renderedSelected) {
      reduceCarrierSelection(offer, requestedTotal, control, choice);
      return;
    }
    var data = {
      choice: choice,
      quantity: requestedTotal - renderedSelected,
      desiredTotal: requestedTotal,
      previousTotal: renderedSelected,
      parentLineKey: offer.dataset.parentLineKey,
      parentVariantId: numericId(offer.dataset.parentVariantId),
      parentTitle: offer.dataset.parentTitle,
      parentVariantTitle: offer.dataset.parentVariantTitle,
      carrierVariantId: numericId(offer.dataset.carrierVariantId)
    };

    if (!data.parentLineKey ||
        !(data.parentVariantId > 0) || !(data.carrierVariantId > 0)) {
      setStatus(offer, 'Please refresh your bag to check the shade carrier option.', true);
      return;
    }

    rememberInlineFocus(offer);
    addInFlight = true;
    syncCheckoutGuards();
    setBusy(control, true);
    syncOfferChoice(offer, false);
    setStatus(offer, 'Adding…', false);

    var token = BUILD + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    var addMutationGeneration = 0;
    var protectedBeforeAdd = null;
    var preflightMutationGeneration = cartMutationGeneration;
    var preflightExternalGeneration = externalMutationGeneration;
    var canMutateDuringPreflight = function () {
      return preflightMutationGeneration === cartMutationGeneration &&
        preflightExternalGeneration === externalMutationGeneration &&
        !externalMutationPending &&
        !removeOperation;
    };

    addOperation = getCart()
      .then(function (cart) {
        return reconcileCart(cart, canMutateDuringPreflight);
      })
      .then(function (result) {
        if (result.deferred || externalMutationPending ||
            preflightExternalGeneration !== externalMutationGeneration) {
          throw new Error('Please wait for the shopping bag to finish updating, then try the shade carrier again.');
        }
        if (result.removed.length) refreshCart(result.cart);

        var groups = cartGroups();
        if (!groups) throw new Error('Please refresh your bag before adding the shade carrier.');
        var renderedGroup = offer.dataset.parentGroup || '';
        var descriptor = null;
        try { descriptor = JSON.parse(renderedGroup); } catch (error) { /* Invalid identity is rejected below. */ }
        var parent = findParent(result.cart, data.parentLineKey);
        if (!parent || !descriptor || !groups.sameSelection(parent, descriptor)) {
          parent = descriptor ? result.cart.items.find(function (item) {
            return !isCarrierVariant(item) && !nativeParentKey(item) && groups.sameSelection(item, descriptor);
          }) : null;
        }
        if (!parent || numericId(parent.variant_id) !== data.parentVariantId ||
            mappedCarrier(result.cart, parent.variant_id) !== data.carrierVariantId ||
            parentQuantity(result.cart, parent) < 1) {
          throw new Error('This shade carrier option has changed. Refresh your bag or contact an advisor for fitting help.');
        }
        data.parentLineKey = parent.key;
        data.parentGroup = renderedGroup;
        data.parentSelectionKey = offer.dataset.parentSelectionKey || '';
        if (!data.parentSelectionKey) {
          throw new Error('Your bag has changed. Please refresh before choosing a shade carrier.');
        }
        var currentCarrierQuantity = carrierQuantityForParent(result.cart, parent);
        // An editor opened before another cart mutation must not add an old delta.
        if (currentCarrierQuantity !== data.previousTotal) {
          refreshCart(result.cart);
          throw new Error('Your shade carrier selection has changed. Please check the quantity and try again.');
        }
        var remaining = parentQuantity(result.cart, parent) - currentCarrierQuantity;
        if (data.quantity > remaining) {
          refreshCart(result.cart);
          throw new Error('Your shade carrier quantity cannot exceed the quantity of this lampshade. Please check your selection.');
        }
        protectedBeforeAdd = commerceSnapshot(result.cart);
        return saveCarrierPreference(result.cart, parent, data.choice, true, canMutateDuringPreflight);
      }).then(function (savedCart) {
        if (!canMutateDuringPreflight() || protectedCartIssue(savedCart, protectedBeforeAdd)) throw new Error('Your bag changed while the shade carrier preference was saving. Please check your selection.');
        var savedParent = savedCart.items.find(function (item) { return !isCarrierVariant(item) && cartGroups().sameSelection(item, JSON.parse(data.parentGroup)); });
        if (!savedParent) throw new Error('Your lampshade selection has changed.');
        data.parentLineKey = savedParent.key;
        cartMutationGeneration += 1;
        addMutationGeneration = cartMutationGeneration;
        pendingAddToken = token;
        pendingAddAcknowledged = false;
        pendingAddQuantity = data.quantity;
        pendingAddProtection = protectedBeforeAdd;
        pendingAddRollback = false;
        unverifiedMutation = true;
        markPilotSignal();
        syncCheckoutGuards();
        return requestJson(route('cartAdd', 'cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify(buildAddPayload(data, token))
        }, 'context');
      })
      .then(function (addResult) {
        if (addResult === null) return null;
        pendingAddAcknowledged = true;
        return getCart(false, addResult);
      })
      .then(function (cart) {
        if (!cart) return null;

        return confirmAddedLine(cart, token, data.quantity, protectedBeforeAdd);
      })
      .then(function (confirmation) {
        if (!confirmation) return null;

        if (!confirmation.line) {
          markPilotSignal();
          unverifiedMutation = true;
          syncCheckoutGuards();
          throw new Error('Shade carrier confirmation is still pending. Refresh the shopping bag before checkout.');
        }

        if (confirmation.issue) {
          var diagnostic = recordCarrierFailure(
            confirmation.issue,
            confirmation.line,
            confirmation.cart,
            'add'
          );

          if (externalMutationPending || addMutationGeneration !== cartMutationGeneration) {
            throw new Error('The shopping bag changed while the shade carrier was being checked. Please wait and try again.');
          }

          pendingAddRollback = true;
          return rollbackAddedToken(confirmation.cart, token, function () {
            return !externalMutationPending && addMutationGeneration === cartMutationGeneration;
          })
            .then(function (cart) { return confirmProtectedRestoration(cart, protectedBeforeAdd); })
            .then(function (cart) {
              return reconcileCart(cart, function () {
                return !externalMutationPending && addMutationGeneration === cartMutationGeneration;
              });
            })
            .then(function (result) {
              if (result.deferred) {
                throw new Error('The shade carrier cleanup is still pending. Refresh the shopping bag before checkout.');
              }
              if (addMutationGeneration === cartMutationGeneration) unverifiedMutation = false;
              clearPendingAdd();
              refreshCart(result.cart);
              throw new Error(issueMessage(confirmation.issue, diagnostic.reasonCode));
            });
        }

        return reconcileCart(confirmation.cart, function () {
          return !externalMutationPending && addMutationGeneration === cartMutationGeneration;
        }).then(function (result) {
          if (result.deferred) {
            throw new Error('The shade carrier check was interrupted by another bag update. Refresh before checkout.');
          }
          var retainedLine = findPilotLineByToken(result.cart, token);
          if (!retainedLine) {
            throw new Error('The additional shade carriers could not be retained safely. Please check your bag.');
          }

          var parent = resolveParent(result.cart, retainedLine);
          return saveCarrierPreference(result.cart, parent, data.choice, false, function () { return !externalMutationPending && addMutationGeneration === cartMutationGeneration; }).then(function (savedCart) {
          result.cart = savedCart;
          if (protectedCartIssue(savedCart, protectedBeforeAdd) || findInvalidPilotLine(savedCart)) throw new Error('Your shade carrier pricing is still being checked.');
          if (addMutationGeneration === cartMutationGeneration) unverifiedMutation = false;
          clearPendingAdd();
          clearCarrierFailure();
          offerPreferences.expanded = false;
          saveOfferPreferences();
          return requireCartRefresh(result.cart).then(function () {
            if (addMutationGeneration === cartMutationGeneration && !externalMutationPending) {
              setStatus(offer, data.quantity === 1 ? 'Complimentary shade carrier added.' : 'Complimentary shade carriers added.', false);
            }
            if (unverifiedMutation) scheduleReconcile(true);
            return result;
          });
          });
        });
      })
      .catch(function (error) {
        var message = error && error.message ? error.message : 'The complimentary shade carrier could not be added.';
        if (unverifiedMutation) scheduleReconcile(true);
        setStatus(offer, message, true);
        // The compact add-on owns its feedback. Use the global notice only if
        // no offer remains to display the message. NC codes stay in diagnostics.
        if (!document.querySelector(OFFER_SELECTOR)) publishNotice(message);
      })
      .finally(function () {
        addInFlight = false;
        addOperation = null;
        resumeDeferredReconcile();
        syncCheckoutGuards();
        setBusy(control, false);
        revealOffers();
        restoreInlineFocus();
      });
  }

  function reduceCarrierSelection(offer, desiredQuantity, control, choice) {
    if (choice == null) choice = desiredQuantity;
    if (!offer || !isPilotEnvironment() || !Number.isSafeInteger(desiredQuantity) || desiredQuantity < 0) return;
    if (inlineRemoveBusy()) return;
    var descriptor;
    try { descriptor = JSON.parse(offer.dataset.parentGroup || ''); } catch (error) { return; }
    var groups = cartGroups();
    if (!groups) return;
    var renderedQuantity = Number(offer.dataset.carrierSelected || 0);
    var generation = ++cartMutationGeneration;
    var externalGeneration = externalMutationGeneration;
    var protection = null;
    var steps = 0;
    var started = false;
    var limit = MAX_RECONCILE_REMOVALS;
    function canMutate() {
      return generation === cartMutationGeneration && externalGeneration === externalMutationGeneration && !externalMutationPending;
    }
    function locateParent(cart) {
      return cart.items.find(function (item) { return !isCarrierVariant(item) && !nativeParentKey(item) && groups.sameSelection(item, descriptor); });
    }
    function next(cart) {
      if (!canMutate()) throw new Error('Your bag changed while the shade carrier quantity was updating. Please check your selection.');
      var parent = locateParent(cart);
      if (!parent) throw new Error('This lampshade is no longer in your bag. Please refresh your selection.');
      var children = linkedCarriers(cart, parent);
      var quantity = carrierQuantityForParent(cart, parent);
      if (!started) {
        // Removing all is also an explicit request. Do not erase a newer choice
        // made from another tab after this control was rendered.
        if (quantity !== renderedQuantity || desiredQuantity > quantity) {
          refreshCart(cart);
          throw new Error('Your shade carrier selection has changed. Please check the quantity and try again.');
        }
        protection = commerceSnapshot(cart);
        children.forEach(function (child) { delete protection.carriers[normaliseProperties(child.properties)._mekhann_pilot_token]; });
        pendingReductionProtection = protection;
        limit = Math.max(limit, cart.items.length + 1);
        started = true;
        var reduction = carrierReductionPlan(cart, parent, desiredQuantity, choice);
        if (reduction) return reduceCarriersTogether(cart, parent, choice, reduction, protection, canMutate).then(next);
        return saveCarrierPreference(cart, parent, choice, false, canMutate).then(next);
      }
      if (quantity <= desiredQuantity) {
        if (quantity !== desiredQuantity) throw new Error('The shade carrier quantity could not be confirmed. Please refresh your bag.');
        return confirmProtectedRestoration(cart, protection).then(function (confirmed) {
          var currentParent = locateParent(confirmed);
          if (!currentParent || carrierQuantityForParent(confirmed, currentParent) !== desiredQuantity) {
            throw new Error('Your shade carrier quantity changed during confirmation. Please refresh your bag.');
          }
          return reconcileCart(confirmed, canMutate);
        });
      }
      if (++steps > limit || !children.length) throw new Error('The shade carrier quantity could not be updated safely. Please refresh your bag.');
      // Retain older choices first, matching the existing entitlement reconciler.
      var child = children[0];
      return postChange(child.key, Math.max(0, Number(child.quantity) - (quantity - desiredQuantity))).then(next);
    }
    rememberInlineFocus(offer);
    unverifiedMutation = true;
    setBusy(control, true);
    setStatus(offer, 'Updating…', false);
    removeOperation = getCart().then(next).then(function (result) {
      if (result.deferred || !canMutate()) throw new Error('Shade carrier confirmation is still pending. Refresh your bag before checkout.');
      var parent = locateParent(result.cart);
      if (!parent || carrierQuantityForParent(result.cart, parent) !== desiredQuantity || protectedCartIssue(result.cart, protection)) {
        throw new Error('The shade carrier selection could not be confirmed. Please refresh your bag.');
      }
      offerPreferences.expanded = false;
      offerPreferences.selection = '';
      saveOfferPreferences();
      return requireCartRefresh(result.cart).then(function () {
        if (!canMutate()) throw new Error('Your bag changed while the shade carrier reduction was being displayed. Please refresh your bag.');
        unverifiedMutation = false;
        pendingReductionProtection = null;
        setStatus(offer, desiredQuantity ? 'Shade carrier quantity updated.' : 'Shade carrier removed.', false);
      });
    }).catch(function (error) {
      // Keep the reduction protected until its exact result has been rendered.
      // A failed/stale render is not a completed customer operation.
      unverifiedMutation = true;
      setStatus(offer, error && error.message ? error.message : 'The shade carrier quantity could not be updated.', true);
      if (unverifiedMutation) scheduleReconcile(true);
    }).finally(function () {
      removeOperation = null;
      resumeDeferredReconcile();
      setBusy(control, false);
      syncCheckoutGuards();
      revealOffers();
      restoreInlineFocus();
    });
    syncCheckoutGuards();
    revealOffers();
  }

  function removeCarrier(lineKey, control) {
    if (!lineKey || !isPilotEnvironment()) return;
    if (addInFlight || unverifiedMutation || removeOperation ||
        externalMutationPending || externalVerificationInFlight || extrasPending || reconcileInFlight || groupBusy()) {
      publishNotice('Please wait while the complimentary shade carrier is being checked.');
      scheduleReconcile(true);
      return;
    }

    cartMutationGeneration += 1;
    var removeMutationGeneration = cartMutationGeneration;
    unverifiedMutation = true;
    syncCheckoutGuards();
    setBusy(control, true);

    var canRemove = function () { return !externalMutationPending && removeMutationGeneration === cartMutationGeneration; };
    removeOperation = getCart().then(function (cart) {
      var child = cart.items.find(function (item) { return item.key === lineKey; });
      var parent = child && resolveParent(cart, child);
      if (parent && isCurrentPilotLine(child)) {
        return saveCarrierPreference(cart, parent, 0, false, canRemove).then(function (saved) {
          return trimCarrierPreference(saved, parent, 0, canRemove);
        });
      }
      if (!canRemove()) throw new Error('Your bag is still updating.');
      return child ? postChange(child.key, 0) : cart;
    }).then(function (cart) {
        if (removeMutationGeneration === cartMutationGeneration) unverifiedMutation = false;
        pendingReductionProtection = null;
        offerPreferences.expanded = false;
        saveOfferPreferences();
        clearPendingAdd();
        return requireCartRefresh(cart);
      })
      .catch(function (error) {
        scheduleReconcile(true);
        publishNotice(error && error.message ? error.message : 'The shade carrier could not be removed.');
      })
      .finally(function () {
        removeOperation = null;
        resumeDeferredReconcile();
        syncCheckoutGuards();
        setBusy(control, false);
      });
  }

  function onDocumentClick(event) {
    var followRetry = event.target.closest('[data-mekhann-carrier-retry]');
    if (followRetry) {
      event.preventDefault();
      retryFollowCarrier(followRetry);
      return;
    }
    var dismiss = event.target.closest('[data-mekhann-carrier-dismiss]');
    var restore = event.target.closest('[data-mekhann-carrier-restore]');
    if (dismiss || restore) {
      event.preventDefault();
      chooseOffer((dismiss || restore).closest(OFFER_SELECTOR), Boolean(restore));
      return;
    }

    var continueShopping = event.target.closest('[data-mekhann-continue-shopping]');
    if (continueShopping) {
      event.preventDefault();
      var close = document.querySelector('#CartDrawer .drawer__close-button');
      if (close) close.click();
      return;
    }

    var removeSelection = event.target.closest('[data-mekhann-carrier-remove-parent]');
    if (removeSelection) {
      event.preventDefault();
      reduceCarrierSelection(removeSelection.closest(OFFER_SELECTOR), 0, removeSelection);
      return;
    }

    var addControl = event.target.closest('[data-mekhann-carrier-add]');
    if (addControl) {
      event.preventDefault();
      addCarrier(addControl);
      return;
    }

    var removeControl = event.target.closest('.cart__remove a');
    if (!removeControl) return;

    var carrierItem = removeControl.closest(PILOT_LINE_SELECTOR);
    if (!carrierItem || !carrierItem.dataset.key) return;

    event.preventDefault();
    removeCarrier(carrierItem.dataset.key, removeControl);
  }

  function checkoutControl(form, submitter) {
    return submitter || form.querySelector('[name="checkout"]');
  }

  function retireDetachedCheckout() {
    var intent = checkoutIntent;
    if (!intent || document.contains(intent.form)) return;
    checkoutIntent = null;
    checkoutInFlight = false;
    checkoutBypass = false;
    intent.retryAllowed = false;
    // Revoke late finally callbacks before a replacement form accepts checkout.
    intent.attempt += 1;
    setBusy(checkoutControl(intent.form, intent.submitter), false);
    syncCheckoutGuards();
  }

  function continueCheckout(form, submitter, proof) {
    var token = {
      form: form, proof: proof, accepted: false, recheck: false,
      revision: cartExtras ? cartExtras.revision() : 0,
      mutation: cartMutationGeneration, signal: cartSignalGeneration, external: externalMutationGeneration
    };
    checkoutBypass = token;
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
      else if (submitter && typeof submitter.click === 'function') submitter.click();
      else throw new Error('Checkout could not be resumed safely. Please try again.');
    } finally {
      // Authorization exists only during this synchronous native submission.
      // It cannot be reused by another form or a later checkout event.
      checkoutBypass = false;
    }
    return token;
  }

  function assertCheckoutSafe(result) {
    if (!result || result.deferred || !result.cart || findInvalidPilotLine(result.cart)) {
      throw new Error('The complimentary shade carrier could not be validated safely.');
    }
    if (nativeBatchRecord || nativeBatchFault || unverifiedMutation || pendingAddToken || externalMutationPending || externalVerificationInFlight ||
        addInFlight || addOperation || removeOperation || reconcileInFlight || pendingRemoveIntent || groupBusy()) {
      throw new Error('Shade carrier confirmation is still pending. Please try again.');
    }
  }

  function checkoutWithin(promise, deadline) {
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(function () {
        reject(new Error('Your bag is taking longer to update. Your text is kept. Please try again.'));
      }, Math.max(0, deadline - Date.now()));
      Promise.resolve(promise).then(function (value) {
        window.clearTimeout(timer); resolve(value);
      }, function (error) {
        window.clearTimeout(timer); reject(error);
      });
    });
  }

  function resumeCheckoutIntent(intent) {
    if (checkoutInFlight || pendingRemoveIntent) return;
    // The newly accepted checkout owns the destination, including a retry.
    // Revoke an older bag-link intent without cancelling its metadata save.
    if (cartExtras) cartExtras.cancelBagNavigation();
    checkoutInFlight = true;
    syncCheckoutGuards();
    intent.attempt = (intent.attempt || 0) + 1;
    var attempt = intent.attempt;
    var deadline = Date.now() + 45000;
    var control = checkoutControl(intent.form, intent.submitter);
    setBusy(control, true);

    function active() {
      if (!document.contains(intent.form)) {
        var detached = new Error('The shopping bag changed while checkout was being prepared.');
        detached.mekhannCheckoutOwnerLost = true;
        throw detached;
      }
      if (checkoutIntent !== intent || intent.attempt !== attempt || !checkoutInFlight || Date.now() >= deadline) {
        throw new Error('Your bag is taking longer to update. Your text is kept. Please try again.');
      }
    }

    function verify() {
      active();
      setBusy(control, true);
      if (cartExtras) cartExtras.capture(intent.form);
      var metadata = cartExtras ? cartExtras.flush(deadline, true) : Promise.resolve();
      var proofGeneration;
      return metadata.then(function () {
        active();
        // Metadata waits for an existing carrier mutation before writing. Once
        // metadata is settled this read proves both current prices and metadata.
        var pendingMutation = addOperation || removeOperation;
        return (pendingMutation ? pendingMutation.catch(function () {}) : Promise.resolve()).then(function () {
          active();
          proofGeneration = { mutation: cartMutationGeneration, signal: cartSignalGeneration, external: externalMutationGeneration };
          return runReconcile(null, true);
        });
      }).then(function (result) {
        active();
        if (proofGeneration.mutation !== cartMutationGeneration || proofGeneration.signal !== cartSignalGeneration ||
            proofGeneration.external !== externalMutationGeneration) return verify();
        if (cartExtras) cartExtras.capture(intent.form);
        if (cartExtras && (!cartExtras.verified() || !cartExtras.matches(result && result.cart))) return verify();
        assertCheckoutSafe(result);
        if (result.removed && result.removed.length) {
          refreshCart(result.cart);
          publishNotice(cleanupNotice(result.removed));
        }
        // Re-rendering, listeners, or an edit during carrier validation must not
        // escape the final synchronous, form-specific resubmission guard.
        if (cartExtras) cartExtras.capture(intent.form);
        if (cartExtras && (!cartExtras.verified() || !cartExtras.matches(result.cart))) return verify();
        setBusy(control, false);
        var continued = continueCheckout(intent.form, control, result);
        if (!continued.accepted) {
          // Native constraint validation can decline to dispatch submit. Retain
          // native validation rather than bypassing it with form.submit().
          if (continued.recheck || cartExtras && !cartExtras.verified()) return verify();
          checkoutIntent = null;
          checkoutInFlight = false;
          return;
        }
        checkoutIntent = null;
        checkoutInFlight = false;
      });
    }

    checkoutWithin(Promise.resolve().then(verify), deadline).catch(function (error) {
      if (checkoutIntent !== intent || intent.attempt !== attempt) return;
      checkoutInFlight = false;
      // A failed checkout may resume only in its original editing session.
      // Closing the drawer does not cancel an accepted in-flight checkout,
      // but must not give a later unrelated field retry its old destination.
      if (error && error.mekhannCheckoutOwnerLost || !document.contains(intent.form)) {
        checkoutIntent = null;
        return;
      }
      if (intent.retryAllowed === false) checkoutIntent = null;
      if (cartExtras) cartExtras.fail(extrasError || 'Your bag could not be confirmed. Your text is kept. Try saving again.');
      publishNotice(error && error.message ? error.message : 'We could not confirm your bag. Please try again.');
    }).finally(function () {
      if (intent.attempt === attempt) { setBusy(control, false); syncCheckoutGuards(); }
    });
  }

  function onCheckout(event) {
    var form = event.target && event.target.closest ? event.target.closest(FORM_SELECTOR) : null;
    if (!form || !isPilotEnvironment()) return;
    if (cartExtras) cartExtras.capture(form);

    if (checkoutBypass) {
      var token = checkoutBypass;
      checkoutBypass = false;
      var safe = token.form === form && token.mutation === cartMutationGeneration &&
        token.signal === cartSignalGeneration && token.external === externalMutationGeneration &&
        (!cartExtras || token.revision === cartExtras.revision() && cartExtras.verified() && cartExtras.matches(token.proof.cart));
      try { assertCheckoutSafe(token.proof); } catch (error) { safe = false; }
      if (safe) { token.accepted = true; return; }
      token.recheck = true;
      event.preventDefault(); event.stopImmediatePropagation();
      return;
    }

    // Note/gift drafts need this gate even when the bag has no shade carrier.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.querySelector('[data-mekhann-add-checkout-lock]')) return;
    if (checkoutInFlight || pendingRemoveIntent) return;
    if (form.getAttribute('data-mekhann-cart-unverified') === 'true') {
      publishNotice('We could not confirm your bag. Please refresh before checking out.');
      return;
    }
    checkoutIntent = { form: form, submitter: event.submitter || null, attempt: 0, retryAllowed: true };
    resumeCheckoutIntent(checkoutIntent);
  }
  function externalWriterSource(event) {
    var source = event && event.detail && event.detail.source;
    return typeof source === 'string' ? source : '';
  }

  function onExternalQuantityChange(event) {
    if (!isPilotEnvironment()) return;
    // Even a selection with zero child lines may retain explicit follow/off intent.

    externalMutationGeneration += 1;
    externalActiveWrites += 1;
    var source = externalWriterSource(event);
    externalWriterCounts[source] = (externalWriterCounts[source] || 0) + 1;
    externalMutationPending = true;
    if (ownedMutation) ownedMutation.invalid = true;
    // Every parent operation is a new generation, but an ordinary lampshade
    // update is not evidence that a carrier POST exists. Real DOM/server/pending
    // carrier signals continue to require the second absence proof.
    if (pilotLinePresent || pendingAddToken || document.querySelector(PILOT_LINE_SELECTOR)) markPilotSignal();
    syncCheckoutGuards();
  }

  function verifyCompletedExternalMutation(generation) {
    if (externalActiveWrites || externalMutationUncertain || ownedMutation) return Promise.resolve(null);
    if (externalVerificationOwner) return externalVerificationOwner.promise;
    var owner = { generation: generation, promise: null };
    externalVerificationOwner = owner;
    externalVerificationDemand = false;
    externalMutationPending = false;
    externalVerificationInFlight = true;
    syncCheckoutGuards();

    var operation = runReconcile(null, true)
      .then(function (result) {
        if (generation !== externalMutationGeneration || externalActiveWrites || externalMutationUncertain) return result;

        if (result.deferred || findInvalidPilotLine(result.cart) || unverifiedMutation || pendingAddToken) {
          throw new Error('The shopping bag update could not be verified safely. Refresh before checkout.');
        }

        externalMutationPending = false;
        if (result.removed.length) publishNotice(cleanupNotice(result.removed));
        return result;
      }).catch(function (error) {
        if (generation === externalMutationGeneration) {
          externalMutationPending = true;
          var message = error && error.message
            ? error.message
            : 'The shopping bag update could not be verified. Refresh before checkout.';
          publishNotice(message);
        }
        throw error;
      }).finally(function () {
        if (externalVerificationOwner !== owner) return;
        externalVerificationOwner = null;
        externalVerificationInFlight = false;
        syncCheckoutGuards();
        // Drain only a real newer completion, once. A current read failure
        // remains visible and guarded; it never creates a polling loop.
        if (externalVerificationDemand && !externalActiveWrites && !externalMutationUncertain && !ownedMutation) {
          verifyCompletedExternalMutation(externalMutationGeneration).catch(function () {});
        }
      });
    owner.promise = operation;
    return operation;
  }

  function onExternalMutationComplete(event) {
    var source = externalWriterSource(event);
    // Existing producers have no operation ID. Pair their balanced events
    // by source; a duplicate/unmatched source cannot finish another writer.
    if (!isPilotEnvironment() || !externalWriterCounts[source]) return;
    externalWriterCounts[source] -= 1;
    if (!externalWriterCounts[source]) delete externalWriterCounts[source];
    externalActiveWrites -= 1;
    var detail = event && event.detail || {};
    if (detail.unknown === true) externalMutationUncertain = true;
    externalMutationPending = true;
    if (ownedMutation) {
      ownedMutation.invalid = true;
      ownedMutation.externalCompleted = !externalActiveWrites && !externalMutationUncertain;
    }
    if (externalMutationUncertain) {
      externalVerificationDemand = false;
      publishNotice('Your shopping bag update could not be confirmed. Refresh your bag before continuing.');
    } else if (!externalActiveWrites) {
      externalVerificationDemand = true;
      verifyCompletedExternalMutation(externalMutationGeneration).catch(function () {});
    }
    syncCheckoutGuards();
  }

  function onCartUpdated(event) {
    var cart = event.detail && event.detail.cart;
    if (cart && Array.isArray(cart.items)) observeCarrierPreferences(cart);
    revealOffers();
    if (cart && Array.isArray(cart.items) && !cart.items.length) {
      offerPreferences = { expanded: false, selection: '' };
      saveOfferPreferences();
    }
    var source = event.detail && event.detail.source;
    if (source === BUILD) { syncCheckoutGuards(); return; }
    if (ownedMutation) {
      ownedMutation.invalid = true;
      ownedMutation.externalCompleted = !externalActiveWrites && !externalMutationUncertain;
      if (!externalMutationPending) externalMutationGeneration += 1;
      externalMutationPending = true;
      syncCheckoutGuards();
      return;
    }
    var eventHasPilot = Boolean(cart && Array.isArray(cart.items) && cart.items.some(isKnownPilotLine));
    var domHasPilot = Boolean(document.querySelector(PILOT_LINE_SELECTOR));
    if (eventHasPilot || domHasPilot) markPilotSignal();
    syncCheckoutGuards();

    if (externalMutationPending) {
      // A cart snapshot is not the completion of a still-running writer.
      // Paired producers may emit updated before their complete event.
      if (!externalActiveWrites && !externalMutationUncertain) verifyCompletedExternalMutation(externalMutationGeneration).catch(function () {
        // The verification routine publishes the fail-closed recovery message.
      });
      return;
    }

    if (externalVerificationInFlight) return;
    if (pilotLinePresent || addInFlight || unverifiedMutation || pendingAddToken || Object.keys(observedCarrierPreferences).length) {
      runReconcile(null, false).catch(function (error) {
        publishNotice(error && error.message ? error.message : 'The complimentary shade carrier could not be checked.');
      });
    }
  }

  function initCalmDrawer(drawer) {
    if (!drawer || drawer.__mekhannCalmDrawer) return;
    var disposers = [];
    var disposed = false;
    function listen(target, name, listener, options) {
      target.addEventListener(name, listener, options);
      disposers.push(function () { target.removeEventListener(name, listener, options); });
    }
    var chatStates = new Map();
    var lastOpen = drawer.classList.contains('drawer--is-open');
    var visibilityTimer = null;
    var visibilityRequest = null;
    var activePointerId = null;
    var compactDock = null;
    var dock = drawer.querySelector('[data-mekhann-compact-dock]');
    var dockCheckout = dock && dock.querySelector('[data-mekhann-compact-checkout]');
    var subtotal = drawer.querySelector('[data-mekhann-compact-subtotal]');
    var checkout = drawer.querySelector('[name="checkout"]');
    var delivery = drawer.querySelector('.mekhann-cart-delivery');
    var viewBag = drawer.querySelector('.drawer__footer .cart__checkout-wrapper > [data-mekhann-view-bag]');
    var bagStatus = drawer.querySelector('.drawer__footer .cart__checkout-wrapper > [data-mekhann-bag-navigation-status]');
    var inner = drawer.querySelector('.drawer__inner');
    var footer = subtotal && subtotal.closest('.drawer__footer');
    // Mixed old/new assets retain the original footer. The empty dock remains
    // hidden until matching CSS and all nodes in the same form are available.
    if (dock && dockCheckout && subtotal && checkout && delivery && viewBag && bagStatus && inner && footer &&
        inner.contains(subtotal) && inner.contains(checkout) && inner.contains(delivery) &&
        inner.contains(viewBag) && inner.contains(bagStatus) &&
        dock.parentNode === inner.parentNode && checkout.form === dock.closest('form') &&
        viewBag.closest('form') === checkout.form && bagStatus.closest('form') === checkout.form &&
        typeof window.getComputedStyle === 'function' &&
        window.getComputedStyle(drawer).getPropertyValue('--mekhann-compact-dock-supported').trim() === '2') {
      var returns = [subtotal, delivery, checkout, viewBag, bagStatus].map(function (node) {
        var anchor = document.createComment('compact footer return');
        node.parentNode.insertBefore(anchor, node.nextSibling);
        return { node: node, anchor: anchor };
      });
      compactDock = { active: false, dock: dock, checkoutSlot: dockCheckout,
        subtotal: subtotal, delivery: delivery, checkout: checkout, viewBag: viewBag, bagStatus: bagStatus,
        footer: footer, returns: returns };
    }

    function syncCompactDock(active) {
      var state = compactDock;
      if (!state || state.active === active) return;
      var focused = document.activeElement;
      state.active = active;
      if (active) {
        state.dock.insertBefore(state.subtotal, state.checkoutSlot);
        state.dock.insertBefore(state.delivery, state.checkoutSlot);
        state.checkoutSlot.appendChild(state.checkout);
        state.checkoutSlot.appendChild(state.viewBag);
        state.checkoutSlot.appendChild(state.bagStatus);
        state.footer.classList.add('mekhann-cart-footer-details');
        state.dock.hidden = false;
      } else {
        state.returns.forEach(function (entry) { entry.anchor.parentNode.insertBefore(entry.node, entry.anchor); });
        state.footer.classList.remove('mekhann-cart-footer-details');
        state.dock.hidden = true;
      }
      // Move the original controls and their live status together. Preserve
      // focus, form/listener identity, disabled state and native guard ownership.
      if (focused && document.activeElement !== focused && state.returns.some(function (entry) {
        return entry.node === focused || entry.node.contains(focused);
      })) focused.focus({ preventScroll: true });
    }

    function cancelVisibility() {
      window.clearTimeout(visibilityTimer);
      visibilityTimer = null;
      visibilityRequest = null;
    }

    function editable(control) {
      return Boolean(control && control.matches && drawer.contains(control) &&
        control.matches('textarea, input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"])'));
    }

    function drawerScroller() {
      var shortScreen = typeof window.matchMedia === 'function' ? window.matchMedia('(max-height: 600px)').matches : window.innerHeight <= 600;
      var narrowDrawer = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 999px)').matches : window.innerWidth <= 999;
      return drawer.querySelector(drawer.classList.contains('mekhann-cart-editing') || shortScreen || narrowDrawer ? '.drawer__inner' : '.drawer__scrollable');
    }

    function ensureVisible() {
      var request = visibilityRequest;
      visibilityTimer = null;
      visibilityRequest = null;
      if (disposed || !drawer.isConnected) return;
      if (activePointerId !== null || !request || !drawer.classList.contains('drawer--is-open')) return;
      var control = request.control;
      if (request.details) {
        if (!request.details.open || !request.details.contains(control) || request.focusOwner !== document.activeElement) return;
      } else if (control !== document.activeElement) return;
      if (!control || !drawer.contains(control) || control.hidden || typeof control.getBoundingClientRect !== 'function') return;
      var scroller = drawerScroller();
      if (!scroller || !scroller.contains(control)) return;
      var viewport = window.visualViewport;
      var viewportTop = viewport ? viewport.offsetTop : 0;
      var viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
      var bounds = scroller.getBoundingClientRect();
      var target = control.getBoundingClientRect();
      var top = Math.max(bounds.top, viewportTop) + 12;
      var bottom = Math.min(bounds.bottom, viewportBottom) - 12;
      var available = bottom - top;
      if (available < 44 || !target.height) return;
      // Scroll the drawer only. scrollIntoView would also move the locked PDP.
      var delta = target.height > available ? target.top - top :
        target.bottom > bottom ? target.bottom - bottom : target.top < top ? target.top - top : 0;
      if (Math.abs(delta) > 1) scroller.scrollTop = Math.max(0, scroller.scrollTop + delta);
    }

    function queueVisibility(control, details) {
      cancelVisibility();
      if (disposed || activePointerId !== null || !control) return;
      visibilityRequest = { control: control, details: details || null, focusOwner: document.activeElement };
      visibilityTimer = window.setTimeout(ensureVisible, 30);
    }

    function syncViewport() {
      if (disposed || !drawer.isConnected) return;
      var viewport = window.visualViewport;
      if (viewport) {
        drawer.style.setProperty('--mekhann-cart-viewport-height', viewport.height + 'px');
        drawer.style.setProperty('--mekhann-cart-viewport-top', viewport.offsetTop + 'px');
      }
      var focused = editable(document.activeElement);
      var narrow = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 768px)').matches : window.innerWidth <= 768;
      var shortened = Boolean(viewport && viewport.height < window.innerHeight - 100);
      // On narrow screens flow the footer out of the editing viewport before
      // the keyboard transition finishes, then restore it after editing ends.
      var editing = drawer.classList.contains('drawer--is-open') && focused && (narrow || shortened);
      if (drawer.classList.contains('mekhann-cart-editing') !== editing) drawer.classList.toggle('mekhann-cart-editing', editing);
      var compactWidth = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 999px)').matches : window.innerWidth <= 999;
      var addState = drawer.getAttribute('data-mekhann-add-state');
      syncCompactDock(drawer.classList.contains('drawer--is-open') && compactWidth &&
        window.innerHeight > 600 && (!viewport || viewport.height > 600) && !focused && !shortened && !editing &&
        !drawer.classList.contains('is-empty') && addState !== 'pending' && addState !== 'unverified');
      if (focused) queueVisibility(document.activeElement);
    }
    syncViewport();
    if (window.visualViewport) {
      listen(window.visualViewport, 'resize', syncViewport);
      listen(window.visualViewport, 'scroll', syncViewport);
    }
    listen(window, 'resize', syncViewport);
    // A new pointer activation owns its target. Do not let an older focus
    // request move the drawer between pointerdown and release.
    listen(document, 'pointerdown', function (event) {
      if (!drawer.classList.contains('drawer--is-open')) return;
      cancelVisibility();
      if (event.isPrimary !== false && drawer.contains(event.target)) activePointerId = event.pointerId;
    }, true);
    function releasePointer(event) {
      if (event.pointerId === activePointerId) activePointerId = null;
    }
    listen(document, 'pointerup', releasePointer, true);
    listen(document, 'pointercancel', releasePointer, true);
    listen(window, 'blur', function () { activePointerId = null; cancelVisibility(); });
    listen(drawer, 'click', function (event) {
      syncViewport();
      // The native form still owns terms validation. Bring an unchecked terms
      // control into the content scroller when its docked checkout is used.
      if (compactDock && compactDock.active && compactDock.checkout.contains(event.target)) {
        var terms = drawer.querySelector('.cart__terms-checkbox');
        if (terms && !terms.checked) terms.focus({ preventScroll: true });
      }
    });
    listen(drawer, 'focusin', function (event) { syncViewport(); queueVisibility(event.target); });
    listen(drawer, 'focusout', function () { cancelVisibility(); window.setTimeout(syncViewport, 0); });
    listen(drawer, 'toggle', function (event) {
      if (!event.target.open) {
        if (visibilityRequest && visibilityRequest.details === event.target) cancelVisibility();
        return;
      }
      var control = event.target.querySelector('textarea, select, input:not([type="hidden"]), button');
      queueVisibility(control || event.target, event.target);
    }, true);
    listen(document, 'cart:rendered', function () {
      syncViewport();
      if (drawer.contains(document.activeElement)) queueVisibility(document.activeElement);
    });
    function syncChat() {
      if (disposed || !drawer.isConnected) return;
      var open = drawer.classList.contains('drawer--is-open');
      if (lastOpen && !open && cartExtras) cartExtras.clearSuccess();
      lastOpen = open;
      if (open) syncViewport();
      else {
        cancelVisibility();
        activePointerId = null;
        if (drawer.classList.contains('mekhann-cart-editing')) drawer.classList.remove('mekhann-cart-editing');
        syncCompactDock(false);
      }
      document.documentElement.classList.toggle('mekhann-cart-open', open);
      document.querySelectorAll('shopify-chat').forEach(function (chat) {
        if (open) {
          if (!chatStates.has(chat)) chatStates.set(chat, chat.hasAttribute('inert'));
          chat.setAttribute('inert', '');
        } else if (chatStates.has(chat)) {
          if (!chatStates.get(chat)) chat.removeAttribute('inert');
          chatStates.delete(chat);
        }
      });
    }
    syncChat();
    if (window.MutationObserver) {
      var drawerObserver = new MutationObserver(syncChat);
      var chatObserver = new MutationObserver(syncChat);
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'data-mekhann-add-state'] });
      chatObserver.observe(document.body, { childList: true });
      disposers.push(function () { drawerObserver.disconnect(); chatObserver.disconnect(); });
    }
    listen(document, 'drawerOpen.CartDrawer', syncChat);

    // Advice may open a modal outside Impulse's drawer. Keep its return context.
    listen(document, 'click', function (event) {
      var trigger = event.target.closest('#CartDrawer [data-mekhann-advisor-open]');
      if (!trigger) return;
      var scrollable = drawerScroller();
      advisorReturn = { trigger: trigger, scroll: scrollable ? scrollable.scrollTop : 0, scrollArea: scrollable && scrollable.classList.contains('drawer__inner') ? '.drawer__inner' : '.drawer__scrollable' };
    }, true);
    var dialog = document.querySelector('[data-mekhann-advisor-dialog]');
    if (dialog) listen(dialog, 'close', function () {
      if (!advisorReturn) return;
      var context = advisorReturn;
      advisorReturn = null;
      window.setTimeout(function () {
        if (disposed || !drawer.isConnected) return;
        if (!drawer.classList.contains('drawer--is-open')) {
          var opener = document.querySelector('.js-drawer-open-cart');
          if (opener) opener.click();
        }
        var scrollable = drawer.querySelector(context.scrollArea || '.drawer__scrollable');
        if (scrollable) scrollable.scrollTop = context.scroll;
        if (document.contains(context.trigger)) context.trigger.focus({ preventScroll: true });
      }, 0);
    });
    drawer.__mekhannCalmDrawer = function () {
      disposed = true;
      cancelVisibility();
      activePointerId = null;
      disposers.forEach(function (dispose) { dispose(); });
      syncCompactDock(false);
      if (compactDock) {
        compactDock.returns.forEach(function (entry) { entry.anchor.remove(); });
      }
      chatStates.forEach(function (wasInert, chat) { if (!wasInert) chat.removeAttribute('inert'); });
      chatStates.clear();
      document.documentElement.classList.remove('mekhann-cart-open');
      drawer.__mekhannCalmDrawer = null;
    };
  }

  function initCartExtras() {
    if (cartExtras) { cartExtras.render(); return; }
    var first = document.querySelector('[data-mekhann-cart-extras]');
    if (!first) return;
    var firstNote = first.querySelector('[name="note"]');
    var firstGift = first.querySelector('[data-mekhann-gift-input]');
    var legacyOwner = first.closest('[data-mekhann-legacy-gift]') || first.querySelector('[data-mekhann-legacy-gift]');
    var legacy = Boolean(legacyOwner && legacyOwner.getAttribute('data-mekhann-legacy-gift') === 'Yes');
    var draft = {
      note: firstNote ? firstNote.value : '',
      wrapping: Boolean(firstGift && firstGift.checked),
      giftTouched: false, revision: 0, noteRevision: 0, giftRevision: 0
    };
    var verifiedNote = 0;
    var verifiedGift = 0;
    var verifiedRevision = -1;
    var timer = null;
    var operation = null;
    var ordinarySave = false;
    var metadataWriteTask = null;
    var queuedOperation = null;
    var composing = new Set();
    var failureMessage = 'We couldn’t save your order note or gift wrapping preference. Your note is kept. Please try again.';
    var feedbackEpoch = 0;
    var feedback = {
      note: { revision: -1, until: 0, error: '', timer: null },
      gift: { revision: -1, until: 0, error: '', timer: null }
    };
    var fieldFocus = null;
    var lifecycleEpoch = 0;
    var pageSuspended = false;
    var historyRequired = false;
    var historyOperation = null;
    var historyTimer = null;
    var requests = new Set();
    var bagNavigation = null;
    var bagNavigationFailures = new Map();

    function lifecycleError() {
      var error = new Error('The page changed while your bag was updating.');
      error.mekhannNavigation = true;
      return error;
    }

    function assertLifecycle(epoch) {
      if (pageSuspended || epoch !== lifecycleEpoch) throw lifecycleError();
    }

    function clearSuccess(scope) {
      var keys = scope ? [scope] : ['note', 'gift'];
      keys.forEach(function (key) {
        window.clearTimeout(feedback[key].timer);
        feedback[key].timer = null;
        feedback[key].revision = -1;
        feedback[key].until = 0;
      });
    }

    function confirmField(scope, revision, epoch) {
      if (revision < 1 || epoch !== feedbackEpoch) return;
      clearSuccess(scope);
      var state = feedback[scope];
      state.error = '';
      state.revision = revision;
      state.until = Date.now() + 2500;
      state.timer = window.setTimeout(function () {
        state.until = 0;
        state.timer = null;
        render();
      }, 2500);
    }

    function rememberFieldFocus(input) {
      if (!isField(input)) return;
      var form = input.closest(FORM_SELECTOR);
      var details = input.closest('[data-mekhann-order-note]');
      fieldFocus = {
        node: input, form: form && form.id, name: input.name,
        start: input.selectionStart, end: input.selectionEnd, direction: input.selectionDirection,
        scroll: input.scrollTop, noteOpen: Boolean(details && details.open)
      };
    }

    function restoreFieldFocus() {
      if (!fieldFocus || document.contains(fieldFocus.node)) return;
      var active = document.activeElement;
      // A deliberate move to another control wins over a detached-field record.
      if (active && active !== document.body && active !== fieldFocus.node && document.contains(active)) return;
      var form = document.getElementById(fieldFocus.form);
      if (!form) return;
      var drawer = form.closest('#CartDrawer');
      if (drawer && !drawer.classList.contains('drawer--is-open')) return;
      var replacement = Array.prototype.find.call(form.querySelectorAll('[name="note"], [data-mekhann-gift-input]'), function (input) {
        return input.name === fieldFocus.name;
      });
      if (!replacement || replacement.disabled || typeof replacement.focus !== 'function') return;
      var context = fieldFocus;
      // Detached DOM controls still retain their latest caret and scroll state,
      // including selection-only movement that emitted no input event.
      if (typeof context.node.selectionStart === 'number') {
        context.start = context.node.selectionStart;
        context.end = context.node.selectionEnd;
        context.direction = context.node.selectionDirection;
      }
      context.scroll = context.node.scrollTop;
      var oldDetails = context.node.closest('[data-mekhann-order-note]');
      var details = replacement.closest('[data-mekhann-order-note]');
      if (details && (context.noteOpen || oldDetails && oldDetails.open)) details.open = true;
      replacement.focus({ preventScroll: true });
      if (typeof replacement.setSelectionRange === 'function' && typeof context.start === 'number') {
        replacement.setSelectionRange(context.start, context.end, context.direction || 'none');
      }
      replacement.scrollTop = context.scroll || 0;
      rememberFieldFocus(replacement);
    }

    function snapshot() {
      return {
        note: draft.note, managedNote: Boolean(firstNote), wrapping: draft.wrapping,
        giftTouched: draft.giftTouched, managedGift: draft.giftTouched || draft.wrapping || !legacy,
        revision: draft.revision, noteRevision: draft.noteRevision, giftRevision: draft.giftRevision, feedbackEpoch: feedbackEpoch
      };
    }

    function isField(input) {
      return Boolean(input && input.matches && input.closest('[data-mekhann-cart-extras]') &&
        input.matches('[name="note"], [data-mekhann-gift-input]'));
    }

    function captureField(input, explicit, quiet, suppliedValue) {
      if (!isField(input)) return;
      var field = input.matches('[name="note"]') ? 'note' : 'wrapping';
      var value = suppliedValue !== undefined ? suppliedValue : field === 'wrapping' ? Boolean(input.checked) : String(input.value || '');
      var touched = field !== 'note' && explicit && !draft.giftTouched;
      if (draft[field] === value && !touched) return;
      draft[field] = value;
      if (field !== 'note') draft.giftTouched = true;
      draft.revision += 1;
      if (field === 'note') draft.noteRevision = draft.revision;
      else draft.giftRevision = draft.revision;
      clearSuccess(field === 'note' ? 'note' : 'gift');
      feedback[field === 'note' ? 'note' : 'gift'].error = '';
      extrasError = '';
      if (document.activeElement === input) rememberFieldFocus(input);
      if (!quiet) render();
    }

    function capture(form) {
      // History restoration can repopulate controls from an old document after
      // pageshow. Only real input/change events may create edits until the
      // authoritative refresh has completed; restored DOM values are not edits.
      if (historyRequired || pageSuspended) return draft.revision;
      // input is the primary draft source. Reading the active DOM control also
      // captures autofill or a final edit immediately before form submission.
      var active = isField(document.activeElement) ? document.activeElement : null;
      var values = [];
      if (form) form.querySelectorAll('[name="note"], [data-mekhann-gift-input]').forEach(function (input) {
        var region = input.closest('[data-mekhann-cart-extras]');
        // Fresh section markup may briefly contain server values older than the
        // shared draft. Restore it before treating it as another editing source.
        if (!region || !Object.prototype.hasOwnProperty.call(region, '__mekhannExtrasRevision')) return;
        // An active control on the other surface has the latest value for its
        // field. Capture all remaining DOM values before mirroring any of them.
        if (active && input !== active && input.name === active.name) return;
        values.push({ input: input, value: input.matches('[data-mekhann-gift-input]') ? Boolean(input.checked) : String(input.value || '') });
      });
      if (active) values.push({ input: active, value: active.matches('[data-mekhann-gift-input]') ? Boolean(active.checked) : String(active.value || '') });
      values.forEach(function (entry) { captureField(entry.input, false, true, entry.value); });
      render();
      return draft.revision;
    }

    function render() {
      document.querySelectorAll('[data-mekhann-cart-extras]').forEach(function (region) {
        region.__mekhannExtrasRevision = draft.revision;
        region.querySelectorAll('[name="note"]').forEach(function (input) {
          if (!composing.has(input) && input.value !== draft.note) input.value = draft.note;
        });
        region.querySelectorAll('[data-mekhann-note-summary]').forEach(function (summary) {
          summary.textContent = 'Order Note';
        });
        region.querySelectorAll('[data-mekhann-gift-input]').forEach(function (input) { input.checked = draft.wrapping; });
        // V2.29 no longer edits recipient messages. A stale mounted input must
        // not overwrite the server attribute during native checkout either.
        region.querySelectorAll('[data-mekhann-gift-message], [name="attributes[Gift message]"]').forEach(function (input) { input.disabled = true; });
        region.querySelectorAll('[data-mekhann-gift-message-field]').forEach(function (field) { field.hidden = true; });
        region.querySelectorAll('[name="attributes[Gift order]"]').forEach(function (input) { input.disabled = true; });
        // Gift and note feedback have independent owners. Never reuse the gift
        // status for a note-only operation or keep a generic Saved indefinitely.
        var generic = region.querySelector('[data-mekhann-extras-status]');
        if (generic) { generic.textContent = ''; generic.hidden = true; }
        ['note', 'gift'].forEach(function (scope) {
          var field = region.querySelector(scope === 'note' ? '[name="note"]' : '[data-mekhann-gift-input]');
          if (!field) return;
          var status = region.querySelector(scope === 'note' ? '[data-mekhann-note-status]' : '[data-mekhann-gift-status]');
          if (!status) {
            status = document.createElement('p');
            status.className = 'mekhann-cart-option-status';
            status.setAttribute('data-mekhann-' + scope + '-status', '');
            var host = scope === 'note' ? field.closest('.mekhann-cart-note-options') || field.closest('[data-mekhann-order-note]') || field.parentNode : field.closest('.mekhann-cart-gift-options');
            (host || field.parentNode).appendChild(status);
          }
          var revision = scope === 'note' ? draft.noteRevision : draft.giftRevision;
          var verified = scope === 'note' ? verifiedNote : verifiedGift;
          var state = feedback[scope];
          var message = state.error || (revision > verified && (extrasPending || queuedOperation || historyOperation || timer || composing.size) ? 'Saving…' :
            state.revision === revision && state.until > Date.now() ? (scope === 'note' ? 'Order note saved' : 'Gift wrapping preference saved') : '');
          status.setAttribute('role', 'status');
          status.setAttribute('aria-live', 'polite');
          status.setAttribute('aria-atomic', 'true');
          presentStatus(status, message, state.error ? 'error' : message === 'Saving…' ? 'pending' : 'success',
            scope === 'note' ? 'Your order note is taking longer to save.' : 'Your gift wrapping preference is taking longer to save.');
          status.classList.toggle('is-error', Boolean(state.error));
          var retry = region.querySelector('[data-mekhann-extras-retry="' + scope + '"]');
          if (!retry) {
            retry = document.createElement('button');
            retry.type = 'button';
            retry.className = 'text-link mekhann-cart-extras__retry';
            retry.setAttribute('data-mekhann-extras-retry', scope);
            retry.textContent = 'Try again';
            retry.setAttribute('aria-label', scope === 'note' ? 'Try saving your order note again' : 'Try saving your gift wrapping preference again');
            status.parentNode.insertBefore(retry, status.nextSibling);
          }
          retry.hidden = !state.error;
        });
        // A checkout/read verification failure with no dirty field is a bag
        // failure, not an error owned by an unchecked gift option.
        var bagError = region.querySelector('[data-mekhann-extras-error]');
        var unassignedError = extrasError && !feedback.note.error && !feedback.gift.error ? extrasError : '';
        if (unassignedError && !bagError) {
          bagError = document.createElement('p');
          bagError.className = 'mekhann-cart-option-status is-error';
          bagError.setAttribute('data-mekhann-extras-error', '');
          bagError.setAttribute('role', 'status');
          bagError.setAttribute('aria-live', 'polite');
          region.appendChild(bagError);
        }
        if (bagError) presentStatus(bagError, unassignedError, 'error');
        var bagRetry = region.querySelector('[data-mekhann-extras-retry="bag"]');
        if (unassignedError && !bagRetry) {
          bagRetry = document.createElement('button');
          bagRetry.type = 'button';
          bagRetry.className = 'text-link mekhann-cart-extras__retry';
          bagRetry.setAttribute('data-mekhann-extras-retry', 'bag');
          bagRetry.textContent = 'Try again';
          bagRetry.setAttribute('aria-label', 'Try confirming your bag again');
          region.appendChild(bagRetry);
        }
        if (bagRetry) bagRetry.hidden = !unassignedError;
      });
      // A note/gift save owns the same inline Remove lock until it settles.
      syncCheckoutGuards();
    }

    function remaining(deadline) {
      var milliseconds = deadline - Date.now();
      if (milliseconds <= 0) throw new Error(failureMessage);
      return milliseconds;
    }

    function readOrWrite(payload, deadline, epoch) {
      if (epoch === undefined) epoch = lifecycleEpoch;
      assertLifecycle(epoch);
      var requestDuration = Math.min(15000, remaining(deadline));
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var options = { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } };
      if (payload) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(payload);
      }
      if (controller) options.signal = controller.signal;
      var url = payload ? route('cartUpdate', 'cart/update.js') : route('cart', 'cart.js');
      // The timer rejects independently of AbortController support. Late network
      // completion cannot report Saved or resume an expired checkout attempt.
      return new Promise(function (resolve, reject) {
        var settled = false;
        function cancel() {
          if (settled) return;
          settled = true;
          window.clearTimeout(requestTimer);
          requests.delete(cancel);
          if (controller) controller.abort();
          reject(lifecycleError());
        }
        requests.add(cancel);
        var requestTimer = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          requests.delete(cancel);
          if (controller) controller.abort();
          reject(new Error(failureMessage));
        }, requestDuration);
        Promise.resolve().then(function () { assertLifecycle(epoch); return fetch(url, options); }).then(parseResponse).then(function (cart) {
          assertLifecycle(epoch);
          if (!cart || !Array.isArray(cart.items)) throw new Error(failureMessage);
          if (!settled) { settled = true; requests.delete(cancel); window.clearTimeout(requestTimer); resolve(cart); }
        }).catch(function (error) {
          if (!settled) { settled = true; requests.delete(cancel); window.clearTimeout(requestTimer); reject(error); }
        });
      });
    }

    function matches(cart, expected, noteOnly, giftOnly) {
      if (!cart || !Array.isArray(cart.items)) return false;
      var attributes = cart.attributes || {};
      if (!giftOnly && expected.managedNote && String(cart.note || '') !== expected.note) return false;
      if (!noteOnly && expected.managedGift &&
          String(attributes['Gift wrapping'] || '') !== (expected.wrapping ? 'Yes' : '')) return false;
      return noteOnly || !expected.giftTouched || !String(attributes['Gift order'] || '');
    }

    function adoptUneditedFields(cart, expected, writesNote, writesGift) {
      // A fresh confirmed cart may contain another surface's saved metadata.
      // A restored focus is not evidence of an edit. Revisions and composition
      // protect actual typing; a clean focused field may adopt fresh server data.
      var composingNote = false;
      var composingGift = false;
      composing.forEach(function (input) {
        if (input.matches('[name="note"]')) composingNote = true;
        else composingGift = true;
      });
      if (!writesNote && !composingNote && expected.managedNote && draft.noteRevision === expected.noteRevision &&
          draft.noteRevision <= verifiedNote && draft.note !== String(cart.note || '')) {
        draft.note = String(cart.note || '');
        expected.note = draft.note;
        clearSuccess('note');
      }
      var attributes = cart.attributes || {};
      if (!writesGift && !composingGift && draft.giftRevision === expected.giftRevision && draft.giftRevision <= verifiedGift) {
        var wrapping = attributes['Gift wrapping'] === 'Yes';
        if (draft.wrapping !== wrapping) {
          draft.wrapping = wrapping;
          expected.wrapping = wrapping;
          clearSuccess('gift');
        }
        // A legacy flag never becomes new wrapping consent. Preserve it until
        // an explicit gift edit retires it; a note-only edit must not do so.
        legacy = String(attributes['Gift order'] || '') === 'Yes';
        expected.managedGift = draft.giftTouched || wrapping || !legacy;
      }
      render();
    }

    function waitForIdle(deadline, epoch) {
      if (epoch !== undefined) assertLifecycle(epoch);
      remaining(deadline);
      composing.forEach(function (input) { if (!document.contains(input)) composing.delete(input); });
      if (composing.size || addInFlight || addOperation || removeOperation || reconcileInFlight ||
          externalMutationPending || externalVerificationInFlight || groupBusy()) {
        return delay(50).then(function () { return waitForIdle(deadline, epoch); });
      }
      return Promise.resolve();
    }

    function flush(deadline, full) {
      if (timer) { window.clearTimeout(timer); timer = null; }
      deadline = deadline || Date.now() + 30000;
      if (pageSuspended) return Promise.reject(lifecycleError());
      if (historyRequired || historyOperation) return refreshHistory(deadline).then(function () { return flush(deadline, full); });
      if (queuedOperation) return queuedOperation.then(function () { return flush(deadline, full); });
      if (operation) return operation.then(function () { return flush(deadline, full); });
      var epoch = lifecycleEpoch;
      extrasError = '';
      feedback.note.error = '';
      feedback.gift.error = '';
      if (ownedMutation) {
        // Wait without claiming an active metadata request. The cart owner must
        // validate its completed render receipt before this save can start.
        // The existing deadline and lifecycle epoch bound/cancel this queue;
        // dirty drafts, explicit retry and full checkout all retain their flush.
        queuedOperation = waitForIdle(deadline, epoch).then(function () {
          queuedOperation = null;
          return flush(deadline, full);
        }, function (error) {
          queuedOperation = null;
          if (!error || !error.mekhannNavigation) {
            extrasError = failureMessage;
            if (draft.noteRevision > verifiedNote) feedback.note.error = 'Your order note could not be saved. Your text is kept.';
            if (draft.giftRevision > verifiedGift) feedback.gift.error = 'We couldn’t save your gift wrapping preference. Please try again.';
            clearSuccess();
          }
          render();
          throw error;
        });
        render();
        return queuedOperation;
      }
      ordinarySave = !full;
      extrasPending += 1;
      render();
      function pass() {
        return waitForIdle(deadline, epoch).then(function () {
          assertLifecycle(epoch);
          capture();
          var expected = snapshot();
          var payload = {};
          var writesNote = expected.noteRevision > verifiedNote;
          var writesGift = expected.giftRevision > verifiedGift;
          if (writesNote) payload.note = expected.note;
          if (writesGift) {
            // Patch only the currently editable gift choice. Existing Gift
            // message data belongs to its original writer and remains intact.
            payload.attributes = { 'Gift wrapping': expected.wrapping ? 'Yes' : '' };
            if (expected.giftTouched) payload.attributes['Gift order'] = '';
          }
          var write = function () {
            // groups.run has now assigned this exact metadata owner. Reflect
            // its queueable controls only once no unrelated task is ahead.
            syncCheckoutGuards();
            return readOrWrite(payload, deadline, epoch);
          };
          var groups = cartGroups();
          var save = Promise.resolve();
          if (writesNote || writesGift) {
            // Retain only this exact metadata POST's queue identity. A Remove
            // may wait for its whole save, never bypass a different group task.
            metadataWriteTask = write;
            save = (groups ? groups.run(write) : write()).finally(function () {
              if (metadataWriteTask === write) metadataWriteTask = null;
            });
          }
          return save.then(function (savedCart) {
            // An ordinary edit needs Shopify's acknowledgement of the fields
            // just written, not a second cart read or a new monetary proof.
            // Full checkout still takes the fresh GET below and then its own
            // current JSON/Liquid carrier-price proof before native submission.
            return !full && (writesNote || writesGift) ? savedCart : readOrWrite(null, deadline, epoch);
          }).then(function (cart) {
            assertLifecycle(epoch);
            // A gift-only edit never writes a stale order note. Verify only the
            // fields written here; checkout separately verifies the full draft.
            if (writesNote && !matches(cart, expected, true, false) ||
                writesGift && !matches(cart, expected, false, true)) throw new Error(failureMessage);
            if (writesNote) verifiedNote = expected.noteRevision;
            if (writesGift) { verifiedGift = expected.giftRevision; if (expected.giftTouched) legacy = false; }
            capture();
            adoptUneditedFields(cart, expected, writesNote, writesGift);
            if (writesNote && draft.noteRevision === expected.noteRevision) confirmField('note', expected.noteRevision, expected.feedbackEpoch);
            if (writesGift && draft.giftRevision === expected.giftRevision) confirmField('gift', expected.giftRevision, expected.feedbackEpoch);
            if (draft.revision !== expected.revision || composing.size) return pass();
            if (full && !matches(cart, expected)) {
              // Preserve the customer's visible current intent if a different
              // writer changed metadata between render and checkout.
              var attributes = cart.attributes || {};
              draft.revision += 1;
              if (expected.managedNote && String(cart.note || '') !== expected.note) draft.noteRevision = draft.revision;
              if (expected.managedGift && String(attributes['Gift wrapping'] || '') !== (expected.wrapping ? 'Yes' : '') ||
                  expected.giftTouched && String(attributes['Gift order'] || '')) draft.giftRevision = draft.revision;
              return pass();
            }
            verifiedRevision = expected.revision;
            clearRecoveredBagNavigationFailures();
            return { cart: cart, revision: expected.revision };
          });
        });
      }
      operation = pass().catch(function (error) {
        if (error && error.mekhannNavigation || epoch !== lifecycleEpoch) throw error;
        extrasError = failureMessage;
        if (draft.noteRevision > verifiedNote) feedback.note.error = 'Your order note could not be saved. Your text is kept.';
        if (draft.giftRevision > verifiedGift) feedback.gift.error = 'We couldn’t save your gift wrapping preference. Please try again.';
        clearSuccess();
        throw error;
      }).finally(function () {
        operation = null;
        ordinarySave = false;
        extrasPending -= 1;
        render();
      });
      extrasOperation = operation;
      return operation;
    }

    function refreshHistory(deadline) {
      if (historyOperation) return historyOperation;
      if (pageSuspended) return Promise.reject(lifecycleError());
      deadline = deadline || Date.now() + 15000;
      var epoch = lifecycleEpoch;
      var expected;
      function historyCurrent() { assertLifecycle(epoch); remaining(deadline); }
      historyRequired = true;
      verifiedRevision = -1;
      if (ownedMutation) {
        // A history read follows the same ownership boundary as a queued save.
        // Do not reserve metadata busy state while waiting for the cart owner
        // to confirm its render. Preserve this refresh's deadline and epoch.
        historyOperation = waitForIdle(deadline, epoch).then(function () {
          historyOperation = null;
          return refreshHistory(deadline);
        }, function (error) {
          historyOperation = null;
          if (!error || !error.mekhannNavigation) {
            extrasError = 'Your bag could not be refreshed. Your text is kept. Try again.';
            clearSuccess();
          }
          render();
          throw error;
        });
        render();
        return historyOperation;
      }
      extrasPending += 1;
      // Wait for a cancelled/finishing local save before the fresh read. Never
      // let an older reply mark the resumed page as verified or navigate it.
      historyOperation = (operation ? operation.catch(function () {}) : Promise.resolve()).then(function () {
        assertLifecycle(epoch);
        return waitForIdle(deadline, epoch);
      }).then(function () {
        expected = snapshot();
        return readOrWrite(null, deadline, epoch);
      }).then(function (cart) {
        historyCurrent();
        // Ajax metadata alone cannot validate carrier mapping or refresh a
        // restored bag. Pair that cart with current Liquid proof first.
        return attachCarrierMappings(cart, false);
      }).then(function (cart) {
        historyCurrent();
        // Even a valid cart whose quantity changed elsewhere needs new HTML.
        // Keep metadata ownership through reconciliation and verified rendering.
        return runReconcile(cart, true, null, historyCurrent);
      }).then(function (result) {
        historyCurrent();
        if (!result || result.deferred || !result.cart || findInvalidPilotLine(result.cart)) {
          throw new Error('Your bag could not be refreshed. Please try again.');
        }
        adoptUneditedFields(result.cart, expected, false, false);
        historyRequired = false;
        extrasError = '';
        return result.cart;
      }).catch(function (error) {
        if (!error || !error.mekhannNavigation) {
          extrasError = 'Your bag could not be refreshed. Your text is kept. Try again.';
          clearSuccess();
        }
        throw error;
      }).finally(function () {
        historyOperation = null;
        extrasPending -= 1;
        render();
      });
      extrasOperation = historyOperation;
      render();
      return historyOperation;
    }

    function queueHistoryRefresh() {
      cancelBagNavigation();
      retireCheckoutRetry();
      pageSuspended = false;
      lifecycleEpoch += 1;
      var requestedEpoch = lifecycleEpoch;
      historyRequired = true;
      verifiedRevision = -1;
      feedbackEpoch += 1;
      clearSuccess();
      if (timer) { window.clearTimeout(timer); timer = null; }
      requests.forEach(function (cancel) { cancel(); });
      if (historyTimer) window.clearTimeout(historyTimer);
      historyTimer = window.setTimeout(function () {
        historyTimer = null;
        refreshHistory().catch(function (error) {
          // A newer history event may have joined the cancelled prior refresh.
          // Only the latest event starts its replacement once that work settles.
          if (error && error.mekhannNavigation && !pageSuspended && lifecycleEpoch === requestedEpoch) return refreshHistory();
          throw error;
        }).then(function () {
          if (!pageSuspended && !checkoutInFlight && !operation &&
              (draft.noteRevision > verifiedNote || draft.giftRevision > verifiedGift) &&
              !feedback.note.error && !feedback.gift.error) schedule(300);
        }).catch(function () { /* A visible retry owns recovery; no polling. */ });
      }, 0);
    }

    function hasUnsavedFields() {
      return draft.noteRevision > verifiedNote || draft.giftRevision > verifiedGift;
    }

    // MC_EXTRAS_RECOVERY_01_2026_10_17: ended navigation errors and dormant
    // checkout retries retain their own recovery/session boundaries.
    function retireCheckoutRetry() {
      if (!checkoutIntent) return;
      checkoutIntent.retryAllowed = false;
      if (!checkoutInFlight) checkoutIntent = null;
    }

    function clearRecoveredBagNavigationFailures() {
      if (extrasError || hasUnsavedFields() || composing.size || verifiedRevision !== draft.revision) return;
      bagNavigationFailures.forEach(function (failure, node) {
        // A new navigation or another status owner may have reused this node.
        // Acknowledgement can retire only this exact ended metadata failure.
        if (node.__mekhannCalmStatus !== failure.state) { bagNavigationFailures.delete(node); return; }
        if (verifiedNote < failure.noteRevision || verifiedGift < failure.giftRevision) return;
        presentStatus(node, '', 'pending');
        bagNavigationFailures.delete(node);
      });
    }

    // MC_BAG_NAV_LIFECYCLE_01_2026_10_17: navigation feedback belongs to
    // one intent, including its cancellation and history lifecycle. A finished
    // or abandoned intent must not leave its long-wait timer on the page.
    function bagNavigationStatus(link, message, kind) {
      var form = link.closest(FORM_SELECTOR);
      var status = form && form.querySelector('[data-mekhann-bag-navigation-status]');
      if (!status && form) {
        status = document.createElement('p');
        status.className = 'mekhann-cart-option-status';
        status.setAttribute('data-mekhann-bag-navigation-status', '');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        link.insertAdjacentElement('afterend', status);
      }
      if (status) {
        bagNavigationFailures.delete(status);
        presentStatus(status, message, kind || 'pending', 'Your changes are taking longer to save.');
      }
      return status;
    }

    function clearBagNavigationStatus(intent) {
      // Keep the exact node: the clicked link can detach while its status
      // remains mounted. Looking up its old form would miss that cleanup.
      if (intent && intent.status) {
        bagNavigationFailures.delete(intent.status);
        presentStatus(intent.status, '', 'pending');
      }
    }

    function cancelBagNavigation() {
      var intent = bagNavigation;
      if (!intent) return;
      bagNavigation = null;
      intent.link.removeAttribute('aria-busy');
      clearBagNavigationStatus(intent);
      // Navigation is abandoned, not the customer's underlying metadata save.
    }

    function navigateToBag(event) {
      var link = event.target.closest && event.target.closest('[data-mekhann-view-bag]');
      if (!link || !link.closest(FORM_SELECTOR) || event.defaultPrevented || event.button > 1) return;
      var destination;
      try { destination = new URL(link.href, window.location.href); } catch (ignore) { return; }
      if (destination.origin !== window.location.origin) return;
      // An already accepted checkout intent keeps its navigation ownership.
      if (checkoutInFlight) { event.preventDefault(); return; }
      capture(link.closest(FORM_SELECTOR));
      var modified = event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button === 1;
      var needsSave = hasUnsavedFields() || composing.size || operation || queuedOperation || historyRequired || historyOperation || extrasError;
      // A clean modified click keeps normal browser/new-tab semantics. Dirty
      // modified clicks save first and ask for another click; no surprise popup.
      if (modified && !needsSave) return;
      event.preventDefault();
      if (bagNavigation) return;
      retireCheckoutRetry();
      var drawer = link.closest('#CartDrawer');
      var intent = { link: link, drawer: drawer && drawer.classList.contains('drawer--is-open') ? drawer : null, epoch: lifecycleEpoch, deadline: Date.now() + 30000 };
      bagNavigation = intent;
      link.setAttribute('aria-busy', 'true');
      intent.status = bagNavigationStatus(link, 'Saving your changes…', 'pending');
      function current() {
        assertLifecycle(intent.epoch);
        remaining(intent.deadline);
        if (bagNavigation !== intent || !document.contains(link) || intent.drawer && !intent.drawer.classList.contains('drawer--is-open')) throw lifecycleError();
      }
      function prepare() {
        current();
        return waitForIdle(intent.deadline, intent.epoch).then(function () {
          current();
          capture(link.closest(FORM_SELECTOR));
          // Join the actual existing save. Once its last revision is confirmed,
          // do not turn a clean navigation into a second GET or metadata POST.
          if (operation || queuedOperation) return (operation || queuedOperation).then(prepare);
          if (hasUnsavedFields() || historyRequired || historyOperation || extrasError) return flush(intent.deadline, false).then(prepare);
          if (composing.size) return prepare();
          current();
        });
      }
      prepare().then(function () {
        current();
        if (modified) bagNavigationStatus(link, 'Changes saved. Open your shopping bag when you’re ready.', 'notice');
        else {
          clearBagNavigationStatus(intent);
          window.location.assign(destination.href);
        }
      }).catch(function (error) {
        // An older rejected promise cannot clear or replace a newer intent's
        // status, even if both intents used the same link and status node.
        if (bagNavigation !== intent) return;
        if (error && error.mekhannNavigation) clearBagNavigationStatus(intent);
        else {
          var unsaved = hasUnsavedFields();
          var status = bagNavigationStatus(link, unsaved ? 'Your changes could not be saved. Please try again before opening your shopping bag.' : 'Your shopping bag could not be opened. Please try again.', 'error');
          if (unsaved && status) bagNavigationFailures.set(status, {
            state: status.__mekhannCalmStatus, noteRevision: draft.noteRevision, giftRevision: draft.giftRevision
          });
        }
      }).finally(function () {
        if (bagNavigation === intent) {
          bagNavigation = null;
          link.removeAttribute('aria-busy');
        }
      });
    }

    function schedule(milliseconds) {
      if (timer) { window.clearTimeout(timer); timer = null; }
      // A focused textarea emits change on blur even after autosave confirmed
      // its value. Do not let that no-op save wait behind a cart mutation while
      // holding extrasPending and invalidating the mutation's render receipt.
      // Explicit retry and full checkout verification still call flush directly.
      if (hasUnsavedFields()) {
        timer = window.setTimeout(function () {
          timer = null;
          // A running save already captures newer revisions and repeats its
          // pass when needed. A blur/change must not queue a second no-op read.
          if (hasUnsavedFields() && !operation) flush().catch(function () { /* Kept drafts and visible retry own recovery. */ });
          else render();
        }, milliseconds);
      }
      render();
    }

    cartExtras = {
      capture: capture, render: render, flush: flush,
      cancelBagNavigation: cancelBagNavigation,
      ordinarySavePending: function () { return ordinarySave && !pageSuspended && !historyRequired && !historyOperation; },
      pendingSave: function () { return !pageSuspended && !historyRequired && !historyOperation && !composing.size && !extrasError ? operation : null; },
      ownsGroupTask: function () {
        var groups = cartGroups();
        return Boolean(metadataWriteTask && groups && typeof groups.onlyPendingTaskIs === 'function' && groups.onlyPendingTaskIs(metadataWriteTask));
      },
      removeGuard: function (current, deadline, started, action) {
        var epoch = lifecycleEpoch;
        return function () {
          try {
            assertLifecycle(epoch);
            if (!current()) throw lifecycleError();
            if (!started() && Date.now() >= deadline) throw new Error(action === 'quantity' ? 'Your bag is still saving. Please try updating the quantity again.' : 'Your bag is still saving. Please try removing the item again.');
            if (extrasError) throw new Error(failureMessage);
          } catch (error) { error.mekhannRemoveCancelled = true; throw error; }
        };
      },
      revision: function () { return draft.revision; },
      matches: function (cart) { return !composing.size && matches(cart, snapshot()); },
      verified: function () { return !pageSuspended && !historyRequired && !extrasPending && !extrasError && !composing.size && verifiedRevision === draft.revision; },
      clearSuccess: function () { feedbackEpoch += 1; clearSuccess(); render(); },
      fail: function (message) { extrasError = message || failureMessage; clearSuccess(); render(); }
    };
    document.addEventListener('input', function (event) {
      if (!isField(event.target)) return;
      captureField(event.target, true);
      if (!event.isComposing && !composing.has(event.target)) schedule(300);
    });
    document.addEventListener('change', function (event) {
      if (!isField(event.target)) return;
      captureField(event.target, true);
      if (!composing.has(event.target)) schedule(0);
    });
    document.addEventListener('compositionstart', function (event) {
      if (isField(event.target)) composing.add(event.target);
    });
    document.addEventListener('compositionend', function (event) {
      if (!isField(event.target)) return;
      composing.delete(event.target);
      captureField(event.target, true);
      schedule(0);
    });
    document.addEventListener('click', function (event) {
      var retry = event.target.closest('[data-mekhann-extras-retry]');
      if (!retry) return;
      event.preventDefault();
      var form = retry.closest(FORM_SELECTOR);
      capture(form);
      if (checkoutIntent && !checkoutInFlight && checkoutIntent.retryAllowed !== false &&
          checkoutIntent.form === form && document.contains(form)) resumeCheckoutIntent(checkoutIntent);
      else {
        if (!checkoutInFlight) retireCheckoutRetry();
        flush().catch(function () {});
      }
    });
    document.addEventListener('focusin', function (event) {
      if (isField(event.target)) rememberFieldFocus(event.target);
      else if (event.target !== document.body) fieldFocus = null;
    });
    document.addEventListener('select', function (event) {
      if (isField(event.target)) rememberFieldFocus(event.target);
    }, true);
    document.addEventListener('click', navigateToBag);
    document.addEventListener('auxclick', navigateToBag);
    document.addEventListener('drawerOpen.CartDrawer', cartExtras.clearSuccess);
    document.addEventListener('drawerClose.CartDrawer', function () {
      if (bagNavigation && bagNavigation.drawer) cancelBagNavigation();
      if (checkoutIntent && checkoutIntent.form.closest('#CartDrawer')) retireCheckoutRetry();
    });
    document.addEventListener('cart:rendered', function () { render(); restoreFieldFocus(); });
    window.addEventListener('pagehide', function () {
      capture();
      pageSuspended = true;
      lifecycleEpoch += 1;
      cancelBagNavigation();
      verifiedRevision = -1;
      feedbackEpoch += 1;
      clearSuccess();
      if (timer) { window.clearTimeout(timer); timer = null; }
      if (historyTimer) { window.clearTimeout(historyTimer); historyTimer = null; }
      requests.forEach(function (cancel) { cancel(); });
      composing.clear();
      fieldFocus = null;
      if (checkoutIntent) {
        // Also revoke the old attempt's finally callback, which may settle
        // after a newer checkout has started on the restored page.
        checkoutIntent.attempt += 1;
        setBusy(checkoutControl(checkoutIntent.form, checkoutIntent.submitter), false);
      }
      checkoutIntent = null;
      checkoutInFlight = false;
      checkoutBypass = false;
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted || pageSuspended) queueHistoryRefresh();
    });
    window.addEventListener('popstate', queueHistoryRefresh);
    render();
  }
  // V2.28: PDP is the sole selection surface. These operations retain the
  // existing monetary proof, shared queue and explicit parent-group identity.
  function pdpWaitForIdle(deadline, ownerToken, parentRecovery, guard, removeIntent) {
    deadline = deadline || Date.now() + 10000;
    if (guard) { try { guard(); } catch (error) { return Promise.reject(error); } }
    if (nativeBatchFault || nativeBatchRecord && !parentRecovery) return Promise.reject(nativeBatchError('check the original addition'));
    if (ownedQuantityUncertain) return Promise.reject(new Error('Your last quantity update could not be confirmed. Refresh your bag before continuing.'));
    if (Date.now() >= deadline) return Promise.reject(new Error('Your bag is still updating. Please check it before changing the fitting.'));
    if (pdpRecoveryFault) return Promise.reject(new Error('Your previous fitting request could not be checked safely. Please return to your bag.'));
    if (pendingPdpRecord && !addInFlight && !addOperation && !removeOperation && !reconcileInFlight &&
        !externalMutationPending && !externalVerificationInFlight && !groupBusy(ownerToken)) {
      return runReconcile(null, true, ownerToken).then(function () { return pdpWaitForIdle(deadline, ownerToken, parentRecovery, guard, removeIntent); });
    }
    if (addInFlight || addOperation || removeOperation || reconcileInFlight || checkoutInFlight || extrasPending ||
        externalMutationPending || externalVerificationInFlight || groupBusy(ownerToken) ||
        (unverifiedMutation && !parentRecovery) || pendingAddToken || pendingRemoveIntent && pendingRemoveIntent !== removeIntent) {
      return delay(50).then(function () { return pdpWaitForIdle(deadline, ownerToken, parentRecovery, guard, removeIntent); });
    }
    return Promise.resolve();
  }

  function pdpReadCart() {
    return pdpWaitForIdle().then(function () { return getCart(); });
  }

  function supersedeCartBuilds() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      var cartForm = form.__mekhannCartForm;
      if (form.isConnected && cartForm && typeof cartForm.supersedeBuild === 'function') {
        cartForm.supersedeBuild();
      }
    });
  }

  function canQueueRemoveAfterExtras() {
    var onlyMetadataBusy = cartExtras && cartExtras.ownsGroupTask() &&
      !document.querySelector('#CartDrawerForm[aria-busy="true"], #CartPageForm[aria-busy="true"]');
    return Boolean(cartExtras && cartExtras.pendingSave() && extrasPending === 1 && !pendingRemoveIntent &&
      !nativeBatchRecord && !nativeBatchFault &&
      !ownedMutation && !addInFlight && !addOperation && !removeOperation && !reconcileInFlight && !checkoutInFlight &&
      !unverifiedMutation && !ownedParentUncertain && !ownedQuantityUncertain && !pendingAddToken && !pendingPdpRecord &&
      !pendingReductionProtection && !pdpRecoveryFault && !externalMutationPending && !externalVerificationInFlight && (!groupBusy() || onlyMetadataBusy) &&
      !document.querySelector(FORM_SELECTOR.split(',').map(function (selector) { return selector.trim() + '[data-mekhann-cart-unverified="true"]'; }).join(',')));
  }

  function canQueueQuantityAfterExtras() {
    return Boolean(cartExtras && cartExtras.ordinarySavePending() && canQueueRemoveAfterExtras());
  }

  function waitForRemoveSave(pending, intent) {
    return new Promise(function (resolve, reject) {
      var settled = false, timer;
      function finish(error) {
        if (settled) return;
        settled = true; window.clearTimeout(timer);
        if (error) reject(error); else resolve();
      }
      function check() {
        try { intent.guard(); } catch (error) { finish(error); return; }
        timer = window.setTimeout(check, 50);
      }
      check();
      Promise.resolve(pending).then(function () { finish(); }, finish);
    });
  }

  function beginOwnedMutation(options) {
    if (options && options.afterExtras) {
      var quantityAction = options.action === 'quantity';
      if (!(quantityAction ? canQueueQuantityAfterExtras() : canQueueRemoveAfterExtras()) || typeof options.isCurrent !== 'function') return Promise.reject(new Error('Your bag is still updating. Please try again.'));
      var deadline = Date.now() + 10000;
      var intent = { writeStarted: false, action: quantityAction ? 'quantity' : 'remove' };
      intent.guard = cartExtras.removeGuard(function () { return options.isCurrent(intent.writeStarted || intent.settling); }, deadline, function () { return intent.writeStarted || intent.settling; }, intent.action);
      pendingRemoveIntent = intent;
      syncCheckoutGuards();
      return waitForRemoveSave(cartExtras.pendingSave(), intent).then(function () {
        intent.guard();
        cartExtras.capture();
        if (!cartExtras.verified()) throw new Error(quantityAction ? 'Your note or gift details are still being saved. Please try updating the quantity again.' : 'Your note or gift details are still being saved. Please try removing the item again.');
        return beginOwnedMutation({ removeIntent: intent, deadline: deadline });
      }).finally(function () {
        if (pendingRemoveIntent === intent) pendingRemoveIntent = null;
        syncCheckoutGuards();
      });
    }
    var removeIntent = options && options.removeIntent;
    var parentRecovery = Boolean(options && options.parentRecovery && ownedParentUncertain && !ownedQuantityUncertain &&
      !pendingAddToken && !pendingPdpRecord && !pendingReductionProtection && !pdpRecoveryFault && !nativeBatchFault);
    return pdpWaitForIdle(options && options.deadline, undefined, parentRecovery, removeIntent && removeIntent.guard, removeIntent).then(function () {
      if (removeIntent) removeIntent.guard();
      if (ownedMutation) throw new Error('Your bag is already updating. Please wait for it to finish.');
      supersedeCartBuilds();
      cartMutationGeneration += 1;
      ownedMutation = { id: ++ownedSequence, external: externalMutationGeneration, invalid: false, settling: null, parentRecovery: parentRecovery };
      ownedMutation.nativeRecoveryRequested = Boolean(options && options.parentRecovery);
      if (parentRecovery && nativeBatchRecord) ownedMutation.nativeBatchToken = nativeBatchRecord.token;
      if (removeIntent) ownedMutation.queuedRemoval = removeIntent;
      window.clearTimeout(reconcileTimer);
      lastRenderReceipt = null;
      syncCheckoutGuards();
      return ownedMutation;
    });
  }

  function assertQueuedRemove(token, beforeWrite) {
    var intent = token && token.queuedRemoval;
    if (!intent) return;
    intent.guard();
    if (intent.writeStarted) return;
    if (!ownedCurrent(token) || !cartExtras.verified()) {
      var error = new Error(intent.action === 'quantity' ? 'Your bag changed while waiting. Please try updating the quantity again.' : 'Your bag changed while waiting. Please try removing the item again.');
      error.mekhannRemoveCancelled = true;
      throw error;
    }
    if (beforeWrite) intent.writeStarted = true;
  }

  function cancelQueuedRemove(token, uncertain) {
    if (!token || ownedMutation !== token || !token.queuedRemoval) return false;
    // Never start abort recovery after navigation: reconciliation can mutate.
    // An unsent Remove needs no new verification lock; a started update must
    // remain unverified until the next active surface proves the actual cart.
    if (token.queuedRemoval.writeStarted) {
      unverifiedMutation = true;
      if (uncertain) ownedQuantityUncertain = true;
    }
    ownedMutation = null;
    renderVerificationPending = true;
    syncCheckoutGuards();
    return true;
  }

  function finishOwnedMutation(token, result) {
    if (!ownedCurrent(token) || !result || !result.cart || result.deferred ||
        nativeBatchRecord || nativeBatchFault || unverifiedMutation || pendingAddToken || findInvalidPilotLine(result.cart)) {
      throw new Error('Your shopping bag update could not be confirmed safely. Please refresh it before continuing.');
    }
    if (!result.renderReceipt || result.renderReceipt !== lastRenderReceipt || result.renderReceipt.stamp !== generationStamp()) {
      throw new Error('Your bag could not be refreshed. Please refresh it before continuing.');
    }
    // A matching server snapshot and tagged synchronous replacement already
    // prove this generation. Do not schedule its structural observer again.
    reconcileAfterMutation = false;
    window.clearTimeout(reconcileTimer);
    ownedMutation = null;
    syncCheckoutGuards();
    revealOffers();
    if (token.nativeBatchResolved) result.nativeBatchResolved = token.nativeBatchResolved;
    return result;
  }

  // PLUS1: an explicit +1 on a fully proven Follow group is a new paired
  // purchase. Keep its distinct server identity and reuse the existing grouped
  // batch journal, stock-checked Add, monetary proof and final render barrier.
  // null means no POST/journal was started; only that result permits the older
  // quantity route. Once prepared, every outcome stays with this batch owner.
  function tryPlusOwnedSelection(owner, identity, target, guard, expectedQuantity) {
    var groups = cartGroups();
    if (!groups || !ownedCurrent(owner) || owner.parentRecovery ||
        !Number.isSafeInteger(expectedQuantity) || expectedQuantity < 1 || target !== expectedQuantity + 1 ||
        nativeBatchRecord || nativeBatchFault || pendingAddToken || pendingPdpRecord || pdpRecoveryFault ||
        ownedParentUncertain || ownedQuantityUncertain || pendingReductionProtection) return Promise.resolve(null);
    var display = groups.isDisplay(identity);
    var descriptor = display && identity.configuration ? identity.configuration.identity : identity;
    if (!descriptor || descriptor.uniqueKey || descriptor.parentKey || Number(descriptor.sellingPlanId) !== 0 ||
        display && (identity.configuration.carrierMode !== 'follow' || !Array.isArray(identity.childStates) ||
          identity.childStates.length !== identity.selections.length)) return Promise.resolve(null);
    var captured = Object.create(null), selections = display ? identity.selections : [identity];
    var offers = Array.prototype.slice.call(document.querySelectorAll(OFFER_SELECTOR));
    if (!selections.every(function (selection) {
      var matches = offers.filter(function (offer) {
        try { return groups.sameSelection(JSON.parse(offer.dataset.parentGroup), selection); }
        catch (ignore) { return false; }
      });
      var offer = matches[0];
      if (!offer || offer.dataset.carrierProven !== 'true' || !positiveQuantity(offer.dataset.parentQuantity) ||
          Number(offer.dataset.carrierSelected) !== Number(offer.dataset.parentQuantity) ||
          !numericId(offer.dataset.carrierVariantId)) return false;
      var evidence = { carrier: Number(offer.dataset.carrierVariantId), quantity: Number(offer.dataset.parentQuantity) };
      if (matches.some(function (other) {
        return other.dataset.carrierProven !== 'true' || Number(other.dataset.carrierVariantId) !== evidence.carrier ||
          Number(other.dataset.parentQuantity) !== evidence.quantity || Number(other.dataset.carrierSelected) !== evidence.quantity;
      })) return false;
      captured[groups.selectionSignature(selection)] = evidence;
      return true;
    })) return Promise.resolve(null);
    var batch = null, intent = null, response = null, addError = null;
    function current(beforeWrite) {
      if (guard) guard(Boolean(beforeWrite));
      if (!ownedCurrent(owner)) throw new Error('Your bag changed while the quantity was being checked. Please refresh your bag.');
    }
    current(false);
    // Fresh Ajax and Liquid reads run concurrently. A prior-action proof is
    // never substituted for current mapping, price or automatic-discount data.
    return getCart().then(function (cart) {
      current(false);
      var parents = groups.members(cart, identity);
      if (!parents.length || parents.reduce(function (sum, parent) { return sum + parent.quantity; }, 0) !== expectedQuantity ||
          display && (identity.quantity !== expectedQuantity || parents.length !== identity.selections.length)) {
        throw new Error('Your bag has changed. Please check the quantity and try again.');
      }
      var config = null, seen = Object.create(null), eligible = parents.every(function (parent) {
        var props = parent.properties || {}, parentInfo = groups.descriptor(parent);
        // This cart already has matched fresh Liquid evidence. Preserve the
        // established blank-type allowance; getPilotLineIssue below still
        // requires the full zero-price/discount provenance and live mapping.
        var next = groups.displayConfiguration(cart, parent, true);
        var preference = carrierPreference(cart, parent), signature = groups.selectionSignature(parent);
        if (seen[signature] || !(nativeGroupProperties(props) || groupedParentProperties(props)) ||
            parentInfo.sellingPlanId || parentInfo.parentKey || parentInfo.uniqueKey ||
            !Number.isSafeInteger(parent.product_id) || parent.product_id <= 0 ||
            !next || next.carrierMode !== 'follow' || next.identity.properties.length ||
            !validCarrierPreference(preference) || preference.mode !== 'follow' || preference.suspended ||
            !parent._mekhann_parent_selection_key ||
            !carrierOptions(cart, parent.variant_id).some(function (option) {
              return option.id === next.carrierVariantId && option.available;
            }) || linkedCarriers(cart, parent).some(function (child) { return getPilotLineIssue(cart, child); })) return false;
        seen[signature] = true;
        var shown = captured[signature];
        if (!shown || shown.carrier !== next.carrierVariantId || shown.quantity !== parent.quantity) {
          throw new Error('Your fitting selection has changed. Please check your bag before increasing the quantity.');
        }
        if (config && !nativeEqual(config, next)) return false;
        config = next;
        if (display) {
          var index = identity.selections.findIndex(function (selection) { return groups.sameSelection(parent, selection); });
          if (index < 0 || !nativeEqual(next, identity.configuration) ||
              identity.childStates[index] !== groups.displayChildState(cart, parent)) {
            throw new Error('Your bag has changed. Please check the quantity and try again.');
          }
        }
        return true;
      });
      if (!eligible || !config || findInvalidPilotLine(cart)) return null;
      // A second-tab equivalent purchase must not silently turn an old +1
      // command into an addition on a newly enlarged visible group.
      var equivalent = cart.items.filter(function (parent) {
        var value = groups.displayConfiguration(cart, parent, true);
        return value && nativeEqual(value, config);
      });
      if (equivalent.length !== parents.length) throw new Error('Your bag has changed. Please check the quantity and try again.');
      var parent = parents[0];
      var groupId = 'plus-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      intent = { expectedVariantId: parent.variant_id, expectedProductId: parent.product_id,
        parentGroupId: groupId, carrierVariantId: config.carrierVariantId, quantityPlus: true };
      var choices = [{ id: parent.variant_id, quantity: 1, plan: 0, properties: { _mekhann_fitting_group: groupId } }];
      current(false);
      batch = prepareNativeBatch(owner, intent, choices, cart);
      if (!batch) return null;
      intent.nativeBatch = batch;
      try { current(true); markNativeBatchSent(owner, batch); }
      catch (error) {
        // The durable sent marker is the last synchronous step before fetch.
        // A cancelled unsent intent may clear only its own prepared journal.
        if (nativeBatchRecord && nativeBatchRecord.phase === 'prepared' && ownedCurrent(owner)) {
          abandonUnsentNativeBatch(owner, batch);
        }
        throw error;
      }
      return requestJson(route('cartAdd', 'cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: batch.items })
      }, 'response').then(function (data) { response = data; }, function (error) { addError = error; })
        .then(function () {
          current(false);
          acknowledgeNativeBatch(owner, batch, !addError, {
            httpStatus: addError ? Number(addError.httpStatus) || 0 : 200,
            unknown: Boolean(addError && (addError.mekhannMutationUnknown || [400, 404, 422].indexOf(Number(addError.httpStatus)) === -1))
          });
          // Bare add.js items cannot prove the whole cart or real Ajax token.
          // Only matching bundled Liquid evidence travels with this fresh read.
          return getCart(false, response);
        }).then(function (confirmed) {
          current(false);
          if (addError && rejectNativeBatch(owner, batch, confirmed, Number(addError.httpStatus),
              Boolean(addError.mekhannMutationUnknown || [400, 404, 422].indexOf(Number(addError.httpStatus)) === -1))) {
            return { cart: confirmed, warning: addError.message || 'The additional items could not be added. Your bag is unchanged.' };
          }
          return { cart: confirmed, fitting: intent };
        });
    });
  }

  function settleOwnedMutation(token, options) {
    if (!ownedCurrent(token)) return Promise.reject(new Error('Your bag changed during this update. Please refresh it before continuing.'));
    if (token.settling) return token.settling;
    options = options || {};
    var latest = null;
    var parentFingerprint = '';
    var parentCartToken = '';
    var queuedGuard = token.queuedRemoval ? function () { assertQueuedRemove(token, false); } : null;
    token.settling = Promise.resolve().then(function () {
      if (queuedGuard) queuedGuard();
      if (token.queuedRemoval) token.queuedRemoval.settling = true;
      if (!options.cart || !Array.isArray(options.cart.items)) throw new Error('The shopping bag response could not be confirmed.');
      parentFingerprint = renderCartFingerprint(options.cart);
      parentCartToken = options.cart.token || priorCartToken(options.cart) || '';
      // The theme owns and validates its parent mutation. Attach the current
      // mapping/economic context to that response before any child operation.
      return attachCarrierMappings(options.cart, false).then(observeCarrierPreferences).then(checkPendingPdpCart);
    }).then(function (cart) {
      if (queuedGuard) queuedGuard();
      latest = cart;
      if (!ownedCurrent(token)) throw new Error('Your bag changed before the fitting could be checked.');
      // attachCarrierMappings can fall back to a fresh cart after a mismatched
      // context. That fresh cart must still be the parent result the theme
      // validated; a different cross-tab cart cannot inherit that validation.
      if (!parentFingerprint || parentFingerprint !== renderCartFingerprint(cart) ||
          parentCartToken && cart.token && parentCartToken !== cart.token) {
        throw new Error('Your shopping bag changed after the product update. Please check it before continuing.');
      }
      if (options.fitting && options.fitting.nativeBatch) {
        return nativeBatchRecord ? settleNativeBatch(token, options.fitting, cart) : recoverCompletedNativeBatch(token, options.fitting.nativeBatch, cart);
      }
      if (nativeBatchRecord || nativeBatchFault) throw nativeBatchError('missing original fitting intent');
      if (token.parentRecovery) {
        // The theme's verification-only path has proven its original parent
        // request before supplying this response; no replacement POST is sent.
        ownedParentUncertain = false;
        unverifiedMutation = false;
      }
      if (options.fitting && Number(options.fitting.carrierVariantId) > 0) {
        return pdpSetFitting(options.fitting, token, cart);
      }
      return runReconcile(cart, true, token, queuedGuard).then(function (result) {
        latest = result.cart;
        if (result.deferred || !ownedCurrent(token) || unverifiedMutation || pendingAddToken || findInvalidPilotLine(result.cart)) {
          throw new Error('Your bag is still being checked. Please refresh it before continuing.');
        }
        return requireCartRefresh(result.cart, queuedGuard).then(function (confirmed) {
          return { cart: confirmed, renderReceipt: lastRenderReceipt };
        });
      });
    }).then(function (result) { latest = result.cart; return finishOwnedMutation(token, result); })
      .catch(function (error) {
        if (ownedMutation === token) unverifiedMutation = true;
        if (latest) error.cart = latest;
        syncCheckoutGuards();
        throw error;
      });
    return token.settling;
  }

  function abortOwnedMutation(token, options) {
    if (!token || ownedMutation !== token) return Promise.reject(new Error('This bag update is no longer active.'));
    if (token.recovering) return token.recovering;
    if (nativeBatchRecord || nativeBatchFault) {
      ownedMutation = null;
      return Promise.reject(nativeBatchError('original batch still pending'));
    }
    options = options || {};
    var latest = null;
    if (options.uncertain) {
      // Record before recovery I/O: a second network failure cannot downgrade
      // an unknown write to an ordinary refresh error.
      ownedParentUncertain = options.parentRecovery !== false;
      ownedQuantityUncertain = options.parentRecovery === false;
    }
    // An unrelated operation that has started but not completed still owns its
    // own lock. Releasing our token must never declare that operation finished.
    if (externalActiveWrites || externalMutationUncertain || externalMutationPending && !token.externalCompleted) {
      ownedMutation = null;
      unverifiedMutation = true;
      syncCheckoutGuards();
      return Promise.reject(new Error('Another shopping bag update is still running. Please wait before continuing.'));
    }
    token.invalid = false;
    token.external = externalMutationGeneration;
    externalMutationPending = false;
    externalVerificationDemand = false;
    token.recovering = getCart().then(function (cart) {
      latest = cart;
      if (options.uncertain) {
        // A late parent POST is not disproved by one clean GET. Never replay it
        // or report a successful recovery from that absence.
        throw new Error('Your last bag request could not be confirmed. Refresh your bag before trying again.');
      }
      return runReconcile(cart, true, token);
    }).then(function (result) {
      latest = result.cart;
      if (result.deferred || unverifiedMutation || pendingAddToken) throw new Error('Your bag is still being checked. Please refresh it before continuing.');
      return requireCartRefresh(result.cart).then(function (confirmed) {
        return finishOwnedMutation(token, { cart: confirmed, renderReceipt: lastRenderReceipt, recovered: true });
      });
    }).catch(function (error) {
      if (ownedMutation === token) ownedMutation = null;
      unverifiedMutation = true;
      if (latest) error.cart = latest;
      syncCheckoutGuards();
      revealOffers();
      throw error;
    });
    return token.recovering;
  }

  function pdpParent(cart, request) {
    var groups = cartGroups();
    if (!groups || !request || !Number.isSafeInteger(Number(request.expectedVariantId)) ||
        Number(request.expectedVariantId) <= 0 || !Number.isSafeInteger(Number(request.expectedProductId)) ||
        Number(request.expectedProductId) <= 0 || !request.parentGroupId && !request.parentDescriptor) {
      throw new Error('Your lampshade selection could not be identified. Please return to your bag.');
    }
    var descriptor = request.parentDescriptor;
    if (typeof descriptor === 'string') {
      try { descriptor = JSON.parse(descriptor); } catch (error) { throw new Error('Your lampshade selection could not be identified.'); }
    }
    var matches = cart.items.filter(function (item) {
      if (isCarrierVariant(item) || nativeParentKey(item)) return false;
      if (request.parentGroupId && normaliseProperties(item.properties)._mekhann_fitting_group !== request.parentGroupId) return false;
      return !descriptor || groups.sameSelection(item, descriptor);
    });
    var parent = matches[0];
    if (!parent || matches.some(function (item) { return !groups.sameSelection(item, parent); }) ||
        numericId(parent.variant_id) !== numericId(request.expectedVariantId) ||
        numericId(parent.product_id) !== numericId(request.expectedProductId) || parentQuantity(cart, parent) < 1) {
      throw new Error('This lampshade selection has changed. Please return to your bag to choose its fitting.');
    }
    return parent;
  }

  function unconfiguredOwnedFitting(cart, parent, request, ownerToken, suppliedCart, children) {
    // Only the owned new-purchase path may omit the initial Off write. A new
    // group with no preference or children cannot follow/grow on reload. The
    // pending-POST ledger and the final verified Follow write still own recovery.
    if (!ownedCurrent(ownerToken) || !ownerToken.settling || ownerToken.parentRecovery ||
        !suppliedCart || cart !== suppliedCart || !request || request.parentDescriptor ||
        typeof request.parentGroupId !== 'string' || !request.parentGroupId ||
        normaliseProperties(parent.properties)._mekhann_fitting_group !== request.parentGroupId ||
        Number(request.carrierVariantId) <= 0 || children.length ||
        pendingAddToken || pendingPdpRecord || pendingReductionProtection || restoredPdpPending ||
        ownedParentUncertain || ownedQuantityUncertain || pdpRecoveryFault) return false;
    var raw = (cart.attributes || {})[CARRIER_PREFERENCE_ATTRIBUTE];
    if (raw === undefined || raw === null || raw === '') return true;
    if (typeof raw !== 'string') return false;
    try {
      var saved = JSON.parse(raw);
      if (!saved || saved.version !== 1 || !saved.selections ||
          typeof saved.selections !== 'object' || Array.isArray(saved.selections)) return false;
      // An own key, including an invalid/null entry, is an existing setting.
      // Never reinterpret a broken preference document as a fresh selection.
      return !Object.prototype.hasOwnProperty.call(saved.selections, cartGroups().selectionSignature(parent));
    } catch (error) { return false; }
  }

  function pdpSetFitting(request, ownerToken, suppliedCart) {
    if (pdpOperation) return Promise.reject(new Error('Your fitting is already updating. Please wait for it to finish.'));
    request = Object.assign({}, request || {});
    var selectedId = Number(request.carrierVariantId);
    if (!Number.isSafeInteger(selectedId) || selectedId < 0) return Promise.reject(new Error('Please choose an available fitting.'));
    var operation = pdpWaitForIdle(undefined, ownerToken).then(function () {
      if (ownerToken && !ownedCurrent(ownerToken)) throw new Error('Your bag changed before the fitting could be updated.');
      if (!cartGroups()) throw new Error('Your shopping bag could not be loaded. Please refresh the page.');
      if (!ownerToken) supersedeCartBuilds();
      var previousReceipt = lastRenderReceipt;
      var previousRender = activeRender;
      var previousRenderCurrent = receiptCurrent(previousReceipt) && previousRender && previousRender.stamp === generationStamp();
      addInFlight = true;
      cartMutationGeneration += 1;
      var generation = cartMutationGeneration;
      var externalGeneration = externalMutationGeneration;
      var signalGeneration = cartSignalGeneration;
      var changed = false;
      var noOp = false;
      var current = null;
      var protection = null;
      var token = '';
      var warning = '';
      var ownedNewPurchase = false;
      var canMutate = function () {
        return generation === cartMutationGeneration && externalGeneration === externalMutationGeneration && signalGeneration === cartSignalGeneration &&
          !externalMutationPending && !removeOperation && (!ownerToken || ownedCurrent(ownerToken));
      };
      syncCheckoutGuards();
      var task = (suppliedCart && ownedCurrent(ownerToken) ? Promise.resolve(suppliedCart) : getCart()).then(function (cart) {
        current = cart;
        var parent = pdpParent(cart, request);
        if (!canMutate()) throw new Error('Your bag changed before the fitting could be updated.');
        // Resolve a requested option only against the fresh server allow-list.
        // Legacy mapped variants can remain but are never offered as new choices.
        var selected = carrierOptions(cart, parent.variant_id).find(function (option) { return option.id === selectedId; });
        if (selectedId && (!selected || !selected.available)) throw new Error('This fitting is currently unavailable. Please choose another option.');
        if (!parent._mekhann_parent_selection_key) throw new Error('Your fitting options need a fresh page. Please refresh your bag.');
        protection = commerceSnapshot(cart);
        var preference = carrierPreference(cart, parent);
        var children = linkedCarriers(cart, parent);
        var alreadySelected = selectedId ? children.length && children.every(function (child) {
          return numericId(child.variant_id) === selectedId && !getPilotLineIssue(cart, child);
        }) && carrierQuantityForParent(cart, parent) === parentQuantity(cart, parent) &&
          validCarrierPreference(preference) && preference.mode === 'follow' && !preference.suspended &&
          numericId(preference.chosenCarrierVariantId) === selectedId :
          !children.length && validCarrierPreference(preference) && preference.mode === 'off';
        if (alreadySelected && !findInvalidPilotLine(cart)) { noOp = true; return cart; }
        linkedCarriers(cart, parent).forEach(function (child) {
          delete protection.carriers[normaliseProperties(child.properties)._mekhann_pilot_token];
        });
        // Existing selections commit Off BEFORE replacement/add. A genuinely
        // unconfigured owned purchase already has no follow/grow instruction.
        changed = true;
        unverifiedMutation = true;
        ownedNewPurchase = unconfiguredOwnedFitting(cart, parent, request, ownerToken, suppliedCart, children);
        if (ownedNewPurchase) return cart;
        return saveCarrierPreference(cart, parent, 0, false, canMutate, selectedId);
      }).then(function (cart) {
        current = cart;
        if (noOp) return cart;
        var parent = pdpParent(cart, request);
        if (!canMutate() || protectedCartIssue(cart, protection)) throw new Error('Your bag changed while the fitting preference was saving.');
        var children = linkedCarriers(cart, parent);
        var alreadyCorrect = selectedId && children.length && children.every(function (child) {
          return numericId(child.variant_id) === selectedId && !getPilotLineIssue(cart, child);
        }) && carrierQuantityForParent(cart, parent) === parentQuantity(cart, parent);
        if (alreadyCorrect) return cart;
        return cartGroups().run(function () {
          if (!canMutate()) throw new Error('Your bag changed before the fitting could be replaced.');
          return trimCarrierPreference(cart, parent, 0, canMutate);
        });
      }).then(function (cart) {
        current = cart;
        if (noOp) return cart;
        var parent = pdpParent(cart, request);
        if (!canMutate() || protectedCartIssue(cart, protection)) throw new Error('Your existing bag contents could not be confirmed.');
        pendingReductionProtection = null;
        if (!selectedId || carrierQuantityForParent(cart, parent) === parentQuantity(cart, parent)) return cart;
        var selected = carrierOptions(cart, parent.variant_id).find(function (option) { return option.id === selectedId; });
        if (!selected || !selected.available) {
          warning = 'The fitting became unavailable. Your lampshade remains in your bag without a carrier.';
          return cart;
        }
        var amount = parentQuantity(cart, parent);
        var before = commerceSnapshot(cart);
        token = BUILD + '-pdp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        var data = { quantity: amount, carrierVariantId: selectedId, parentVariantId: parent.variant_id,
          parentLineKey: parent.key, parentTitle: parent.product_title || parent.title || 'Lampshade',
          parentVariantTitle: parent.variant_title || '', parentGroup: JSON.stringify(cartGroups().selectionDescriptor(parent)),
          parentSelectionKey: parent._mekhann_parent_selection_key };
        var addError = null;
        var sent = false;
        var sections = cartSections();
        var snapshotEligible = ownedNewPurchase && sections && typeof sections.fromAdd === 'function' &&
          typeof sections.priorToken === 'function';
        function canUseSnapshot() {
          return Boolean(snapshotEligible && canMutate() && ownedCurrent(ownerToken) && ownerToken.settling &&
            !ownerToken.parentRecovery && !restoredPdpPending && !ownedParentUncertain && !ownedQuantityUncertain &&
            !pdpRecoveryFault && !addError && pendingAddAcknowledged && pendingAddToken === token &&
            pendingPdpRecord && pendingPdpRecord.token === token);
        }
        return cartGroups().run(function () {
          if (!canMutate()) throw new Error('Your bag changed before the fitting could be added.');
          // Own the queue before recording a possibly sent POST. A superseded
          // queued callback is known not sent and must not leave an unknown token.
          persistPendingPdpAdd(cart, parent, token, amount, before, snapshotEligible, selectedId);
          pendingAddToken = token;
          pendingAddQuantity = amount;
          pendingAddProtection = before;
          pendingAddAcknowledged = false;
          pendingAddRollback = false;
          pendingPdpUncertain = true;
          sent = true;
          return requestJson(route('cartAdd', 'cart/add.js'), {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(buildAddPayload(data, token))
          }, 'context');
        }).then(function (response) { pendingAddAcknowledged = true; return response; }, function (error) {
          if (!sent) {
            if (pendingAddToken === token) clearPendingAdd();
            throw error;
          }
          addError = error;
        })
          .then(function (response) {
            var snapshot = canUseSnapshot() ? sections.fromAdd(response, cart, canUseSnapshot) : null;
            if (!snapshot) return getCart(false, response);
            return attachCarrierMappings(snapshot, false).then(observeCarrierPreferences).then(function (confirmed) {
              if (!canMutate()) throw new Error('Your bag changed while the fitting was being checked.');
              return checkPendingPdpCart(confirmed);
            });
          })
          .then(function (fresh) { current = fresh; return confirmAddedLine(fresh, token, amount, before); })
          .then(function (confirmation) {
            current = confirmation.cart;
            if (!canMutate()) throw new Error('Your bag changed while the fitting was being checked.');
            if (!confirmation.issue && confirmation.line) { pendingPdpUncertain = false; return confirmation.cart; }
            var definitiveRejection = addError && !addError.mekhannMutationUnknown && [400, 404, 422].indexOf(addError.httpStatus) !== -1;
            if (!confirmation.line && !definitiveRejection) {
              // Absence in a GET cannot disprove a late timed-out POST. Keep
              // the token and checkout lock until its outcome is known.
              pendingAddRollback = true;
              pendingPdpUncertain = true;
              throw new Error('The fitting request could not be confirmed. Your lampshade is in the bag. Refresh your bag before trying again.');
            }
            pendingPdpUncertain = false;
            pendingAddRollback = true;
            return cartGroups().run(function () { return rollbackAddedToken(confirmation.cart, token, canMutate); })
              .then(function (restored) { return confirmProtectedRestoration(restored, before); })
              .then(function (restored) {
                current = restored;
                clearPendingAdd();
                warning = 'The fitting could not be added as complimentary. Your lampshade remains in your bag without a carrier.';
                return restored;
              });
          });
      }).then(function (cart) {
        current = cart;
        if (noOp) return cart;
        var parent = pdpParent(cart, request);
        if (!canMutate() || protectedCartIssue(cart, protection)) throw new Error('Your bag changed before the fitting could be confirmed.');
        var children = linkedCarriers(cart, parent);
        var complete = selectedId && children.length && children.every(function (child) {
          return numericId(child.variant_id) === selectedId && !getPilotLineIssue(cart, child);
        }) && carrierQuantityForParent(cart, parent) === parentQuantity(cart, parent);
        if (selectedId && !complete && !warning) throw new Error('Your fitting selection is still being checked. Please refresh your bag.');
        return saveCarrierPreference(cart, parent, complete ? 'follow' : 0, false, canMutate, selectedId);
      }).then(function (cart) {
        current = cart;
        // Follow returns a real Ajax cart. A carried prior token must never
        // stand in for that final identity proof, including read fallbacks.
        if (pendingPdpRecord && pendingPdpRecord.tokenSource === 'prior-ajax-token' &&
            (priorCartToken(cart) || !cart || typeof cart.token !== 'string' || !cart.token)) {
          throw new Error('Your fitting confirmation still needs a current shopping bag check.');
        }
        checkPendingPdpCart(cart);
        if (pendingPdpRecord && pendingPdpRecord.tokenSource === 'prior-ajax-token') {
          var confirmedLines = findPilotLinesByToken(cart, pendingPdpRecord.token);
          var confirmedQuantity = confirmedLines.reduce(function (sum, line) { return sum + Number(line.quantity); }, 0);
          if (pendingAddToken !== pendingPdpRecord.token || pendingAddQuantity !== pendingPdpRecord.quantity ||
              selectedId !== pendingPdpRecord.requestedCarrierVariantId ||
              confirmedQuantity !== pendingAddQuantity || !confirmedLines.length || confirmedLines.some(function (line) {
                var parent = resolveParent(cart, line);
                return numericId(line.variant_id) !== selectedId || getPilotLineIssue(cart, line) || !parent ||
                  !cartGroups().sameSelection(parent, pendingPdpRecord.parent);
              })) {
            // Follow may have committed even though its final cart no longer
            // contains the complete batch. Disable this group's Follow before
            // ordinary token cleanup can run, or recovery would add it again.
            return requirePendingPdpOff(cart, canMutate).then(function (confirmed) {
              current = confirmed;
              throw new Error('The complete shade carrier addition could not be confirmed. Please check your shopping bag.');
            });
          }
        }
        if (!canMutate() || protectedCartIssue(cart, protection) || findInvalidPilotLine(cart)) {
          throw new Error('Your fitting could not be confirmed safely. Please check your bag.');
        }
        clearPendingAdd();
        pendingReductionProtection = null;
        unverifiedMutation = false;
        pilotLinePresent = cart.items.some(isKnownPilotLine);
        releaseServerVerificationLocks();
        clearCarrierFailure();
        if (noOp && !ownerToken && previousRenderCurrent && lastRenderReceipt === previousReceipt && activeRender === previousRender &&
            (!cartExtras || previousReceipt.extrasRevision === cartExtras.revision()) && !extrasPending && !extrasError &&
            previousRender.fingerprint === renderCartFingerprint(cart, previousRender.fields)) {
          // No write occurred and the fresh server cart exactly matches the
          // still-current rendered snapshot. Carry that proof to this new
          // request generation without replacing identical markup.
          activeRender = { stamp: generationStamp(), cartToken: cart.token, fields: previousRender.fields,
            fingerprint: previousRender.fingerprint, products: previousRender.products };
          lastRenderReceipt = { stamp: generationStamp(), extrasRevision: cartExtras ? cartExtras.revision() : 0 };
          return { cart: cart, unchanged: true, renderReceipt: lastRenderReceipt };
        }
        return requireCartRefresh(cart).then(function (confirmed) {
          return { cart: confirmed, warning: warning || undefined, unchanged: noOp || undefined, renderReceipt: lastRenderReceipt };
        });
      }).catch(function (error) {
        if (changed) unverifiedMutation = true;
        // Existing preferences were set Off, or this new group was unconfigured.
        // Keep uncertain tokens/protected snapshots so recovery can remove ONLY
        // the new fitting batch and never discard an unrelated selection.
        if (pendingAddToken && token === pendingAddToken) pendingAddRollback = true;
        throw error;
      }).finally(function () {
        addInFlight = false;
        if (addOperation === task) addOperation = null;
        resumeDeferredReconcile();
        syncCheckoutGuards();
        // Cart HTML was rendered while this request still owned the busy lock.
        // Recompute controls on the replacement nodes after releasing it.
        revealOffers();
      });
      addOperation = task;
      return task;
    });
    pdpOperation = operation;
    return operation.finally(function () { if (pdpOperation === operation) pdpOperation = null; });
  }

  function cartStructureNode(node) {
    if (!node || node.nodeType !== 1) return false;
    var selector = '.cart__items, [data-mekhann-cart-group], [data-mekhann-carrier-line]';
    return Boolean((node.matches && node.matches(selector)) || (node.querySelector && node.querySelector(selector)));
  }

  var mountedDrawer = null;
  var checkoutForms = [];

  function mountCartSurfaces() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    var forms = Array.prototype.slice.call(document.querySelectorAll(FORM_SELECTOR));
    var changed = mountedDrawer !== drawer || forms.length !== checkoutForms.length ||
      forms.some(function (form) { return checkoutForms.indexOf(form) === -1; });
    if (!changed) return false;
    retireDetachedCheckout();
    checkoutForms.forEach(function (form) {
      if (forms.indexOf(form) === -1) form.removeEventListener('submit', onCheckout, true);
    });
    cartObservers = cartObservers.filter(function (entry) {
      if (entry.products.isConnected) return true;
      entry.observer.disconnect();
      return false;
    });
    if (mountedDrawer && mountedDrawer !== drawer && typeof mountedDrawer.__mekhannCalmDrawer === 'function') {
      mountedDrawer.__mekhannCalmDrawer();
    }
    mountedDrawer = drawer;
    seedClientVerificationLocks();
    initCalmDrawer(drawer);
    initCartExtras();
    if (drawer) {
      var newDrawer = drawer.dataset.mekhannCarrierRuntime !== BUILD;
      drawer.dataset.mekhannCarrierRuntime = BUILD;
      if (newDrawer && drawer.dataset.mekhannCartHasPilot === 'true') markPilotSignal();
      var products = drawer.querySelector('[data-products]');
      if (products && window.MutationObserver && !cartObservers.some(function (entry) { return entry.products === products; })) {
        var handleStructure = function (records) {
          // Local feedback text, select options and fitting-help disclosure do
          // not change Shopify's cart. Only structural line replacement needs
          // another fresh proof. Watching every subtree write otherwise turns
          // our own busy/status rendering into redundant verification cycles.
          var structural = records.some(function (record) {
            return Array.prototype.some.call(record.addedNodes || [], cartStructureNode) ||
              Array.prototype.some.call(record.removedNodes || [], cartStructureNode);
          });
          if (!structural) return;
          if (products.querySelector(PILOT_LINE_SELECTOR)) markPilotSignal();
          else cartSignalGeneration += 1;
          if (ownedMutation) ownedMutation.invalid = true;
          revealOffers();
          syncCheckoutGuards();
          scheduleReconcile(true);
        };
        var observer = new MutationObserver(handleStructure);
        observer.observe(products, { childList: true, subtree: true });
        cartObservers.push({ products: products, observer: observer, handle: handleStructure });
      }
    }
    forms.forEach(function (form) {
      if (checkoutForms.indexOf(form) === -1) form.addEventListener('submit', onCheckout, true);
    });
    checkoutForms = forms;
    return changed;
  }

  function init() {
    if (!isPilotEnvironment()) {
      document.querySelectorAll(FORM_SELECTOR).forEach(function (form) { form.classList.remove(GUARD_CLASS); });
      return;
    }
    loadOfferPreferences();
    mountCartSurfaces();
    if (document.querySelector(PILOT_LINE_SELECTOR)) markPilotSignal();
    document.addEventListener('mekhann:cart:mounted', function () {
      if (!mountCartSurfaces()) return;
      // A newly mounted drawer is a new render surface. Cancel stale work and
      // establish current cart evidence before it can be used for checkout.
      cartSignalGeneration += 1;
      lastRenderReceipt = null;
      if (ownedMutation) ownedMutation.invalid = true;
      revealOffers();
      syncCheckoutGuards();
      scheduleReconcile(true);
    });

    document.addEventListener('cart:mutation:start', onExternalQuantityChange);
    document.addEventListener('cart:mutation:complete', onExternalMutationComplete);
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('click', guardParentRemoveClick, true);
    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-mekhann-carrier-quantity]')) return;
      var offer = event.target.closest(OFFER_SELECTOR);
      if (offer && !addInFlight) syncOfferChoice(offer, true);
    });
    document.addEventListener('cart:build', function (event) {
      var detail = event.detail || {};
      // This exact generation was just checked before requesting its render.
      // The structural observer still verifies the returned replacement; do
      // not start a second read while that HTML request is still in flight.
      if (detail.source === BUILD && detail.carrierGeneration === cartMutationGeneration &&
          detail.carrierSignal === cartSignalGeneration &&
          detail.carrierExternalGeneration === externalMutationGeneration && !externalMutationPending) return;
      cartSignalGeneration += 1;
      if (ownedMutation) ownedMutation.invalid = true;
      scheduleReconcile(false);
    });
    document.addEventListener('cart:updated', onCartUpdated);
    document.addEventListener('cart:rendered', function (event) {
      acceptRenderedProof(event.detail);
      revealOffers();
      syncCheckoutGuards();
      restoreInlineFocus();
    });
    document.addEventListener('ajaxProduct:added', function (event) {
      if (receiptCurrent(event.detail && event.detail.renderReceipt)) { revealOffers(); return; }
      window.setTimeout(function () {
        revealOffers();
        scheduleReconcile(true);
      }, 80);
    });

    revealOffers();
    syncCheckoutGuards();
    scheduleReconcile(true);
  }

  // Restore before exposing the API or scheduling any checkout reconciliation.
  restorePendingPdpAdd();
  restoreNativeBatch();
  restoreRemovalJournal();

  window.MekhannCarrierPilotV2193 = {
    build: BUILD,
    technicalRevision: 'V2.34-QTY1-2026-09-20',
    performanceRevision: 'V2.34-HAR1-2026-09-19',
    recoveryRevision: 'V2.34-RECOVERY1-2026-09-19',
    addPerformanceRevision: 'V2.35-ADD1-2026-09-22',
    pilotMarker: PILOT_MARKER,
    pdpReadCart: pdpReadCart,
    pdpSetFitting: pdpSetFitting,
    prepareNativeBatch: prepareNativeBatch,
    prepareScopedNativeBatch: prepareScopedNativeBatch,
    markNativeBatchSent: markNativeBatchSent,
    recoverNativeAttempt: recoverNativeAttempt,
    checkNativeBatch: checkNativeBatch,
    nativeBatchAbandonedTokens: function () { return nativeAbandonedTokens.slice(); },
    nativeBatchResolvedTokens: function () { return nativeResolvedTokens.slice(); },
    acknowledgeNativeBatch: acknowledgeNativeBatch,
    abandonUnsentNativeBatch: abandonUnsentNativeBatch,
    rejectNativeBatch: rejectNativeBatch,
    beginOwnedMutation: beginOwnedMutation,
    isOwnedMutationCurrent: ownedCurrent,
    canQueueRemoveAfterExtras: canQueueRemoveAfterExtras,
    canQueueQuantityAfterExtras: canQueueQuantityAfterExtras,
    assertQueuedRemove: assertQueuedRemove,
    cancelQueuedRemove: cancelQueuedRemove,
    settleOwnedMutation: settleOwnedMutation,
    tryPlusOwnedSelection: tryPlusOwnedSelection,
    tryMinusOwnedSelection: tryMinusOwnedSelection,
    removeOwnedSelection: removeOwnedSelection,
    abortOwnedMutation: abortOwnedMutation,
    isRenderReceiptCurrent: receiptCurrent,
    presentStatus: presentStatus,
    canCommitRender: canCommitRender,
    carrierOptions: carrierOptions,
    linkedCarriers: linkedCarriers,
    selectedCarrierVariantId: selectedCarrierVariantId,
    mappingMetafield: 'custom.complimentary_carrier',
    preferenceAttribute: CARRIER_PREFERENCE_ATTRIBUTE,
    carrierPreference: carrierPreference,
    desiredCarrierQuantity: desiredCarrierQuantity,
    mappedCarrier: mappedCarrier,
    parentQuantity: parentQuantity,
    carrierQuantityForParent: carrierQuantityForParent,
    allowedCarrierQuantity: allowedCarrierQuantity,
    discountTitle: DISCOUNT_TITLE,
    buildAddPayload: buildAddPayload,
    discountFailureReason: discountFailureReason,
    failureSnapshot: failureSnapshot,
    findInvalidPilotLine: findInvalidPilotLine,
    findPilotLineByToken: findPilotLineByToken,
    findPilotLinesByToken: findPilotLinesByToken,
    getPilotLineIssue: getPilotLineIssue,
    hasAnyCarrierVariant: hasAnyCarrierVariant,
    isComplimentaryLine: isComplimentaryLine,
    isCurrentPilotLine: isCurrentPilotLine,
    isKnownPilotLine: isKnownPilotLine,
    isPilotEnvironment: isPilotEnvironment,
    isBusy: function () {
      return Boolean(nativeBatchRecord || nativeBatchFault || ownedMutation || pendingRemoveIntent || addInFlight || removeOperation || reconcileInFlight || checkoutInFlight || extrasPending ||
        unverifiedMutation || externalMutationPending || externalVerificationInFlight);
    }
  };

  try { document.documentElement.setAttribute('data-mekhann-native-recovery-build', 'V2.35-FIX3-2026-09-22'); } catch (ignore) {}
  publishNativeDiagnostic();
  document.dispatchEvent(new CustomEvent('mekhann:carrier:ready'));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
